window.products = [
  {
    "sku": "MRC100RMD",
    "title": "100mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC100RMD.webp?v=1790160744"
  },
  {
    "sku": "MRC100RHD",
    "title": "100mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC100RHD.webp?v=1790161139"
  },
  {
    "sku": "MRCAB76",
    "title": "108mm Grey Conduit Fittings Adaptable box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCA_DATASHEET_-_Adaptable_Box.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCAB76.webp?v=1792121800"
  },
  {
    "sku": "MRC125RHD",
    "title": "125mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC125RHD.webp?v=1790161172"
  },
  {
    "sku": "MRC150RHD",
    "title": "150mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC150RHD.webp?v=1790161203"
  },
  {
    "sku": "MA14-W-SN",
    "title": "16cm Bell Shaped Alabaster Glass DIY Batten Fix",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/16cm-Bell-Shaped-Alabaster-Glass-DIY-Ceiling-Fixture-Mercator-9079_45f190f6-7280-4692-ace3-109815a531ca.jpg?v=1778648175"
  },
  {
    "sku": "MRC200RHD",
    "title": "200mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC200RHD.webp?v=1790161233"
  },
  {
    "sku": "MRC20FSD",
    "title": "20mm Full Saddle Zinc-plated Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSD_DATASHEET_-_Conduit_Full_Saddle_ZP.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FSD.webp?v=1791865698"
  },
  {
    "sku": "MRC20F1WLJG",
    "title": "20mm Grey 1-Way Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF1WLJG_DATASHEET_-_Conduit_Junction_Box_1_Way.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20F1WLJG.webp?v=1791883951"
  },
  {
    "sku": "MRC20F2WLJG",
    "title": "20mm Grey 2-Way Left-Angle Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF2WLJG_DATASHEET_-_Conduit_Junction_Box_2_Way_Through.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20F2WLJG.webp?v=1792123541"
  },
  {
    "sku": "MRC20F2WRJG",
    "title": "20mm Grey 2-Way Right-Angle Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF2WRJG_DATASHEET_-_Conduit_Junction_Box_2_Way_Right_Angle.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20F2WRJG.webp?v=1792123570"
  },
  {
    "sku": "MRC20F2WUJG",
    "title": "20mm Grey 2-Way U-Type Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF2WUJG_DATASHEET_-_Conduit_Junction_Box_2_Way_U-type.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20F2WUJG_f6340591-4863-4a3f-b615-656ef1fee1c6.webp?v=1792123528"
  },
  {
    "sku": "MRC20F3WRJG",
    "title": "20mm Grey 3-Way Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF3WRJG_DATASHEET_-_Conduit_Junction_Box_3_Way.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20F3WRJG.webp?v=1792123384"
  },
  {
    "sku": "MRC20F4WRJG",
    "title": "20mm Grey 4-Way Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF4WRJG_DATASHEET_-_Conduit_Junction_Box_4_Way.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20F4WRJG.webp?v=1791884123"
  },
  {
    "sku": "MRC20FAWR",
    "title": "20mm Grey Conduit Adaptor with Lock Ring",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFAWR_DATASHEET_-_Adaptor_w_Lock_Ring.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FAWR.webp?v=1791882370"
  },
  {
    "sku": "MRC20FP2",
    "title": "20mm Grey Conduit Plug",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFP_DATASHEET_-_Conduit_Plug.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FP2.webp?v=1791865379"
  },
  {
    "sku": "MRC20FCLP",
    "title": "20mm Grey Conduit PVC Mounting Clip",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCLP_DATASHEET_-_Conduit_PVC_Mounting_Clip.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FCLP.webp?v=1791884224"
  },
  {
    "sku": "MRC20FGGD",
    "title": "20mm Grey Corrugated Gland Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFGGD_DATASHEET_-_Corrugated_Gland.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FGGD.webp?v=1791883482"
  },
  {
    "sku": "MRC20FCPG",
    "title": "20mm Grey Coupling Plain/Plain Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCP_DATASHEET_-_Coupling_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FCPG.webp?v=1791883124"
  },
  {
    "sku": "MRC20FPTS",
    "title": "20mm Grey Coupling Plain/Screw Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFPTS_DATASHEET_-_Coupling_Plain_to_Screw.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FPTS.webp?v=1791883261"
  },
  {
    "sku": "MRC20FELG",
    "title": "20mm Grey Elbow Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFEL_DATASHEET_-_Conduit_Elbow_Bend.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FELG.webp?v=1791882908"
  },
  {
    "sku": "MRC20FIELG",
    "title": "20mm Grey Inspection Elbow  90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFIELG_DATASHEET_-_Conduit_Inspection_Elbow.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FIELG.webp?v=1791883629"
  },
  {
    "sku": "MRC20FITG",
    "title": "20mm Grey Inspection Tee  90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFITG_DATASHEET_-_Conduit_Inspection_Tee.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FITG.webp?v=1791797254"
  },
  {
    "sku": "MRC20FSDP",
    "title": "20mm Grey Mounting Saddle",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSDP_DATASHEET_-_Conduit_PVC_Saddle.pdf?v=1792123886",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FSDP.webp?v=1791865585"
  },
  {
    "sku": "MRC20FFCG",
    "title": "20mm Grey Plain to Plain Flexible Coupling Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFFC_DATASHEET_-_Coupling_Flexible_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FFCG.webp?v=1791883360"
  },
  {
    "sku": "MRC20FDBG",
    "title": "20mm Grey Standard Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFDB_DATASHEET_-_Conduit_Standard_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FDBG.webp?v=1791882952"
  },
  {
    "sku": "MRC20FSBO",
    "title": "20mm Grey Sweep Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSB_DATASHEET_-_Conduit_Sweep_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FSBO.webp?v=1791797562"
  },
  {
    "sku": "MRC20FSDH",
    "title": "20mm Half Saddle Zinc-plated Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSDH_DATASHEET_-_Conduit_Half_Saddle_ZP.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FSDH.webp?v=1791865834"
  },
  {
    "sku": "MRC2016FRD",
    "title": "20mm to 16mm Grey Plain Reducer",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFRD_DATASHEET_-_Conduit_Reducer_Plain_to_Plain.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC2016FRD.webp?v=1791797713"
  },
  {
    "sku": "MRC20FCBW",
    "title": "20mm White Communication Sweep Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCBW_DATASHEET_-_Conduit_Communication_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20FCBW.webp?v=1791882869"
  },
  {
    "sku": "MRC20GMD20",
    "title": "20mm x 20m Grey Corrugated Medium Duty Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGMD_DATASHEET_-_Corrugated_Conduit_Medium_Duty.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20GMD20.webp?v=1790154357"
  },
  {
    "sku": "MRC20GMDW20",
    "title": "20mm x 20m Grey Medium Duty Corrugated with Metal Wire Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGMD_DATASHEET_-_Corrugated_Conduit_Medium_Duty.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20GMDW20.webp?v=1790154490"
  },
  {
    "sku": "MRC20GHD20",
    "title": "20mm x 20m Orange Heavy Duty Corrugated Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGHD_DATASHEET_-_Corrugated_Conduit_Heavy_Duty.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20GHD20_50ca344c-bb22-4008-84ed-2c496ecc4110.webp?v=1790154589"
  },
  {
    "sku": "MRC20COM",
    "title": "20mm x 4.5m White Rigid PVC Communication Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCCOM_DATASHEET_-_Rigid_Communication_PVC_Conduit.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20COM.webp?v=1790154032"
  },
  {
    "sku": "MRC20RMD",
    "title": "20mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20RMD.webp?v=1790160291"
  },
  {
    "sku": "MRC20RHD",
    "title": "20mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC20RHD.webp?v=1790161651"
  },
  {
    "sku": "MRCAB81",
    "title": "211mm Grey Conduit Fittings Adaptable box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCA_DATASHEET_-_Adaptable_Box.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCAB81.webp?v=1792121658"
  },
  {
    "sku": "MA15-W-AB",
    "title": "22cm Alabaster Glass DIY Batten Fix",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MicrosoftTeams-image_41_38b21c4a-28e3-41fd-90bb-1af44ad7c948.jpg?v=1778648178"
  },
  {
    "sku": "MPC728",
    "title": "24 hour analog timer",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPC728_decf025c-97d5-45ae-b854-cd44481ee98c.jpg?v=1778648181"
  },
  {
    "sku": "MRC25FSD",
    "title": "25mm Full Saddle Zinc-plated Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSD_DATASHEET_-_Conduit_Full_Saddle_ZP.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FSD.webp?v=1791865757"
  },
  {
    "sku": "MRC25F1WLJG",
    "title": "25mm Grey 1-Way Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF1WLJG_DATASHEET_-_Conduit_Junction_Box_1_Way.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25F1WLJG.webp?v=1791883984"
  },
  {
    "sku": "MRC25F2WLJG",
    "title": "25mm Grey 2-Way Left-Angle Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF2WLJG_DATASHEET_-_Conduit_Junction_Box_2_Way_Through.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25F2WLJG.webp?v=1791884015"
  },
  {
    "sku": "MRC25F2WRJG",
    "title": "25mm Grey 2-Way Right-Angle Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF2WRJG_DATASHEET_-_Conduit_Junction_Box_2_Way_Right_Angle.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25F2WRJG.webp?v=1792123556"
  },
  {
    "sku": "MRC25F2WUJG",
    "title": "25mm Grey 2-Way U-Type Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF2WUJG_DATASHEET_-_Conduit_Junction_Box_2_Way_U-type.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25F2WUJG.webp?v=1792123429"
  },
  {
    "sku": "MRC25F3WRJG",
    "title": "25mm Grey 3-Way Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF3WRJG_DATASHEET_-_Conduit_Junction_Box_3_Way.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25F3WRJG.webp?v=1792123362"
  },
  {
    "sku": "MRC25F4WRJG",
    "title": "25mm Grey 4-Way Conduit Junction Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCF4WRJG_DATASHEET_-_Conduit_Junction_Box_4_Way.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25F4WRJG.webp?v=1791884163"
  },
  {
    "sku": "MRC25FAWR",
    "title": "25mm Grey Conduit Adaptor with Lock Ring",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFAWR_DATASHEET_-_Adaptor_w_Lock_Ring.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FAWR.webp?v=1791882750"
  },
  {
    "sku": "MRC25FP2",
    "title": "25mm Grey Conduit Plug",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFP_DATASHEET_-_Conduit_Plug.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FP2.webp?v=1791865484"
  },
  {
    "sku": "MRC25FCLP",
    "title": "25mm Grey Conduit PVC Mounting Clip",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCLP_DATASHEET_-_Conduit_PVC_Mounting_Clip.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FCLP.webp?v=1792122078"
  },
  {
    "sku": "MRC25FGGD",
    "title": "25mm Grey Corrugated Gland Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFGGD_DATASHEET_-_Corrugated_Gland.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FGGD.webp?v=1791883518"
  },
  {
    "sku": "MRC25FCPG",
    "title": "25mm Grey Coupling Plain/Plain Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCP_DATASHEET_-_Coupling_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FCPG.webp?v=1791883148"
  },
  {
    "sku": "MRC25FPTS",
    "title": "25mm Grey Coupling Plain/Screw Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFPTS_DATASHEET_-_Coupling_Plain_to_Screw.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FPTS.webp?v=1791883287"
  },
  {
    "sku": "MRC25FIELG",
    "title": "25mm Grey Inspection Elbow  90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFIELG_DATASHEET_-_Conduit_Inspection_Elbow.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FIELG.webp?v=1791883877"
  },
  {
    "sku": "MRC25FITG",
    "title": "25mm Grey Inspection Tee  90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFITG_DATASHEET_-_Conduit_Inspection_Tee.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FITG.webp?v=1791797481"
  },
  {
    "sku": "MRC25FSDP",
    "title": "25mm Grey Mounting Saddle",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSDP_DATASHEET_-_Conduit_PVC_Saddle.pdf?v=1792123886",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FSDP.webp?v=1791865617"
  },
  {
    "sku": "MRC25FFCG",
    "title": "25mm Grey Plain to Plain Flexible Coupling Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFFC_DATASHEET_-_Coupling_Flexible_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FFCG.webp?v=1791883407"
  },
  {
    "sku": "MRC25FDBG",
    "title": "25mm Grey Standard Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFDB_DATASHEET_-_Conduit_Standard_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FDBG.webp?v=1791882980"
  },
  {
    "sku": "MRC25FSBO",
    "title": "25mm Grey Sweep Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSB_DATASHEET_-_Conduit_Sweep_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FSBO.webp?v=1791797616"
  },
  {
    "sku": "MRC25FSDH",
    "title": "25mm Half Saddle Zinc-plated Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSDH_DATASHEET_-_Conduit_Half_Saddle_ZP.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25FSDH.webp?v=1791865872"
  },
  {
    "sku": "MRC2520FTRD",
    "title": "25mm to 20mm Grey Conduit Reducer Threaded to Threaded",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFTRD_DATASHEET_-_Conduit_Reducer_Threaded_to_Threaded.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC2520FTRD.webp?v=1791865526"
  },
  {
    "sku": "MRC2520FRD2",
    "title": "25mm to 20mm Grey Plain Reducer",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFRD_DATASHEET_-_Conduit_Reducer_Plain_to_Plain.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC2520FRD2.webp?v=1791797738"
  },
  {
    "sku": "MRC25GMD20",
    "title": "25mm x 20m Grey Corrugated Medium Duty Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGMD_DATASHEET_-_Corrugated_Conduit_Medium_Duty.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25GMD20.webp?v=1790154390"
  },
  {
    "sku": "MRC25GMDW20",
    "title": "25mm x 20m Grey Medium Duty Corrugated with Metal Wire Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGMD_DATASHEET_-_Corrugated_Conduit_Medium_Duty.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25GMDW20.webp?v=1790154524"
  },
  {
    "sku": "MRC25GHD20",
    "title": "25mm x 20m Orange Heavy Duty Corrugated Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGHD_DATASHEET_-_Corrugated_Conduit_Heavy_Duty.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25GHD20.webp?v=1790154614"
  },
  {
    "sku": "MRC25GSHD25",
    "title": "25mm x 25m Grey Heavy Duty Solar Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGSHD_DATASHEET_-_Corrugated_Conduit_Solar_Heavy_Duty.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25GSHD25.webp?v=1790154705"
  },
  {
    "sku": "MRC25RSHD",
    "title": "25mm x 4m Grey Heavy Duty Rigid PVC Solar Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRSHD_DATASHEET_-_Rigid_Solar_PVC_Conduit.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25RSHD.webp?v=1790154326"
  },
  {
    "sku": "MRC25RMD",
    "title": "25mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25RMD.webp?v=1790160456"
  },
  {
    "sku": "MRC25RHD",
    "title": "25mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC25RHD.webp?v=1790160848"
  },
  {
    "sku": "LR275E7GDR",
    "title": "275W Heat Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/LR275E7GDR.png?v=1786598137"
  },
  {
    "sku": "MUC160",
    "title": "2M ALUMINIUM CORNER STRIP",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "MRC32FSD",
    "title": "32mm Full Saddle Zinc-plated Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSD_DATASHEET_-_Conduit_Full_Saddle_ZP.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FSD.webp?v=1791865793"
  },
  {
    "sku": "MRC32FAWR",
    "title": "32mm Grey Conduit Adaptor with Lock Ring",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFAWR_DATASHEET_-_Adaptor_w_Lock_Ring.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FAWR.webp?v=1791882799"
  },
  {
    "sku": "MRC32FCLP",
    "title": "32mm Grey Conduit PVC Mounting Clip",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCLP_DATASHEET_-_Conduit_PVC_Mounting_Clip.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FCLP.webp?v=1792121927"
  },
  {
    "sku": "MRC32FGGD",
    "title": "32mm Grey Corrugated Gland Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFGGD_DATASHEET_-_Corrugated_Gland.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FGGD.webp?v=1791883545"
  },
  {
    "sku": "MRC32FCPG",
    "title": "32mm Grey Coupling Plain/Plain Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCP_DATASHEET_-_Coupling_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FCPG.webp?v=1791883194"
  },
  {
    "sku": "MRC32FPTS",
    "title": "32mm Grey Coupling Plain/Screw Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFPTS_DATASHEET_-_Coupling_Plain_to_Screw.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FPTS.webp?v=1791883330"
  },
  {
    "sku": "MRC32FIELG",
    "title": "32mm Grey Inspection Elbow  90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFIELG_DATASHEET_-_Conduit_Inspection_Elbow.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FIELG.webp?v=1791883919"
  },
  {
    "sku": "MRC32FITG",
    "title": "32mm Grey Inspection Tee  90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFITG_DATASHEET_-_Conduit_Inspection_Tee.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FITG.webp?v=1791797518"
  },
  {
    "sku": "MRC32FSDP",
    "title": "32mm Grey Mounting Saddle",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSDP_DATASHEET_-_Conduit_PVC_Saddle.pdf?v=1792123886",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FSDP.webp?v=1791865654"
  },
  {
    "sku": "MRC32FFCG",
    "title": "32mm Grey Plain to Plain Flexible Coupling Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFFC_DATASHEET_-_Coupling_Flexible_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FFCG.webp?v=1791883447"
  },
  {
    "sku": "MRC32FDBG",
    "title": "32mm Grey Standard Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFDB_DATASHEET_-_Conduit_Standard_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FDBG.webp?v=1791883020"
  },
  {
    "sku": "MRC32FSBO",
    "title": "32mm Grey Sweep Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSB_DATASHEET_-_Conduit_Sweep_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FSBO.webp?v=1791797655"
  },
  {
    "sku": "MRC32FSDH",
    "title": "32mm Half Saddle Zinc-plated Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSDH_DATASHEET_-_Conduit_Half_Saddle_ZP.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32FSDH.webp?v=1791865901"
  },
  {
    "sku": "MRC3225FTRD",
    "title": "32mm to 25mm Grey Conduit Reducer Threaded to Threaded",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFTRD_DATASHEET_-_Conduit_Reducer_Threaded_to_Threaded.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC3225FTRD.webp?v=1791865551"
  },
  {
    "sku": "MRC3225FRD2",
    "title": "32mm to 25mm Grey Plain Reducer",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFRD_DATASHEET_-_Conduit_Reducer_Plain_to_Plain.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC3225FRD2.webp?v=1791797761"
  },
  {
    "sku": "MRC32GMD20",
    "title": "32mm x 20m Grey Corrugated Medium Duty Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGMD_DATASHEET_-_Corrugated_Conduit_Medium_Duty.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32GMD20.webp?v=1790154424"
  },
  {
    "sku": "MRC32GHD20",
    "title": "32mm x 20m Orange Heavy Duty Corrugated Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGHD_DATASHEET_-_Corrugated_Conduit_Heavy_Duty.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32GHD20.webp?v=1790154646"
  },
  {
    "sku": "MRC32GSHD25",
    "title": "32mm x 25m Grey Heavy Duty Solar Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGSHD_DATASHEET_-_Corrugated_Conduit_Solar_Heavy_Duty.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32GSHD25.webp?v=1790154740"
  },
  {
    "sku": "MRC32RMD",
    "title": "32mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32RMD.webp?v=1790160495"
  },
  {
    "sku": "MRC32RHD",
    "title": "32mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC32RHD.webp?v=1790160891"
  },
  {
    "sku": "MRC40FAWR",
    "title": "40mm Grey Conduit Adaptor with Lock Ring",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFAWR_DATASHEET_-_Adaptor_w_Lock_Ring.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40FAWR.webp?v=1791882831"
  },
  {
    "sku": "MRC40FGGD",
    "title": "40mm Grey Corrugated Gland Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFGGD_DATASHEET_-_Corrugated_Gland.pdf?v=1792123890",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40FGGD.webp?v=1791883588"
  },
  {
    "sku": "MRC40FCPG",
    "title": "40mm Grey Heavy Duty Coupling Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCP_DATASHEET_-_Coupling_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40FCPG.webp?v=1791883217"
  },
  {
    "sku": "MRC40FDBG",
    "title": "40mm Grey Standard Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFDB_DATASHEET_-_Conduit_Standard_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40FDBG.webp?v=1791883089"
  },
  {
    "sku": "MRC40FSBO",
    "title": "40mm Grey Sweep Bend 90 Conduit Fitting",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFSB_DATASHEET_-_Conduit_Sweep_Bend.pdf?v=1792123887",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40FSBO.webp?v=1791797681"
  },
  {
    "sku": "MRC40FCPO",
    "title": "40mm Orange Heavy Duty Coupling Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFCP_DATASHEET_-_Coupling_Plain_to_Plain.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40FCPO.webp?v=1791865326"
  },
  {
    "sku": "MRC4032FRD",
    "title": "40mm to 32mm Grey Plain Reducer",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCFRD_DATASHEET_-_Conduit_Reducer_Plain_to_Plain.pdf?v=1792123885",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC4032FRD.webp?v=1791797794"
  },
  {
    "sku": "MRC40GMD20",
    "title": "40mm x 20m Grey Corrugated Medium Duty Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/5_MRCGMD_DATASHEET_-_Corrugated_Conduit_Medium_Duty.pdf?v=1790156808",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40GMD20.webp?v=1790154455"
  },
  {
    "sku": "MRC40GHD20",
    "title": "40mm x 20m Orange Heavy Duty Corrugated Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCGHD_DATASHEET_-_Corrugated_Conduit_Heavy_Duty.pdf?v=1792123888",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40GHD20.webp?v=1790154674"
  },
  {
    "sku": "MRC40RMD",
    "title": "40mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40RMD.webp?v=1790160601"
  },
  {
    "sku": "MRC40RHD",
    "title": "40mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC40RHD.webp?v=1790160988"
  },
  {
    "sku": "MI8240",
    "title": "40W LED Ceiling Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/40W-LED-Ceiling-Batten-Mercator-1823_3616aa34-7177-4a6b-ab6f-519aa4f44e27.jpg?v=1778648191"
  },
  {
    "sku": "MRCCUT",
    "title": "42mm Conduit Cutter",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCCUT_DATASHEET_-_Conduit_Cutter_Tool_89b845d7-b827-440f-8534-1b7e2e209ff3.pdf?v=1792642169",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCCUT.webp?v=1791884199"
  },
  {
    "sku": "MRC50COM",
    "title": "50mm x 4.5m White Rigid PVC Communication Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCCOM_DATASHEET_-_Rigid_Communication_PVC_Conduit.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC50COM.webp?v=1790154279"
  },
  {
    "sku": "MRC50RMD",
    "title": "50mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC50RMD.webp?v=1790160642"
  },
  {
    "sku": "MRC50RHD",
    "title": "50mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC50RHD.webp?v=1790161032"
  },
  {
    "sku": "MRC63RMD",
    "title": "63mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC63RMD.webp?v=1790160678"
  },
  {
    "sku": "MRC63RHD",
    "title": "63mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC63RHD.webp?v=1790161064"
  },
  {
    "sku": "XBH1514",
    "title": "800W R7s Linear Heat Lamp for Domini/Domino Series",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ReferencePhoto_a8c6cd28-268c-42c1-9764-849ecdf6bb03.jpg?v=1778648199"
  },
  {
    "sku": "MRC80RMD",
    "title": "80mm x 4m Grey Medium Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRMD_DATASHEET_-_Medium.pdf?v=1792123909",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC80RMD.webp?v=1790160705"
  },
  {
    "sku": "MRC80RHD",
    "title": "80mm x 4m Orange Heavy Duty Rigid Conduit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRCRHD_DATA_SHEET_-_Heavy_Duty.pdf?v=1792123889",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRC80RHD.webp?v=1790161106"
  },
  {
    "sku": "MGL010WB-D",
    "title": "A60 3000K 6W B22 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-3000K-6W-B22-LED-Globe-Mercator-9114_5ff027f2-5a46-4f38-b514-787bc3bf58ed.jpg?v=1778648202"
  },
  {
    "sku": "MGL010WE-D",
    "title": "A60 3000K 6W E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-3000K-6W-E27-LED-Globe-Mercator-6626_9ed857c7-45ea-4fb8-b912-c4d0ad9010fa.jpg?v=1778648206"
  },
  {
    "sku": "MGL020WB-D",
    "title": "A60 3000K 9W B22 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-3000K-9W-B22-LED-Globe-Mercator-9037_3c475063-75b1-41b1-b19f-dcb12aa54250.jpg?v=1778648211"
  },
  {
    "sku": "MGL020WE-D",
    "title": "A60 3000K 9W E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-3000K-9W-E27-LED-Globe-Mercator-6278_754e668f-5038-42a0-8232-7c9385c444ba.jpg?v=1778648215"
  },
  {
    "sku": "MGL010DB-D",
    "title": "A60 5700K 6W B22 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-5700K-6W-B22-LED-Globe-Mercator-1188_8aa3e6d1-e055-4e89-a2dd-74882a988418.jpg?v=1778648218"
  },
  {
    "sku": "MGL010DE-D",
    "title": "A60 5700K 6W E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-5700K-6W-E27-LED-Globe-Mercator-9318_ed0ddecd-9584-4458-b1f1-dc43f5ee851c.jpg?v=1778648223"
  },
  {
    "sku": "MGL020DB-D",
    "title": "A60 5700K 9W B22 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-5700K-9W-B22-LED-Globe-Mercator-9475_29bb03c8-a3ec-4679-858d-e36ee45c8194.jpg?v=1778648226"
  },
  {
    "sku": "MGL020DE-D",
    "title": "A60 5700K 9W E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A60-5700K-9W-E27-LED-Globe-Mercator-1752_2c8c1892-7cc0-4f64-898f-7a704b36ef91.jpg?v=1778648230"
  },
  {
    "sku": "MGL030DB-D",
    "title": "A60 Day Light B22 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A70-5700K-B22-LED-Globe-Mercator-4270_0f1a1786-aba0-474f-ba25-17b456568b24.jpg?v=1778648233"
  },
  {
    "sku": "MGL030DE-D",
    "title": "A60 Day Light E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A70-5700K-E27-LED-Globe-Mercator-2984_bf1353a9-9fe1-4964-a962-5b67051c4095.jpg?v=1778648237"
  },
  {
    "sku": "MGL030WB-D",
    "title": "A60 Warm White B22 LED  Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A70-3000K-B22-LED-Globe-Mercator-340_c56d7beb-7b8b-484d-8f62-55aeafa6623d.jpg?v=1778648239"
  },
  {
    "sku": "MGL030WE-D",
    "title": "A60 Warm White E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A70-3000K-E27-LED-Globe-Mercator-6565_a5ee9ba6-a1f0-4e9e-bb97-089a8ccafd7a.jpg?v=1778648246"
  },
  {
    "sku": "MGL040WB-D",
    "title": "A80 3000K B22 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A80-3000K-B22-LED-Globe-Mercator-8543_5161a4d1-0dd3-409f-81ea-a377ae9dfbeb.jpg?v=1778648250"
  },
  {
    "sku": "MGL040WE-D",
    "title": "A80 3000K E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A80-3000K-E27-LED-Globe-Mercator-8791_77d8c447-28c4-4550-a579-958dc21301e4.jpg?v=1778648254"
  },
  {
    "sku": "MGL040DB-D",
    "title": "A80 5700K B22 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A80-5700K-B22-LED-Globe-Mercator-3836_24198906-c805-487f-b8c8-4b13edc06375.jpg?v=1778648257"
  },
  {
    "sku": "MGL040DE-D",
    "title": "A80 5700K E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A80-5700K-E27-LED-Globe-Mercator-1641_9bfd4255-2d21-4290-bb49-a51dcb12d150.jpg?v=1778648261"
  },
  {
    "sku": "MD4129WH-TRI",
    "title": "Aaydan 8W Tri-Colour Low Glare Recessed LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aaydan-8W-Tri-Colour-Low-Glare-Recessed-LED-Downlight-Mercator-3536_1c818c36-bfa0-4c18-861a-1ab5a57ef6f4.jpg?v=1778648264"
  },
  {
    "sku": "MD4119WH-TRI",
    "title": "Aaydan 8W Tri-Colour Recessed Lens Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aaydan-8W-Tri-Colour-Recessed-Lens-Downlight-Mercator-6887_ec8a17df-efa1-427a-bf6c-edc1568c2563.jpg?v=1778648267"
  },
  {
    "sku": "BE370ESPWH",
    "title": "Aceline Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aceline-Exhaust-Fan-with-LED-Light--Mercator-1406_3a7665c3-208f-48b6-bfa2-c9d64ad6d4ca.jpg?v=1778648271"
  },
  {
    "sku": "A29121WHT",
    "title": "Addison Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Addison-Floor-Lamp-Mercator-6430_6b53c406-4bc4-40d6-bff8-c3dc4b1979d6.jpg?v=1778648276"
  },
  {
    "sku": "A29111",
    "title": "Addison Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MicrosoftTeams-image_40_1e2da468-3a4b-48af-9410-126da5eb0aeb.jpg?v=1778648289"
  },
  {
    "sku": "A29111WHT",
    "title": "Addison Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MicrosoftTeams-image_40_1e2da468-3a4b-48af-9410-126da5eb0aeb.jpg?v=1778648289"
  },
  {
    "sku": "MPLS515WHT",
    "title": "Adena 1Lt Wire Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Adena-1Lt-Wire-Pendant-Light-Mercator-3598_e5d00a70-f1b2-4b4f-9a13-f5a6ca6bbdb3.jpg?v=1778648293"
  },
  {
    "sku": "MPLS515BLK",
    "title": "Adena 1Lt Wire Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Adena-1Lt-Wire-Pendant-Light-Mercator-3598_e5d00a70-f1b2-4b4f-9a13-f5a6ca6bbdb3.jpg?v=1778648293"
  },
  {
    "sku": "BE6200SPWH",
    "title": "Affinity 300 DC Exhaust Fan with Run on Timer (4 Pin Plug)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE6200SPWH_Hero_00927b2a-e51e-4276-b1b9-4537fb8cfa90.jpg?v=1778648297"
  },
  {
    "sku": "XBE620WH",
    "title": "Affinity Light Kit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/XBE620WH_48300eae-3714-42a1-9a6f-5652b009ca9a.jpg?v=1778648302"
  },
  {
    "sku": "MTBL012",
    "title": "Ainsley Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ainsley-Table-Lamp-Mercator-1950_ed40448d-ddf0-402a-91c2-3f8e01c9ffb3.jpg?v=1778648306"
  },
  {
    "sku": "FF62230BK",
    "title": "Airbond 75cm High Velocity Industrial DC Pedestal Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airbond-75cm-High-Velocity-Industrial-DC-Pedestal-Fan-Mercator-3466_94cf9f70-1cd7-4064-b1a4-59b2cbc166b9.jpg?v=1778648309"
  },
  {
    "sku": "FF62330BK",
    "title": "Airbond 75cm High Velocity Industrial DC Wall Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airbond-75cm-High-Velocity-Industrial-DC-Wall-Fan-Mercator-62_42b415fa-91d2-421e-9d46-2e349c11b825.jpg?v=1778648312"
  },
  {
    "sku": "FC770134WH",
    "title": "Airnimate 133cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airnimate-AC-Ceiling-Fan-Mercator-8673_9295345f-87d7-4341-86ce-cfefd428a8cd.jpg?v=1778648316"
  },
  {
    "sku": "FC770134WH",
    "title": "Airnimate 133cm AC Ceiling Fan (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airnimate-AC-Ceiling-Fan-Mercator-8673_3ec12aa2-0b07-4260-a352-21538f551aaf.jpg?v=1778648320"
  },
  {
    "sku": "FC770134BK",
    "title": "Airnimate 133cm AC Ceiling Fan (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airnimate-AC-Ceiling-Fan-Mercator-8673_3ec12aa2-0b07-4260-a352-21538f551aaf.jpg?v=1778648320"
  },
  {
    "sku": "FC777134WH",
    "title": "Airnimate 133cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airnimate-AC-Ceiling-Fan-with-LED-Light-Mercator-7692_0bae30f1-3209-42fb-ba1e-8449c0800486.jpg?v=1778648323"
  },
  {
    "sku": "FC777134BK",
    "title": "Airnimate 133cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airnimate-AC-Ceiling-Fan-with-LED-Light-Mercator-7692_0bae30f1-3209-42fb-ba1e-8449c0800486.jpg?v=1778648323"
  },
  {
    "sku": "FC777134WH",
    "title": "Airnimate 133cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airnimate-AC-Ceiling-Fan-with-LED-Light-Mercator-7692_0bae30f1-3209-42fb-ba1e-8449c0800486.jpg?v=1778648323"
  },
  {
    "sku": "FC587133BK",
    "title": "Airventure 133cm  AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airventure-AC-Ceiling-Fan-with-LED-Light-Mercator-7344_a5c27e68-f0ed-43ff-a2aa-f1e6354870c0.jpg?v=1778648328"
  },
  {
    "sku": "FC587133WH",
    "title": "Airventure 133cm  AC Ceiling Fan with LED Light (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airventure-AC-Ceiling-Fan-with-LED-Light-Mercator-973_d30ab0b6-9a2c-48e3-9759-a66a37ece79a.jpg?v=1778648332"
  },
  {
    "sku": "FC587133BK",
    "title": "Airventure 133cm  AC Ceiling Fan with LED Light (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airventure-AC-Ceiling-Fan-with-LED-Light-Mercator-973_d30ab0b6-9a2c-48e3-9759-a66a37ece79a.jpg?v=1778648332"
  },
  {
    "sku": "FC580133BK",
    "title": "Airventure 133cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Airventure-AC-Ceiling-Fan-Mercator-6330_8ac7aed4-0458-4227-8a54-697ecd118796.jpg?v=1778648336"
  },
  {
    "sku": "MTBL043",
    "title": "Akira Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Akira-Table-Lamp-Mercator-7949_787e1501-4515-4ead-80ed-022fad5a5686.jpg?v=1778648340"
  },
  {
    "sku": "MPLS008BLK",
    "title": "Aksel 1Lt  Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aksel-1Lt-Light-Pendant-Mercator-3086_68c71165-35b9-4b0a-ae70-26cb662a2865.jpg?v=1778648344"
  },
  {
    "sku": "MTBL031GRY",
    "title": "Albion Crystal With Pleated Shade Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Albion-Crystal-With-Pleated-Shade-Table-Lamp-Mercator-6711_282e81f1-d10a-4547-8fcd-7973b2022ee2.jpg?v=1778648348"
  },
  {
    "sku": "A19264BLK",
    "title": "Alecia 4Lt Plate Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Alecia-4Lt-Plate-Spotlight-Mercator-9265_4a52c430-f269-406e-95fe-6bc183fffbee.jpg?v=1778648351"
  },
  {
    "sku": "MFL003",
    "title": "Alexia Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MFL003_547c8225-10a7-41ac-b775-89b707cb4260.jpg?v=1778648355"
  },
  {
    "sku": "A86321WHT",
    "title": "Alfred Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Alfred-Floor-Lamp-Mercator-9646_3fe52b2f-c103-4cb9-ac34-4940270396d0.jpg?v=1778648359"
  },
  {
    "sku": "A86321BLK",
    "title": "Alfred Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Alfred-Floor-Lamp-Mercator-9646_3fe52b2f-c103-4cb9-ac34-4940270396d0.jpg?v=1778648359"
  },
  {
    "sku": "SHO122BLK-WIFI",
    "title": "Alfresco Iku Smart Wi-Fi 1800W Strip Heater With Remote Control",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SHO122BLK-WIFI_69678ae8-ac81-4a4f-99b1-a01220c1a970.jpg?v=1778648362"
  },
  {
    "sku": "SHO123BLK-WIFI",
    "title": "Alfresco Iku Smart Wi-Fi 2400W Strip Heater With Remote Control",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SHO123BLK-WIFI_14841980-369b-4b8f-95c6-33637be10121.jpg?v=1778648365"
  },
  {
    "sku": "MA418-5K",
    "title": "Allen II 24W LED Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MA418-5K_cd47e2c8-089f-4a81-a92d-e51210092be4.jpg?v=1778648368"
  },
  {
    "sku": "M1003VKIT",
    "title": "Aluminium 100mm Duct Ventilation Kits",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/M1003VKIT_af28b0c0-e105-4873-ac5d-ca0b45351e07.jpg?v=1778648372"
  },
  {
    "sku": "M1006VKIT",
    "title": "Aluminium 100mm Duct Ventilation Kits",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/M1003VKIT_af28b0c0-e105-4873-ac5d-ca0b45351e07.jpg?v=1778648372"
  },
  {
    "sku": "M1503VKIT",
    "title": "Aluminium 150mm Duct Ventilation Kits",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/M1503VKIT_bf9d3a7d-9915-4b3c-baf9-1d24381aa8be.jpg?v=1778648377"
  },
  {
    "sku": "M1506VKIT",
    "title": "Aluminium 150mm Duct Ventilation Kits",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/M1503VKIT_bf9d3a7d-9915-4b3c-baf9-1d24381aa8be.jpg?v=1778648377"
  },
  {
    "sku": "MPLS001BLK-S",
    "title": "Amar  1Lt 25W  Small Island Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Amar-1Lt-25W-Small-Island-Pendant-Light-Mercator-8426_9012f4b2-3303-40e0-ad3c-139e24b41b33.jpg?v=1778648381"
  },
  {
    "sku": "MPLS001BLK-L",
    "title": "Amar 1Lt 30W Large Island Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Amar-1Lt-30W-Large-Island-Pendant-Light-Mercator-3413_f795c58e-de7a-4885-991f-7aaeb3fb5f38.jpg?v=1778648385"
  },
  {
    "sku": "MNL001",
    "title": "Amaya Penguin Night Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Amya-Night-Light-Mercator-218_59d1257b-8847-4f1d-8cde-9c8958e3da08.jpg?v=1778648388"
  },
  {
    "sku": "MA6815WHT-CCT",
    "title": "Andre 15W LED CCT Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Andre-15W-Ceiling-Light-Mercator-2510_6902af00-be98-4f6f-afca-d27850547fb9.jpg?v=1778648392"
  },
  {
    "sku": "MA6825WHT-CCT",
    "title": "Andre 25W LED CCT Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Andre-25W-Ceiling-Light-Mercator-6849_5b0ebccb-69bb-4883-8c63-6930af34b125.jpg?v=1778648396"
  },
  {
    "sku": "MA6835WHT-CCT",
    "title": "Andre 35W LED CCT Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Andre-35W-Ceiling-Light-Mercator-1338_33f83ad5-5c53-4781-9abd-823e65969e95.jpg?v=1778648400"
  },
  {
    "sku": "MA1071BLK",
    "title": "Anna DIY Batten Fix Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Anna-DIY-Batten-Fix-Light-Mercator-6819_1deacb00-6cab-4165-94ce-9d896fb35c69.jpg?v=1778648405"
  },
  {
    "sku": "MA1071PWT",
    "title": "Anna DIY Batten Fix Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Anna-DIY-Batten-Fix-Light-Mercator-6819_1deacb00-6cab-4165-94ce-9d896fb35c69.jpg?v=1778648405"
  },
  {
    "sku": "FC1148WHWIFI",
    "title": "Anova 132cm DC Iku Smart Wi-Fi Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1148WHWIFI_483be77c-1bab-4188-84ac-cf813a7fdf88.jpg?v=1778648409"
  },
  {
    "sku": "FC1148BKWIFI",
    "title": "Anova 132cm DC Iku Smart Wi-Fi Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1148WHWIFI_483be77c-1bab-4188-84ac-cf813a7fdf88.jpg?v=1778648409"
  },
  {
    "sku": "FC1140BKWIFI",
    "title": "Anova 132cm DC Iku Smart Wi-Fi Ceiling Fan with Remote",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000040W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006312_Pairing_Guide.pdf?v=1776661657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1140BKWIFI_e3050f76-465b-4087-bb08-742374332d8f.jpg?v=1778648414"
  },
  {
    "sku": "FC1140WHWIFI",
    "title": "Anova 132cm DC Iku Smart Wi-Fi Ceiling Fan with Remote",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000040W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006312_Pairing_Guide.pdf?v=1776661657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1140BKWIFI_e3050f76-465b-4087-bb08-742374332d8f.jpg?v=1778648414"
  },
  {
    "sku": "SMD4309WRGB-WIFI",
    "title": "Apollo 7W  Iku Smart Wi-Fi LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4309WRGB-WIFI_523a0571-2fa9-4dd8-a6d6-3455250bd944.jpg?v=1778648419"
  },
  {
    "sku": "MD4309WP-CCT",
    "title": "Apollo 7W 3CCT LED Downlight with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Apollo-7W-3CCT-LED-Downlight-with-PIR-Sensor-Mercator-9756_2eb44092-2ed4-4504-9e57-90807c0870ff.jpg?v=1778648424"
  },
  {
    "sku": "SMD4309W-WIFI",
    "title": "Apollo 7W 90mm Iku Smart Wi-Fi LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4309WRGB-WIFI_d62ab621-67c3-4e3e-899d-3a200d9bf245.jpg?v=1778648428"
  },
  {
    "sku": "MD4309W-CCT",
    "title": "Apollo 7W LED CCT Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Apollo-7W-LED-CCT-Downlight-Mercator-6923_7e856bd0-31e8-40ff-9fba-36a64218a2a5.jpg?v=1778648432"
  },
  {
    "sku": "MD4309WL-CCT",
    "title": "Apollo Pro 7W 3CCT LED Downlight Low Glare",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Apollo-Pro-7W-3CCT-LED-Downlight-Low-Glare-Mercator-3736_09ba1509-adbf-46a1-ae41-47b32a135024.jpg?v=1778648436"
  },
  {
    "sku": "MD4309WLG-CCT",
    "title": "Apollo Pro 7W 3CCT LED Downlight Low Glare Gimbal LED",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Apollo-Pro-7W-3CCT-LED-Downlight-Low-Glare-Gimbal-LED-Mercator-820_6b6fb1c0-8452-4cbf-9ec7-5bfe57564b88.jpg?v=1778648439"
  },
  {
    "sku": "MD560W",
    "title": "Aquarius 9W 92mm LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aquarius-9W-92mm-LED-Downlight-Mercator-1833_4588c690-e10c-4402-898a-ee728e99c27b.jpg?v=1778648444"
  },
  {
    "sku": "BS122ESWWH",
    "title": "Ardene Duo 3-in-1 Bathroom Heater with Exhaust Fan and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ardene-Duo-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-LED-Light-Mercator-40919989_ee601f1a-8d42-4796-b98d-4b2e1f77a406.jpg?v=1778648447"
  },
  {
    "sku": "BS124ESWWH",
    "title": "Ardene Quattro 3-in-1 Bathroom Heater with Exhaust Fan and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ardene-Quattro-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-LED-Light-Mercator-40920971_cc997c4f-dc2a-4310-8c98-53bf27efd37f.jpg?v=1778648450"
  },
  {
    "sku": "FF83320BK",
    "title": "Arena 50cm Industrial Wall Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Arena-50cm-Industrial-Wall-Fan-Mercator-824_3d431683-6cd8-4ce4-b73a-d28f9a95b7f9.jpg?v=1778648455"
  },
  {
    "sku": "A38522",
    "title": "Arizona 2 Light Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Arizona-2-Light-Floor-Lamp-Mercator-3353_a4566ec0-c51f-40e3-91c2-2540a24cda19.jpg?v=1778648458"
  },
  {
    "sku": "A38511",
    "title": "Arizona Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A38511_2e33bf5a-15ba-4a7e-aa93-86843384d05b.jpg?v=1778648461"
  },
  {
    "sku": "ML7437BLK",
    "title": "Armstrong 1Lt 60cm LED Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Armstrong-1Lt-60cm-LED-Pendant-Light-Mercator-9469_313cbb5b-be2e-41f4-abb7-b417e3c056e3.jpg?v=1778648465"
  },
  {
    "sku": "ML7450BLK",
    "title": "Armstrong 1Lt 80cm LED Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Armstrong-1Lt-80cm-LED-Pendant-Light-Mercator-5731_0f44896e-6f7e-47d1-ae8e-c68c405b6e05.jpg?v=1778648469"
  },
  {
    "sku": "MTBL028",
    "title": "Asher Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Asher-Table-Lamp-Mercator-5219_6e28ed06-260b-4fc3-a2d3-eb4e0eb807e4.jpg?v=1778648472"
  },
  {
    "sku": "MX104100BLK-5",
    "title": "Aspect 100W LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aspect-100W-LED-Flood-Light-Mercator-2513_0845120c-0907-476e-8224-e2f93f6762ad.jpg?v=1778648476"
  },
  {
    "sku": "MX104150BLK-5",
    "title": "Aspect 150W LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aspect-150W-LED-Flood-Light-Mercator-5726_fa4943c8-7421-428d-bacd-bc134a8667e6.jpg?v=1778648480"
  },
  {
    "sku": "MX104200BLK-5",
    "title": "Aspect 200W LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aspect-200W-LED-Flood-Light-Mercator-4742_4f9f04b6-86ee-41b5-9922-5b6576fdbc5e.jpg?v=1778648483"
  },
  {
    "sku": "MM104100GRY-5",
    "title": "Aspect LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Aspect-LED-Flood-Light-Mercator-573_6455253e-e56b-4d30-850d-3e8b6dc3c99d.jpg?v=1778648487"
  },
  {
    "sku": "MTL025BLK",
    "title": "Astro  Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Astro-Table-Lamp-Mercator-3280_15f76dd2-6c55-4c9e-ba09-493f4799b4f0.jpg?v=1778648492"
  },
  {
    "sku": "MTL025WHT",
    "title": "Astro  Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Astro-Table-Lamp-Mercator-3280_15f76dd2-6c55-4c9e-ba09-493f4799b4f0.jpg?v=1778648492"
  },
  {
    "sku": "MA2751-SN",
    "title": "Astro Chrome Clips 1lt 30cm Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Astro-1lt-Ceiling-Light-Mercator-3003_3c05c73d-1937-49a4-a8e7-7d3c48914a5a.jpg?v=1778648497"
  },
  {
    "sku": "MA2771-SN",
    "title": "Astro DIY 1 Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Astro-DIY-1-Light-Mercator-3417_97448354-37db-494a-a088-8c39f6702877.jpg?v=1778648504"
  },
  {
    "sku": "MA2772-SN",
    "title": "Astro DIY 2 Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Astro-DIY-2-Light-Mercator-5537_4864f7bb-e23f-47f2-a25c-9198b364c9c5.jpg?v=1778648507"
  },
  {
    "sku": "MA2752-SN",
    "title": "Astro Satin Nickle Clips 2lt 40cm Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Astro-2lt-Ceiling-Light-Mercator-3761_de9fdb64-fede-4dab-bc4c-8ffda2fcad64.jpg?v=1778648510"
  },
  {
    "sku": "MC8211",
    "title": "Autumn Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Autumn-Wall-Light-Mercator-6993_4849a018-3ff9-4bf8-bfd4-549793de1d77.jpg?v=1778648514"
  },
  {
    "sku": "MPL505BLK",
    "title": "Ava 1Lt  Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ava-1Lt-Pendant-Light-Mercator-3068_4d69df35-a238-481c-8287-6b01dd70a53a.jpg?v=1778648517"
  },
  {
    "sku": "MPL505BRS",
    "title": "Ava 1Lt  Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ava-1Lt-Pendant-Light-Mercator-3068_4d69df35-a238-481c-8287-6b01dd70a53a.jpg?v=1778648517"
  },
  {
    "sku": "MTBL411",
    "title": "Bahama Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bahama-Table-Lamp-Mercator-3313_2791b123-e31b-4449-b16f-3f5df9e3c8e1.jpg?v=1778648522"
  },
  {
    "sku": "MTBL037",
    "title": "Balmain Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Balmain-Table-Lamp-Mercator-1272_5ad7cb28-7760-4a98-baa4-889f581208a4.jpg?v=1778648529"
  },
  {
    "sku": "A87411",
    "title": "Balmoral Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Balmoral-Table-Lamp-Mercator-6717_3166d64e-9c15-4c0f-a726-566bf678f060.jpg?v=1778648542"
  },
  {
    "sku": "MNL002",
    "title": "Barney Polar Bear Night Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Barney-Night-Light-Mercator-3927_6696d205-c648-4d31-a67a-bdcbdc050c52.jpg?v=1778648546"
  },
  {
    "sku": "MUC152",
    "title": "Barry 13W LED CCT Linkable Bar Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Barry-13W-LED-CCT-Linkable-Bar-Light-Mercator-3969_fafde4b8-c6c4-434f-9a1c-cb20e36e789f.jpg?v=1778648550"
  },
  {
    "sku": "MUC153",
    "title": "Barry 18W LED CCT Linkable Bar Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Barry-18W-LED-CCT-Linkable-Bar-Light-Mercator-9701_bfa992d3-49cb-4c40-990b-62bd9cb5c4a8.jpg?v=1778648554"
  },
  {
    "sku": "MUC150",
    "title": "Barry 4W LED CCT Linkable Bar Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Barry-4W-LED-CCT-Linkable-Bar-Light-Mercator-3137_27f2f945-5a19-4103-8e06-2f61ce3989d1.jpg?v=1778648557"
  },
  {
    "sku": "MUC151",
    "title": "Barry 9W LED CCT Linkable Bar Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Barry-9W-LED-CCT-Linkable-Bar-Light-Mercator-9480_c65e87aa-04b5-49dc-b5ab-e5d7b755094a.jpg?v=1778648560"
  },
  {
    "sku": "MX20320BLK",
    "title": "Baxter 20W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Baxter-20W-DIY-LED-Flood-Light-Mercator-7956_c3f26ca7-7266-47b1-a3ed-23d691959148.jpg?v=1778648565"
  },
  {
    "sku": "MX20320BLK-SEN",
    "title": "Baxter 20W DIY LED Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Baxter-20W-DIY-LED-Flood-Light-with-PIR-Sensor-Mercator-302_4c155966-9312-4816-ab74-6858ce95a6f8.jpg?v=1778648568"
  },
  {
    "sku": "MX20330BLK",
    "title": "Baxter 30W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Baxter-30W-DIY-LED-Flood-Light-Mercator-3510_b89581a1-0094-4d31-82ce-62518ea1762f.jpg?v=1778648572"
  },
  {
    "sku": "MX20330BLK-SEN",
    "title": "Baxter 30W DIY LED Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Baxter-30W-DIY-LED-Flood-Light-with-PIR-Sensor-Mercator-707_d57b016e-9b36-4ae2-b4c5-31dc95051f76.jpg?v=1778648576"
  },
  {
    "sku": "MX20350BLK",
    "title": "Baxter 50W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Baxter-50W-DIY-LED-Flood-Light-Mercator-9911_68d7fee3-015b-489e-998d-719fbdb9ba54.jpg?v=1778648581"
  },
  {
    "sku": "MX20350BLK-SEN",
    "title": "Baxter 50W DIY LED Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Baxter-50W-DIY-LED-Flood-Light-with-PIR-Sensor-Mercator-6436_cf160a3c-7ca4-44b1-ac82-425d42b0946f.jpg?v=1778648584"
  },
  {
    "sku": "MTBL019GRY",
    "title": "Belgrave Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTBL019BLK_31c8a844-7146-4253-bb4b-3790a3c3e425.jpg?v=1778648588"
  },
  {
    "sku": "MG2331CLR",
    "title": "Belmont 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Belmont-1Lt-Pendant-Light-Mercator-7326_c0a6fc0d-232c-4d43-a7d1-c1c1fe468eef.jpg?v=1778648593"
  },
  {
    "sku": "MG2331COG",
    "title": "Belmont 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Belmont-1Lt-Pendant-Light-Mercator-7326_c0a6fc0d-232c-4d43-a7d1-c1c1fe468eef.jpg?v=1778648593"
  },
  {
    "sku": "32310-03",
    "title": "Ben  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ben-Floor-Lamp-Mercator-2955_cfe8f3fe-1134-4eac-b6a1-4e073a8452d2.jpg?v=1778648597"
  },
  {
    "sku": "32310-01",
    "title": "Ben  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ben-Floor-Lamp-Mercator-2955_cfe8f3fe-1134-4eac-b6a1-4e073a8452d2.jpg?v=1778648597"
  },
  {
    "sku": "32310-49",
    "title": "Ben  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ben-Floor-Lamp-Mercator-2955_cfe8f3fe-1134-4eac-b6a1-4e073a8452d2.jpg?v=1778648597"
  },
  {
    "sku": "32310-02",
    "title": "Ben  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ben-Floor-Lamp-Mercator-2955_cfe8f3fe-1134-4eac-b6a1-4e073a8452d2.jpg?v=1778648597"
  },
  {
    "sku": "32310-03",
    "title": "Ben  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ben-Floor-Lamp-Mercator-2955_903910c3-0539-4668-8b3e-40b23ef2cd21.jpg?v=1778648601"
  },
  {
    "sku": "32310-01",
    "title": "Ben  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ben-Floor-Lamp-Mercator-2955_903910c3-0539-4668-8b3e-40b23ef2cd21.jpg?v=1778648601"
  },
  {
    "sku": "A87111CP",
    "title": "Benjamin Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Benjamin-Table-Lamp-Mercator-7907_50f15171-8942-4e22-83e9-deef0f246ac2.jpg?v=1778648605"
  },
  {
    "sku": "MA94BC",
    "title": "Biba DIY Batten Cover",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Biba-DIY-Batten-Cover-Mercator-5086_a5edfe45-5cfd-4546-a649-b5448a6abeb3.jpg?v=1778648609"
  },
  {
    "sku": "MTBL049PNK",
    "title": "Blaire Metal & Wood Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Blaire-Metal-Wood-Table-Lamp-Mercator-9221_e5405954-0cdb-40a7-947c-dfc27684b62b.jpg?v=1778648612"
  },
  {
    "sku": "MX5911CCT",
    "title": "Blake LED Bunker Light with CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Blake-LED-Bunker-Light-with-CCT-Mercator-40919885_803174f1-fc40-468e-93a1-9658c3f4a48d.jpg?v=1778648615"
  },
  {
    "sku": "MM5471BLK",
    "title": "Blasko DIY ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Blasko-DIY-Batten-Fix-Light-Mercator-8550_cd82d2d8-7d4a-463c-a37d-0353f625bfdf.jpg?v=1778648620"
  },
  {
    "sku": "MM5471WHT",
    "title": "Blasko DIY ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Blasko-DIY-Batten-Fix-Light-Mercator-8550_cd82d2d8-7d4a-463c-a37d-0353f625bfdf.jpg?v=1778648620"
  },
  {
    "sku": "MM5471WHT",
    "title": "Blasko DIY ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Blasko-DIY-Batten-Fix-Light-Mercator-6241_1a23784e-a8ed-4e2e-a3bc-e95bc57f17fd.jpg?v=1778648623"
  },
  {
    "sku": "MM5471WHT",
    "title": "Blasko DIY ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Blasko-DIY-Batten-Fix-Light-Mercator-6241_d01c3f0a-d599-43ef-9a93-7a0a5b828083.jpg?v=1778648627"
  },
  {
    "sku": "MXW1040WHT",
    "title": "Bond II 6W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bond-II-6W-LED-Wall-Light-Mercator-8726_159fb77b-77d4-495d-810f-d6678c99bb09.jpg?v=1778648631"
  },
  {
    "sku": "MXW1040BLK",
    "title": "Bond II 6W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bond-II-6W-LED-Wall-Light-Mercator-8726_159fb77b-77d4-495d-810f-d6678c99bb09.jpg?v=1778648631"
  },
  {
    "sku": "MXW1050WHT",
    "title": "Bond II LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bond-II-LED-Wall-Light-Mercator-1720_627bf52d-1f53-41b9-a309-e0542b1a490f.jpg?v=1778648636"
  },
  {
    "sku": "MXW1050BLK",
    "title": "Bond II LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bond-II-LED-Wall-Light-Mercator-1720_627bf52d-1f53-41b9-a309-e0542b1a490f.jpg?v=1778648636"
  },
  {
    "sku": "A28412AB",
    "title": "Bonita 2Lt Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bonita-2Lt-Table-Lamp-Mercator-40919187_50db2828-5c31-4a0d-930f-e39555f71027.jpg?v=1778648641"
  },
  {
    "sku": "A35211WHT",
    "title": "Brady Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Brady-Table-Lamp-Mercator-8132_93132b2a-183b-44ea-9a91-a20149a4a54e.jpg?v=1778648644"
  },
  {
    "sku": "MFL014",
    "title": "Briar Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Briar-Floor-Lamp-Mercator-3616_8ff47b46-c3c2-47eb-b29c-e6ecf9fe8b80.jpg?v=1778648647"
  },
  {
    "sku": "MPLS023BLK",
    "title": "Bridgewater 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bridgewater-1Lt-Pendant-Light-Mercator-6249_304d309e-6029-44a2-bbf4-fc3b43d442dc.jpg?v=1778648651"
  },
  {
    "sku": "MPLS023NAT",
    "title": "Bridgewater 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bridgewater-1Lt-Pendant-Light-Mercator-6249_304d309e-6029-44a2-bbf4-fc3b43d442dc.jpg?v=1778648651"
  },
  {
    "sku": "MW7211BLK",
    "title": "Brodie Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Brodie-Wall-Light-Mercator-8660_a5289150-952b-442b-8a94-9ad60ce8857d.jpg?v=1778648654"
  },
  {
    "sku": "MW7111BLK",
    "title": "Bronte Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bronte-Wall-Light-Mercator-6328_b846a257-f5f8-45af-87d6-18c8f4567444.jpg?v=1778648657"
  },
  {
    "sku": "FC947123WH",
    "title": "Brooke 128cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC947123WH_0e98ce3e-3bc3-4faf-84c1-7d4f443e7ddc.jpg?v=1778648663"
  },
  {
    "sku": "FC947123BK",
    "title": "Brooke 128cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC947123WH_0e98ce3e-3bc3-4faf-84c1-7d4f443e7ddc.jpg?v=1778648663"
  },
  {
    "sku": "FC940123WH",
    "title": "Brooke 128cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC940123WH_54b89d03-f18f-4519-96dd-84fe9504b319.jpg?v=1778648698"
  },
  {
    "sku": "FC940123BK",
    "title": "Brooke 128cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC940123WH_54b89d03-f18f-4519-96dd-84fe9504b319.jpg?v=1778648698"
  },
  {
    "sku": "FF101230BK",
    "title": "Broome 75cm Industrial Pedestal Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Broome-75cm-Industrial-Pedestal-Fan-Mercator-5875_9304eac5-5255-4dc2-9a1f-3fc1a067d0f4.jpg?v=1778648732"
  },
  {
    "sku": "FF103330BK",
    "title": "Broome 75cm Industrial Wall Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Broome-75cm-Industrial-Wall-Fan-Mercator-6498_68932c2e-979f-4c3b-92b3-ba7de68eb943.jpg?v=1778648735"
  },
  {
    "sku": "MDA001",
    "title": "Brush Chrome Trims For Eko 9W  Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MicrosoftTeams-image_45_4fd5c2c3-eb2a-4701-9e8f-62c39413e72f.jpg?v=1778648740"
  },
  {
    "sku": "A21341WHT",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-6527_69032a94-9049-4301-8880-d43c813d8a09.jpg?v=1778648746"
  },
  {
    "sku": "A21341PNK",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-6527_69032a94-9049-4301-8880-d43c813d8a09.jpg?v=1778648746"
  },
  {
    "sku": "A21341BLK",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-6527_69032a94-9049-4301-8880-d43c813d8a09.jpg?v=1778648746"
  },
  {
    "sku": "A21341BLU",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-6527_69032a94-9049-4301-8880-d43c813d8a09.jpg?v=1778648746"
  },
  {
    "sku": "A21341WHT",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-8436_86ba46b0-570c-48c7-a693-8dbdb01a634e.jpg?v=1778648752"
  },
  {
    "sku": "A21341PNK",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-8436_86ba46b0-570c-48c7-a693-8dbdb01a634e.jpg?v=1778648752"
  },
  {
    "sku": "A21341BLK",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-8436_86ba46b0-570c-48c7-a693-8dbdb01a634e.jpg?v=1778648752"
  },
  {
    "sku": "A21341BLU",
    "title": "Bryce LED Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-LED-Clamp-Table-Lamp-Mercator-8436_86ba46b0-570c-48c7-a693-8dbdb01a634e.jpg?v=1778648752"
  },
  {
    "sku": "A21311BLK",
    "title": "Bryce Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Bryce-Table-Lamp-Mercator-8792_2c225969-a8a6-4cb9-bea9-1231c38837af.jpg?v=1778648759"
  },
  {
    "sku": "A42722",
    "title": "Buckley Uplighter Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Buckley-Uplighter-Floor-Lamp-Mercator-9464_a4640afb-6b18-433b-8db9-99fa0792ce97.jpg?v=1778648770"
  },
  {
    "sku": "MTBL024",
    "title": "Burnley Mesh Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Burnley-Mesh-Table-Lamp-Mercator-1633_ea9bda1e-cdb4-457c-b2e6-9d53cdcda9d9.jpg?v=1778648773"
  },
  {
    "sku": "MPLS015",
    "title": "Byron 1Lt Bamboo Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Byron-1Lt-Bamboo-Pendant-Light-Mercator-2553_c732d7c4-45fc-4c09-9a59-91acf3100d46.jpg?v=1778648776"
  },
  {
    "sku": "A49731BLK",
    "title": "Calico 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A49731BLK_89a18a5f-7c11-4173-9dae-908bcc502965.jpg?v=1778648784"
  },
  {
    "sku": "A49721BLK",
    "title": "Calico Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Calico-Floor-Lamp-Mercator-2600_c5d4a50c-acea-41e8-abb7-5c1732f4fddb.jpg?v=1778648789"
  },
  {
    "sku": "MW1714WHT",
    "title": "Callan 14W LED Wall Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MW1714WHT_25e73b6c-e443-4fed-a453-eaac1a61dbb1.jpg?v=1778648793"
  },
  {
    "sku": "MW1707WHT",
    "title": "Callan 7W LED Batten Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Callan-7W-LED-Batten-Lamp-Mercator-1311_fd7b271b-146d-44be-9cda-fdf3bcb92fab.jpg?v=1778648797"
  },
  {
    "sku": "MWL005WHT-3",
    "title": "Calvin 3000K LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Calvin-3000K-LED-Wall-Light-Mercator-9085_7f5f16c2-9472-4e05-bf88-c79461ac3cf8.jpg?v=1778648802"
  },
  {
    "sku": "MWL005WHT-4",
    "title": "Calvin 4000K LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Calvin-4000K-LED-Wall-Light-Mercator-7843_9bca1e02-07f6-4f0c-8136-73b3da6fcd0b.jpg?v=1778648807"
  },
  {
    "sku": "A28711BLK",
    "title": "Campbell Large Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Campbell-Large-Table-Lamp-Mercator-4102_624d45cc-7b30-41e9-9b29-6cbf28dae6c5.jpg?v=1778648812"
  },
  {
    "sku": "A28711",
    "title": "Campbell Large Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Campbell-Large-Table-Lamp-Mercator-4102_624d45cc-7b30-41e9-9b29-6cbf28dae6c5.jpg?v=1778648812"
  },
  {
    "sku": "A28711SWHT",
    "title": "Campbell Small Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Campbell-Small-Table-Lamp-Mercator-8871_24fba404-7e1a-4643-b889-122b709cb49f.jpg?v=1778648815"
  },
  {
    "sku": "MGL060WSB-D",
    "title": "Candle 3000K B15 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Candle-3000K-B15-LED-Globe-Mercator-9522_161ef9a3-d9cd-43de-bf4b-71ddd23fdfad.jpg?v=1778648819"
  },
  {
    "sku": "MGL060WSE-D",
    "title": "Candle 3000K E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Candle-3000K-E14-LED-Globe-Mercator-7037_bfc74cb8-81f1-4add-bb46-f5fa7dc720a9.jpg?v=1778648823"
  },
  {
    "sku": "MGL060DSB-D",
    "title": "Candle 5700K B15 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Candle-5700K-B15-LED-Globe-Mercator-1574_341a4aed-ca2a-4bbb-af07-9d3a87688c65.jpg?v=1778648827"
  },
  {
    "sku": "MGL060DSE-D",
    "title": "Candle 5700K E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Candle-5700K-E14-LED-Globe-Mercator-2950_77f9e118-fd54-45e1-90c6-a531ab13ad22.jpg?v=1778648831"
  },
  {
    "sku": "S9B15LED12",
    "title": "Candle Iku Smart Wi-Fi B15 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B15LED12_96753eef-a574-4cb7-90cd-5c281d85bb3e.jpg?v=1778648834"
  },
  {
    "sku": "S9E14LED12",
    "title": "Candle Iku Smart Wi-Fi E14 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E14LED12-ZB_4dc219d8-5a7c-4ccf-bc38-7ea3c361e683.jpg?v=1778648838"
  },
  {
    "sku": "S9B15LED12-ZB",
    "title": "Candle Iku Smart Zigbee B15 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B15LED12-ZB_fb4a07f8-f933-4693-844f-04fd84ce5f64.jpg?v=1778648842"
  },
  {
    "sku": "S9E14LED12-ZB",
    "title": "Candle Iku Smart Zigbee E14 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E14LED12-ZB_a9986404-f79e-41cd-be03-d8f78318e177.jpg?v=1778648845"
  },
  {
    "sku": "XC99",
    "title": "CAPACITOR CBB61 9UF 450V",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XC17",
    "title": "CAPACITOR ONLY MOTOR 1.8UF SWI",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XC12",
    "title": "CAPACITOR ONLY WC 1.8+2.8UF SW",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "FC250134WH",
    "title": "Caprice 132cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Caprice-AC-1-3m-Ceiling-Fan-Mercator-1754_e1acfb28-8113-4bde-9fff-5ba9fa500e82.jpg?v=1778648850"
  },
  {
    "sku": "FC250134BK",
    "title": "Caprice 132cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Caprice-AC-1-3m-Ceiling-Fan-Mercator-1754_e1acfb28-8113-4bde-9fff-5ba9fa500e82.jpg?v=1778648850"
  },
  {
    "sku": "FC250134BS",
    "title": "Caprice 132cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Caprice-AC-1-3m-Ceiling-Fan-Mercator-1754_e1acfb28-8113-4bde-9fff-5ba9fa500e82.jpg?v=1778648850"
  },
  {
    "sku": "FC252134WH",
    "title": "Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Caprice-AC-1-3m-AC-Ceiling-Fan-with-Light-Mercator-3379_b4e10a9c-7e17-461d-a13e-b8076fbfbf21.jpg?v=1778648855"
  },
  {
    "sku": "FC252134BS",
    "title": "Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Caprice-AC-1-3m-AC-Ceiling-Fan-with-Light-Mercator-3379_b4e10a9c-7e17-461d-a13e-b8076fbfbf21.jpg?v=1778648855"
  },
  {
    "sku": "FC252134BK",
    "title": "Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Caprice-AC-1-3m-AC-Ceiling-Fan-with-Light-Mercator-3379_b4e10a9c-7e17-461d-a13e-b8076fbfbf21.jpg?v=1778648855"
  },
  {
    "sku": "FC640134RBS",
    "title": "Caprice Pro 130cm AC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC640134RBS_34747235-3f22-4b69-b09d-6867d69d95f0.jpg?v=1778648860"
  },
  {
    "sku": "FC952123WH",
    "title": "Cardinia 122cm 3 Blade AC Ceiling Fan with B22 Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CARDINIA_3B_BLADE_AC_SERIES.pdf?v=1791278186",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC952123WH.png?v=1791279643"
  },
  {
    "sku": "FC958123WH",
    "title": "Cardinia 122cm 3 Blade AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CARDINIA_3B_BLADE_AC_SERIES.pdf?v=1791278186",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC958123WH.png?v=1791279699"
  },
  {
    "sku": "FC952124WH",
    "title": "Cardinia 122cm 4 Blade AC Ceiling Fan with B22 Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CARDINIA_4B_BLADE_AC_SERIE.pdf?v=1791278187",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC952124WH.png?v=1791279762"
  },
  {
    "sku": "FC950124WH",
    "title": "Cardinia 122cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CARDINIA_4B_BLADE_AC_SERIE.pdf?v=1791278187",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC950124WH_5f673218-28d9-4213-a233-9f4ead089cba.jpg?v=1778648870"
  },
  {
    "sku": "FC958124WH",
    "title": "Cardinia 122cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CARDINIA_4B_BLADE_AC_SERIE.pdf?v=1791278187",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC958124WH_c9ea4d1a-f30a-480b-a1a8-1f5e7c88f595.jpg?v=1778648899"
  },
  {
    "sku": "FC950123WH",
    "title": "Cardinia White 122cm 3 Blade AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CARDINIA_3B_BLADE_AC_SERIES.pdf?v=1791278186",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC950123WH.png?v=1791279578"
  },
  {
    "sku": "FC798133GWW",
    "title": "Casa 132cm DC Iku Smart Wi-Fi Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC798133GWW_fc998597-97da-4cda-b96b-abc71a75a15d.png?v=1778648922"
  },
  {
    "sku": "FC790133GWW",
    "title": "Casa 132cm DC Iku Smart Wi-Fi Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC790133GWW_3c56af92-d3c5-47c0-bef5-4cc1bdb82d02.jpg?v=1778648925"
  },
  {
    "sku": "MXD6512BLK",
    "title": "Cayman LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cayman-LED-Wall-Light-Mercator-9673_4f44d87d-3126-4af5-b083-0dbd79118ec7.jpg?v=1778648932"
  },
  {
    "sku": "MXD6512WHT",
    "title": "Cayman LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cayman-LED-Wall-Light-Mercator-9673_4f44d87d-3126-4af5-b083-0dbd79118ec7.jpg?v=1778648932"
  },
  {
    "sku": "A21821JD",
    "title": "Celeste LED Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Celeste-LED-Floor-Lamp-Mercator-5155_dbb4b4ce-815f-4ded-acee-1a2b90e7b8ec.jpg?v=1778648936"
  },
  {
    "sku": "A21821BLU",
    "title": "Celeste LED Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Celeste-LED-Floor-Lamp-Mercator-5155_dbb4b4ce-815f-4ded-acee-1a2b90e7b8ec.jpg?v=1778648936"
  },
  {
    "sku": "A21811BLK",
    "title": "Celeste LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Celeste-LED-Table-Lamp-Mercator-4672_ee1a2c54-3391-4da8-b997-b2a2ff00b52c.jpg?v=1778648941"
  },
  {
    "sku": "A21811BLU",
    "title": "Celeste LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Celeste-LED-Table-Lamp-Mercator-4672_ee1a2c54-3391-4da8-b997-b2a2ff00b52c.jpg?v=1778648941"
  },
  {
    "sku": "A21811JD",
    "title": "Celeste LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Celeste-LED-Table-Lamp-Mercator-4672_ee1a2c54-3391-4da8-b997-b2a2ff00b52c.jpg?v=1778648941"
  },
  {
    "sku": "FC100253BKKIT",
    "title": "Century 254cm DC Ceiling Fan Kit with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC100253BKKIT_d3a83a04-61fc-4046-8fdc-7952009bb47e.jpg?v=1778648945"
  },
  {
    "sku": "FC100253WHKIT",
    "title": "Century 254cm DC Ceiling Fan Kit with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC100253BKKIT_d3a83a04-61fc-4046-8fdc-7952009bb47e.jpg?v=1778648945"
  },
  {
    "sku": "FC100253DTKIT",
    "title": "Century 254cm DC Ceiling Fan Kit with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC100253BKKIT_d3a83a04-61fc-4046-8fdc-7952009bb47e.jpg?v=1778648945"
  },
  {
    "sku": "MTBL029HWT",
    "title": "Chelsea 2Lt Glowing Base Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Chelsea-2Lt-Glowing-Base-Table-Lamp-Mercator-5516_d14b4545-c830-49ad-95b6-a5b3b469a097.jpg?v=1778648949"
  },
  {
    "sku": "AUL1113BLK",
    "title": "Chester LED Clamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1113BLK_e39be345-c09b-410c-8c32-44422d3b6199.jpg?v=1778648953"
  },
  {
    "sku": "AUL1113WHT",
    "title": "Chester LED Clamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1113BLK_e39be345-c09b-410c-8c32-44422d3b6199.jpg?v=1778648953"
  },
  {
    "sku": "MXD6721BLK",
    "title": "Cicero 1Lt LED Security Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-1Lt-LED-Security-Flood-Light-Mercator-4095_1ae49a49-c145-49eb-82be-3735fd197e10.jpg?v=1778648957"
  },
  {
    "sku": "MXD6721WHT",
    "title": "Cicero 1Lt LED Security Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-1Lt-LED-Security-Flood-Light-Mercator-4095_1ae49a49-c145-49eb-82be-3735fd197e10.jpg?v=1778648957"
  },
  {
    "sku": "MXD6721BLK-SEN",
    "title": "Cicero 1Lt LED Security Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-1Lt-LED-Security-Flood-Light-with-PIR-Sensor-Mercator-4463_31096d67-f55d-4221-b5f7-ec14671632a0.jpg?v=1778648961"
  },
  {
    "sku": "MXD6721WHT-SEN",
    "title": "Cicero 1Lt LED Security Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-1Lt-LED-Security-Flood-Light-with-PIR-Sensor-Mercator-4463_31096d67-f55d-4221-b5f7-ec14671632a0.jpg?v=1778648961"
  },
  {
    "sku": "MXD6722WHT-SEN",
    "title": "Cicero LED Security Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-LED-Security-Flood-Light-with-PIR-Sensor-Mercator-9495_323d4c4b-3df6-4822-8ea6-d71c5f837e58.jpg?v=1778648966"
  },
  {
    "sku": "MXD6722BLK-SEN",
    "title": "Cicero LED Security Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-LED-Security-Flood-Light-with-PIR-Sensor-Mercator-9495_323d4c4b-3df6-4822-8ea6-d71c5f837e58.jpg?v=1778648966"
  },
  {
    "sku": "MXD6722BLK",
    "title": "Cicero Tri-colour Twin Head Security Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-Tri-colour-Twin-Head-Security-Flood-Light-Mercator-6553_104a909c-94ca-42c0-a8f1-a29da0225d5b.jpg?v=1778648971"
  },
  {
    "sku": "MXD6722WHT",
    "title": "Cicero Tri-colour Twin Head Security Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cicero-Tri-colour-Twin-Head-Security-Flood-Light-Mercator-6553_104a909c-94ca-42c0-a8f1-a29da0225d5b.jpg?v=1778648971"
  },
  {
    "sku": "FC660134BK",
    "title": "Clare 135cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clare-AC-Ceiling-Fan-Mercator-5632_6f11b0c0-e90d-447c-a096-e525d4ec0a6f.jpg?v=1778648974"
  },
  {
    "sku": "FC660134WH",
    "title": "Clare 135cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clare-AC-Ceiling-Fan-Mercator-5632_6f11b0c0-e90d-447c-a096-e525d4ec0a6f.jpg?v=1778648974"
  },
  {
    "sku": "FC662134WH",
    "title": "Clare 135cm AC Ceiling Fan with B22 Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clare-AC-Ceiling-Fan-with-B22-Light-Mercator-9627_e81aa289-723c-49db-9949-d6d33b09fbae.jpg?v=1778648979"
  },
  {
    "sku": "FC662134BK",
    "title": "Clare 135cm AC Ceiling Fan with B22 Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clare-AC-Ceiling-Fan-with-B22-Light-Mercator-9627_e81aa289-723c-49db-9949-d6d33b09fbae.jpg?v=1778648979"
  },
  {
    "sku": "FC760143RB",
    "title": "Clarence 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-Mercator-2246_687bb048-4ea7-4778-94ed-5a987bdb1528.jpg?v=1778648985"
  },
  {
    "sku": "FC760143BC",
    "title": "Clarence 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-Mercator-2246_687bb048-4ea7-4778-94ed-5a987bdb1528.jpg?v=1778648985"
  },
  {
    "sku": "FC760143WH",
    "title": "Clarence 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-Mercator-2246_687bb048-4ea7-4778-94ed-5a987bdb1528.jpg?v=1778648985"
  },
  {
    "sku": "FC760143BC",
    "title": "Clarence 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-Mercator-5849_0178f661-7b89-4ce8-b55d-56517660355d.jpg?v=1778648988"
  },
  {
    "sku": "FC760143WH",
    "title": "Clarence 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-Mercator-5849_0178f661-7b89-4ce8-b55d-56517660355d.jpg?v=1778648988"
  },
  {
    "sku": "FC760143BC",
    "title": "Clarence 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-Mercator-5849_6adeb8aa-dfb7-44cb-b54f-a8846c47fc3b.jpg?v=1778648993"
  },
  {
    "sku": "FC760143WH",
    "title": "Clarence 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-Mercator-5849_6adeb8aa-dfb7-44cb-b54f-a8846c47fc3b.jpg?v=1778648993"
  },
  {
    "sku": "FC768143BC",
    "title": "Clarence 142cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-with-LED-Light-Mercator-47_9f750a4f-d976-4b34-9721-fb0e8ad6ef2b.jpg?v=1778648997"
  },
  {
    "sku": "FC768143WH",
    "title": "Clarence 142cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-with-LED-Light-Mercator-47_9f750a4f-d976-4b34-9721-fb0e8ad6ef2b.jpg?v=1778648997"
  },
  {
    "sku": "FC768143RB",
    "title": "Clarence 142cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-AC-Ceiling-Fan-with-LED-Light-Mercator-47_9f750a4f-d976-4b34-9721-fb0e8ad6ef2b.jpg?v=1778648997"
  },
  {
    "sku": "MC1015",
    "title": "Clarence 4Lt Crystal Glass Decorative Ceiling Fixture - Medium",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-4Lt-Ceiling-Light-Mercator-3458_2dcde324-b47e-4665-856f-981fccb5b1dc.jpg?v=1778649000"
  },
  {
    "sku": "MC1016",
    "title": "Clarence 6Lt Crystal Glass Decorative Ceiling Fixture - Large",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clarence-6Lt-Ceiling-Light-Mercator-1627_a82e5983-74e8-4a43-a8fe-344745cfd4a6.jpg?v=1778649003"
  },
  {
    "sku": "AUL1027BLK",
    "title": "Clarke Task Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1027BLK_2fc38a5c-0166-4cfa-9deb-96a5ea3e64dc.jpg?v=1778649007"
  },
  {
    "sku": "9B22LEDA60DC",
    "title": "Classic A60 7.5W B22 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-7-5W-B22-Filament-Globe-Mercator-5271_2ee97d81-4e87-4bbf-aeef-b10b1bf631e7.jpg?v=1778649010"
  },
  {
    "sku": "9E27LEDA60DC",
    "title": "Classic A60 7.5W E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-7-5W-E27-Filament-Globe-Mercator-2787_8dd0f4e1-ab35-4866-b257-31ea51d4bd06.jpg?v=1778649014"
  },
  {
    "sku": "MGL289R",
    "title": "Classic A60 B22 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-B22-Filament-Globe-Mercator-1458_203754c4-2cdd-4e52-969e-bd235c00f87f.jpg?v=1778649021"
  },
  {
    "sku": "MGL289B",
    "title": "Classic A60 B22 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-B22-Filament-Globe-Mercator-1458_203754c4-2cdd-4e52-969e-bd235c00f87f.jpg?v=1778649021"
  },
  {
    "sku": "MGL289G",
    "title": "Classic A60 B22 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-B22-Filament-Globe-Mercator-1458_203754c4-2cdd-4e52-969e-bd235c00f87f.jpg?v=1778649021"
  },
  {
    "sku": "MGL289Y",
    "title": "Classic A60 B22 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-B22-Filament-Globe-Mercator-1458_203754c4-2cdd-4e52-969e-bd235c00f87f.jpg?v=1778649021"
  },
  {
    "sku": "MGL289O",
    "title": "Classic A60 B22 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-B22-Filament-Globe-Mercator-1458_203754c4-2cdd-4e52-969e-bd235c00f87f.jpg?v=1778649021"
  },
  {
    "sku": "MGL288R",
    "title": "Classic A60 E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-E27-Filament-Globe-Mercator-8601_0210bb76-0e6a-4cc7-94cc-f585e464422d.jpg?v=1778649026"
  },
  {
    "sku": "MGL288B",
    "title": "Classic A60 E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-E27-Filament-Globe-Mercator-8601_0210bb76-0e6a-4cc7-94cc-f585e464422d.jpg?v=1778649026"
  },
  {
    "sku": "MGL288G",
    "title": "Classic A60 E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-E27-Filament-Globe-Mercator-8601_0210bb76-0e6a-4cc7-94cc-f585e464422d.jpg?v=1778649026"
  },
  {
    "sku": "MGL288Y",
    "title": "Classic A60 E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-E27-Filament-Globe-Mercator-8601_0210bb76-0e6a-4cc7-94cc-f585e464422d.jpg?v=1778649026"
  },
  {
    "sku": "MGL288O",
    "title": "Classic A60 E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-A60-E27-Filament-Globe-Mercator-8601_0210bb76-0e6a-4cc7-94cc-f585e464422d.jpg?v=1778649026"
  },
  {
    "sku": "9B22LED17",
    "title": "Classic B22 Led Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Classic-B22-Led-Globe-Mercator-4677_b5878630-563c-4746-9ae4-dfffcbb87e7c.jpg?v=1778649031"
  },
  {
    "sku": "S9B22LED9W-4K",
    "title": "Classic Iku Smart Wi-Fi B22 4000K Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B22LED9W-4K_c1245277-150d-45d2-9089-a9abf9a24be1.jpg?v=1778649037"
  },
  {
    "sku": "S9B22LED9W",
    "title": "Classic Iku Smart Wi-Fi B22 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B22LED9W_8af17633-0e49-4bc2-b59f-5358a8ab7020.jpg?v=1778649041"
  },
  {
    "sku": "S9B22LED9W-RGB",
    "title": "Classic Iku Smart Wi-Fi B22 LED with CCT & RGB",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B22LED9W-RGB_10eb33ce-fa7f-4f88-9e4b-e26a9fe1dd8c.jpg?v=1778649045"
  },
  {
    "sku": "S9E27LED9W-4K",
    "title": "Classic Iku Smart Wi-Fi E27 4000K Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LED9W-4K_244966ef-6489-4a9c-8506-6bee3076124d.jpg?v=1778649049"
  },
  {
    "sku": "S9E27LED9W",
    "title": "Classic Iku Smart Wi-Fi E27 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LED9W_470ecaa6-f311-443d-85ed-fb9a3fd3bf50.jpg?v=1778649053"
  },
  {
    "sku": "S9E27LED9W-RGB",
    "title": "Classic Iku Smart Wi-Fi E27 LED with CCT & RGB",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LED9W-RGB_015beb67-1fdb-4695-97cd-6dd7e2d95258.jpg?v=1778649057"
  },
  {
    "sku": "S9B22LED9W-4K-ZB",
    "title": "Classic Iku Smart Zigbee B22 4000K Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B22LED9W-4K_-ZB_eb619646-f7b2-4e93-b2a1-a273278a403a.jpg?v=1778649061"
  },
  {
    "sku": "S9B22LED9W-ZB",
    "title": "Classic Iku Smart Zigbee B22 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B22LED9W-ZB_1e92d3aa-c175-4e59-b87b-04e7fa3c2d42.jpg?v=1778649065"
  },
  {
    "sku": "S9B22LED9W-RGB-Z",
    "title": "Classic Iku Smart Zigbee B22 LED with CCT & RGB",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B22LED9W-RGB-Z_9926609f-220d-4471-9057-33f9a1a87d55.jpg?v=1778649069"
  },
  {
    "sku": "S9E27LED9W-4K-ZB",
    "title": "Classic Iku Smart Zigbee E27 4000K Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LED9W-4K-ZB_c1b2d444-9957-4ccb-89fb-d11e67d4ac35.jpg?v=1778649074"
  },
  {
    "sku": "S9E27LED9W-ZB",
    "title": "Classic Iku Smart Zigbee E27 Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LED9W-ZB_6ae156a8-1096-4096-9320-f2b7dd24d515.jpg?v=1778649078"
  },
  {
    "sku": "S9E27LED9W-RGB-Z",
    "title": "Classic Iku Smart Zigbee E27 LED with CCT & RGB",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000014Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LED9W-RGB-Z_8a43e1ec-6aa2-45c6-b9ce-94d4c4fa894e.jpg?v=1778649082"
  },
  {
    "sku": "A82211",
    "title": "Clinton Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Clinton-Table-Lamp-Mercator-9227_f111b50a-0c85-4ec2-a64d-631c44637857.jpg?v=1778649085"
  },
  {
    "sku": "MTBL070",
    "title": "Clyde Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTBL070_96c668b5-8dc4-49ea-840a-683051d54371.jpg?v=1778649089"
  },
  {
    "sku": "ML320",
    "title": "Cody Linkable IP65 20W LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cody-Linkable-IP65-20W-LED-Batten-Mercator-8809_2256578b-d707-496b-a9d0-fc7def59fbd4.jpg?v=1778649093"
  },
  {
    "sku": "ML340",
    "title": "Cody Linkable IP65 40W LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cody-Linkable-IP65-40W-LED-Batten-Mercator-9440_43561671-5097-40f4-b34a-85c16f197b36.jpg?v=1778649095"
  },
  {
    "sku": "MWL006BLK",
    "title": "Colby LED Round Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MWL006BLK_1f8ebd0d-dd83-4088-8f72-a8897395b745.jpg?v=1778649099"
  },
  {
    "sku": "FC1180134WH",
    "title": "Colombo 132cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/COLOMBO_52_DC_Series_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1180134WH_Hero_f44de36c-a75d-4368-894f-24d098c2c766.jpg?v=1778649104"
  },
  {
    "sku": "FC1188134WH",
    "title": "Colombo 132cm DC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/COLOMBO_52_DC_Series_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1188134WH_Hero_91442d8a-5704-465b-8b08-69bc4de30fdd.jpg?v=1778649155"
  },
  {
    "sku": "MTL011",
    "title": "Colton  Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Colton-Table-Lamp-Mercator-3494_5177ff62-4800-42e1-91cb-6a7cf092dccc.jpg?v=1778649210"
  },
  {
    "sku": "MTFL011",
    "title": "Colton 1 Light  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Colton-1-Light-Floor-Lamp-Mercator-8776_77be561e-c8e1-4743-8734-0f81c769ae5d.jpg?v=1778649215"
  },
  {
    "sku": "MLX610",
    "title": "Compact Digital Lux Meter Battery Operated",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Compact-Digital-Lux-Meter-Battery-Operated-Mercator-9669_a19bb1a9-7a0b-4335-b60e-db01aa657c80.jpg?v=1778649219"
  },
  {
    "sku": "MDCS01BLK",
    "title": "Compact Door Chime Hard Wired Kit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Compact-Door-Chime-Hard-Wired-Kit-Mercator-2698_6d12a49a-9505-48fc-a5be-42a67acc1bcc.jpg?v=1778649222"
  },
  {
    "sku": "MDCS02WHT",
    "title": "Compact Door Chime Hard Wired Kit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MDCS02WHT_d72bbbff-c9bb-4b7d-bc11-1c3cda447616.jpg?v=1778649227"
  },
  {
    "sku": "MEL001",
    "title": "Compact PIR Sensor 180 Degree Sensory",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Compact-PIR-Sensor-180-Degree-Sensory-Mercator-5342_242b734b-a1aa-4e97-a31b-62aa48cfb5b3.jpg?v=1778649231"
  },
  {
    "sku": "MPC627",
    "title": "Compact size 24 hour mechanical timer",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mechanical-Timer-24-Hour-Square-Mercator-9024_2be8aca3-c390-4249-932e-27c93b5c8092.jpg?v=1778649234"
  },
  {
    "sku": "MPLS003",
    "title": "Cono 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cono-1Lt-Pendant-Light-Mercator-4723_9d335187-6822-4e9f-b2fb-fcaa899bd154.jpg?v=1778649238"
  },
  {
    "sku": "MD5010WHT-3",
    "title": "Cooper 10W LED Surface Mounted 3000k Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cooper-10W-LED-Surface-Mounted-3000k-Downlight-Mercator-302_59a579f9-adb0-488c-86f6-85305352d8b9.jpg?v=1778649242"
  },
  {
    "sku": "MD5010BLK-4",
    "title": "Cooper 10W LED Surface Mounted 4000k Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cooper-10W-LED-Surface-Mounted-4000k-Downlight-Mercator-1176_1c5e2a3d-be95-463e-8b36-3a5b748d2f0d.jpg?v=1778649245"
  },
  {
    "sku": "FC190135BR",
    "title": "Cooya 132cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cooya-AC-Ceiling-Fan-Mercator-6938_c384c5c4-e4ac-4084-bd2d-927306e2b572.jpg?v=1778649250"
  },
  {
    "sku": "MF35315-CCT",
    "title": "Corvis II 15W 600mm LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Corvis-II-15W-600mm-LED-Batten-Mercator-9606_3ebcd65d-e92e-4630-83d5-4cf0d32306fa.jpg?v=1778649255"
  },
  {
    "sku": "MF35330-CCT",
    "title": "Corvis II 30W 1200mm LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Corvis-II-30W-1200mm-LED-Batten-Mercator-415_10b98fe5-3bc2-4690-bcfd-71a57dee3f38.jpg?v=1778649259"
  },
  {
    "sku": "A95092BLK",
    "title": "Cowley 9W GU10 Globe LED Track Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cowley-GU10-LED-Track-Light-Mercator-5900_37fde8cd-28c9-4031-848a-2d6142e20c90.jpg?v=1778649262"
  },
  {
    "sku": "MTBL008BLK",
    "title": "Cremini Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cremini-Table-Lamp-Mercator-2034_75052ca8-67d6-4ce2-a064-1b3974303321.jpg?v=1778649267"
  },
  {
    "sku": "MTBL008BRS",
    "title": "Cremini Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cremini-Table-Lamp-Mercator-2034_75052ca8-67d6-4ce2-a064-1b3974303321.jpg?v=1778649267"
  },
  {
    "sku": "MTBL008GRN",
    "title": "Cremini Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cremini-Table-Lamp-Mercator-2034_75052ca8-67d6-4ce2-a064-1b3974303321.jpg?v=1778649267"
  },
  {
    "sku": "MTBL008WHT",
    "title": "Cremini Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cremini-Table-Lamp-Mercator-2034_75052ca8-67d6-4ce2-a064-1b3974303321.jpg?v=1778649267"
  },
  {
    "sku": "MTBL008BLK",
    "title": "Cremini Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cremini-Table-Lamp-Mercator-2034_d93856c8-5ab7-49f0-8410-45f201f49b31.jpg?v=1778649279"
  },
  {
    "sku": "MX20120WHT",
    "title": "Crescent 20W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Crescent-20W-DIY-LED-Flood-Light-Mercator-4847_0d359ac7-23cf-43e9-bf5f-01024652c7c4.jpg?v=1778649294"
  },
  {
    "sku": "MX20120WHT-SEN",
    "title": "Crescent 20W DIY LED Flood Light with PIR Sensor and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Crescent-20W-DIY-LED-Flood-Light-with-PIR-Sensor-and-Remote-Mercator-5012_19d27602-5053-41c2-9faf-f33c925c4518.jpg?v=1778649298"
  },
  {
    "sku": "MX20130WHT-SEN",
    "title": "Crescent 30W DIY Sensor LED Flood Light with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Crescent-30W-DIY-Sensor-LED-Flood-Light-with-Remote-Mercator-9878_447cf08d-3981-40a9-a63e-a7b82f8886f3.jpg?v=1778649301"
  },
  {
    "sku": "MX20150BLK",
    "title": "Crescent 50W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Crescent-50W-DIY-LED-Flood-Light-Mercator-2629_9670120d-b673-4dc1-8300-446c50fe5349.jpg?v=1778649304"
  },
  {
    "sku": "MX20150WHT",
    "title": "Crescent 50W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Crescent-50W-DIY-LED-Flood-Light-Mercator-2629_9670120d-b673-4dc1-8300-446c50fe5349.jpg?v=1778649304"
  },
  {
    "sku": "MX20150WHT-SEN",
    "title": "Crescent 50W DIY LED Flood Light with PIR Sensor and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Crescent-50W-DIY-LED-Flood-Light-with-PIR-Sensor-and-Remote-Mercator-1986_16111c4d-775b-4468-b5c0-37ab813dd016.jpg?v=1778649307"
  },
  {
    "sku": "MX20130WHT",
    "title": "Crescent DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Crescent-DIY-LED-Flood-Light-Mercator-2000_1d48bb5f-c764-4c98-a350-6d477c5a6987.jpg?v=1778649312"
  },
  {
    "sku": "MD780W-CCT",
    "title": "Cruz 8W LED CCT Anti-Glare Deep Recessed Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cruz-8W-LED-CCT-Anti-Glare-Deep-Recessed-Downlight-Mercator-4632_7bd75f0d-7055-4da3-a790-c691ae799b12.jpg?v=1778649316"
  },
  {
    "sku": "MD780B-CCT",
    "title": "Cruz 8W LED CCT Anti-Glare Deep Recessed Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cruz-8W-LED-CCT-Anti-Glare-Deep-Recessed-Downlight-Mercator-4632_7bd75f0d-7055-4da3-a790-c691ae799b12.jpg?v=1778649316"
  },
  {
    "sku": "A44011T-BC",
    "title": "Cube Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cube-Table-Lamp-Mercator-9567_148e8bdd-9b14-41a8-bb63-80091171c36b.jpg?v=1778649319"
  },
  {
    "sku": "HF100120YE",
    "title": "Cubix 2000W Ceramic Fan Heater",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cubix-2000W-Ceramic-Fan-Heater-Mercator-40920753_8c89d670-9115-4935-aa1a-7e505002ff4c.jpg?v=1778649323"
  },
  {
    "sku": "HF100130YE",
    "title": "Cubix 3000W Ceramic Fan Heater",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cubix-3000W-Ceramic-Fan-Heater-Mercator-40920661_8d611359-0d3a-4280-b121-2dea61786004.jpg?v=1778649326"
  },
  {
    "sku": "MPLS503",
    "title": "Cullen 2Lt Pole for LED Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPLS503_jpg_63631608-f745-4f81-bce1-774e0d3306ed.jpg?v=1778649331"
  },
  {
    "sku": "MWL007WHT",
    "title": "Cyrus LED Square Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MWL007WHT_956d3a29-5955-43a8-a474-8e2d5033a027.jpg?v=1778649335"
  },
  {
    "sku": "MWL007BLK",
    "title": "Cyrus LED Square Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MWL007WHT_956d3a29-5955-43a8-a474-8e2d5033a027.jpg?v=1778649335"
  },
  {
    "sku": "MWL007WHT",
    "title": "Cyrus LED Square Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MWL007WHT_4b476727-3090-4e10-aa47-98272039915a.jpg?v=1778649338"
  },
  {
    "sku": "9E27LED32",
    "title": "D120 Decorative Globe Everest",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/D120-Decorative-Globe-Everest-Mercator-8592_81530c38-93e8-4589-adf3-8d41070a3230.jpg?v=1778649342"
  },
  {
    "sku": "9E27LED31",
    "title": "D120 Decorative Globe Within Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/D120-Decorative-Globe-Within-Globe-Mercator-687_7e3d0bfd-1a67-4ced-a2f9-cbc7770556df.jpg?v=1778649347"
  },
  {
    "sku": "MX4971BLK",
    "title": "Dakota DIY Shade",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dakota-DIY-Shade-Mercator-9805_c0ead42f-6d85-4b4e-96f9-9b9795469b69.jpg?v=1778649351"
  },
  {
    "sku": "MX106120",
    "title": "Damian 20W Slim LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Damian-20W-Slim-LED-Flood-Light-Mercator-4429_de9753f0-156c-4463-98ad-f99b4e8f9eed.jpg?v=1778649355"
  },
  {
    "sku": "MX106130",
    "title": "Damian 30W Slim LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Damian-30W-Slim-LED-Flood-Light-Mercator-1505_af389896-033f-442e-9b7a-442ec07939c1.jpg?v=1778649359"
  },
  {
    "sku": "MX106175",
    "title": "Damian 75W Slim LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Damian-75W-Slim-LED-Flood-Light-Mercator-8211_47e72015-342e-4192-83bd-a0a2aaa2b48f.jpg?v=1778649363"
  },
  {
    "sku": "MPLS514SMK-L",
    "title": "Darby 1Lt Light Large Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Darby-1Lt-Light-Large-Pendant-Mercator-8887_9a9409a9-1946-49ca-8bc4-931db37e74af.jpg?v=1778649366"
  },
  {
    "sku": "MPLS514CLR-S",
    "title": "Darby 1Lt Light Small Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Darby-1Lt-Light-Small-Pendant-Mercator-7288_5179996c-acba-4ad2-b269-936a1f31b09c.jpg?v=1778649371"
  },
  {
    "sku": "MPLS514SMK-S",
    "title": "Darby 1Lt Light Small Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Darby-1Lt-Light-Small-Pendant-Mercator-7288_5179996c-acba-4ad2-b269-936a1f31b09c.jpg?v=1778649371"
  },
  {
    "sku": "MXS4410",
    "title": "Defender 10W Solar LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Defender-10W-Solar-LED-Flood-Light-Mercator-1697_7d42f8a6-64aa-4d6d-ab36-4e6f9598520f.jpg?v=1778649374"
  },
  {
    "sku": "MXS4405",
    "title": "Defender 5W Solar LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Defender-5W-Solar-LED-Flood-Light-Mercator-9097_31530dd2-8c84-46c8-993a-e20af553dabc.jpg?v=1778649378"
  },
  {
    "sku": "BET002WH",
    "title": "Delay On/Off Timer for Exhaust fans with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BET002WH_6a1ace9b-27b1-4205-bc47-e829015c3ec9.jpg?v=1778649382"
  },
  {
    "sku": "BET001WH",
    "title": "Delay On/Off Timer for Exhaust fans without Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BET001WH_490895b2-248e-42d5-ad08-ce783efd9427.jpg?v=1778649387"
  },
  {
    "sku": "A18511BLK",
    "title": "Devo LED  Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Devo-LED-Table-Lamp-Mercator-5212_9243a16f-a4da-41e8-a34c-85f7a7dae161.jpg?v=1778649391"
  },
  {
    "sku": "9E27LED19DC",
    "title": "Diamond LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Diamond-LED-Globe-Mercator-2205_93197855-4fc1-43bd-9b43-f02360d9e476.jpg?v=1778649403"
  },
  {
    "sku": "MD666B-TRI",
    "title": "Diaz 12W Tri-Colour Surface Mount Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Diaz-12W-Tri-Colour-Surface-Mount-Downlight-Mercator-3577_846f62ce-c6f3-43af-9bda-25b3f850f4ec.jpg?v=1778649408"
  },
  {
    "sku": "MD666TB-TRI",
    "title": "Diaz 24W Tri-Colour Twin Head Surface Mount Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Diaz-24W-Tri-Colour-Twin-Head-Surface-Mount-Downlight-Mercator-1644_e98cadf6-8fd4-46cd-a369-90b8c5ba0f50.jpg?v=1778649413"
  },
  {
    "sku": "MPLS507SMK",
    "title": "Dixie 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dixie-1Lt-Pendant-Light-Mercator-9987_adddcc03-1763-40b0-a170-94225b0b7e0d.jpg?v=1778649416"
  },
  {
    "sku": "BH161ESWBK",
    "title": "Domini 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Domini-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-CCT-LED-Light-Mercator-40920237_3d1e1e2e-0812-4fbb-a2dd-58c6009bd1f9.jpg?v=1778649421"
  },
  {
    "sku": "BH161ESWSL",
    "title": "Domini 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Domini-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-CCT-LED-Light-Mercator-40920237_3d1e1e2e-0812-4fbb-a2dd-58c6009bd1f9.jpg?v=1778649421"
  },
  {
    "sku": "BH161ESWWH",
    "title": "Domini 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Domini-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-CCT-LED-Light-Mercator-40920237_3d1e1e2e-0812-4fbb-a2dd-58c6009bd1f9.jpg?v=1778649421"
  },
  {
    "sku": "BH161ESWBK",
    "title": "Domini 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Domini-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-CCT-LED-Light-Mercator-40920237_2d66ba98-4896-4c66-bd6a-69d212aff5f6.jpg?v=1778649442"
  },
  {
    "sku": "BH161ESWWH",
    "title": "Domini 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Domini-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-CCT-LED-Light-Mercator-40920237_2d66ba98-4896-4c66-bd6a-69d212aff5f6.jpg?v=1778649442"
  },
  {
    "sku": "BH152ESWWH",
    "title": "Domino 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Domino-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-CCT-LED-Light-Mercator-40920078_1cefb17c-eda9-485a-90e6-92dea9801eec.jpg?v=1778649451"
  },
  {
    "sku": "BH152ESWBK",
    "title": "Domino 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Domino-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-CCT-LED-Light-Mercator-40920078_1cefb17c-eda9-485a-90e6-92dea9801eec.jpg?v=1778649451"
  },
  {
    "sku": "BH252ESWWH",
    "title": "Domino Duo 3-in-1 Bathroom Heater with Dual Heat Lamps",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mercator_Domino_Duo_BH252ESWWH_A4_Flyer_OL_Digital_8a235b7b-4eba-461c-850d-96b57ced2120.pdf?v=1790747503",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BH252ESWWH.webp?v=1780547976"
  },
  {
    "sku": "SMD9300",
    "title": "Donovan 36W Edge Lit Smart Zigbee Panel Light CCT Changeable",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD9300_a5874da4-8eda-4f3f-8fd8-bed478acaa98.jpg?v=1778649463"
  },
  {
    "sku": "MPP02GWE",
    "title": "Double Power Point with Wi-Fi Extender",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPP02GWE_5c73f426-6f85-4a41-a95e-66c41d558f79.jpg?v=1778649466"
  },
  {
    "sku": "FD476180WH",
    "title": "Downrod 1800mm for Rhino 6B 210cm DC Motor Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD476180WH_0fa62918-bade-4658-be38-c77cc8fc0ca9.jpg?v=1778649470"
  },
  {
    "sku": "FD250600WH",
    "title": "Downrod 600mm for Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD250600WH_965a7d82-3a1d-43f1-ad76-c99c9b7fa1db.jpg?v=1778649475"
  },
  {
    "sku": "FD250600BK",
    "title": "Downrod 600mm for Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD250600WH_965a7d82-3a1d-43f1-ad76-c99c9b7fa1db.jpg?v=1778649475"
  },
  {
    "sku": "FD250600BS",
    "title": "Downrod 600mm for Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD250600WH_965a7d82-3a1d-43f1-ad76-c99c9b7fa1db.jpg?v=1778649475"
  },
  {
    "sku": "FD360600BK",
    "title": "Downrod 600mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360600BK_fc4669d1-4965-47f6-95d7-42280c08fbe7.jpg?v=1778649482"
  },
  {
    "sku": "FD360600WH",
    "title": "Downrod 600mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360600BK_fc4669d1-4965-47f6-95d7-42280c08fbe7.jpg?v=1778649482"
  },
  {
    "sku": "FD360600RB",
    "title": "Downrod 600mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360600BK_fc4669d1-4965-47f6-95d7-42280c08fbe7.jpg?v=1778649482"
  },
  {
    "sku": "FD360600BC",
    "title": "Downrod 600mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360600BK_fc4669d1-4965-47f6-95d7-42280c08fbe7.jpg?v=1778649482"
  },
  {
    "sku": "FD360600BZ",
    "title": "Downrod 600mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360600BK_fc4669d1-4965-47f6-95d7-42280c08fbe7.jpg?v=1778649482"
  },
  {
    "sku": "FD250900WH",
    "title": "Downrod 900mm for Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD250900WH_700e1928-39c3-4486-b0dd-df7ff6e5a679.jpg?v=1778649486"
  },
  {
    "sku": "FD250900BS",
    "title": "Downrod 900mm for Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD250900WH_700e1928-39c3-4486-b0dd-df7ff6e5a679.jpg?v=1778649486"
  },
  {
    "sku": "FD250900BK",
    "title": "Downrod 900mm for Caprice 132cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD250900WH_700e1928-39c3-4486-b0dd-df7ff6e5a679.jpg?v=1778649486"
  },
  {
    "sku": "FD360900BK",
    "title": "Downrod 900mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360900BK_93ffac24-cad0-4cbc-9f3c-88003b22b5e1.jpg?v=1778649493"
  },
  {
    "sku": "FD360900WH",
    "title": "Downrod 900mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360900BK_93ffac24-cad0-4cbc-9f3c-88003b22b5e1.jpg?v=1778649493"
  },
  {
    "sku": "FD360900RB",
    "title": "Downrod 900mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360900BK_93ffac24-cad0-4cbc-9f3c-88003b22b5e1.jpg?v=1778649493"
  },
  {
    "sku": "FD360900BC",
    "title": "Downrod 900mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360900BK_93ffac24-cad0-4cbc-9f3c-88003b22b5e1.jpg?v=1778649493"
  },
  {
    "sku": "FD360900BZ",
    "title": "Downrod 900mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD360900BK_93ffac24-cad0-4cbc-9f3c-88003b22b5e1.jpg?v=1778649493"
  },
  {
    "sku": "FD476090WH",
    "title": "Downrod 900mm for Rhino 6B 210cm DC Motor Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FD476090WH.jpg?v=1778649498"
  },
  {
    "sku": "MD1571BC",
    "title": "Duna 1 Light Round DIY Batten Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Duna-1-Light-Round-DIY-Fixture-Mercator-7358_7e9667a4-faee-4e2d-8309-7c7bb83eeefa.jpg?v=1778649502"
  },
  {
    "sku": "FC570133BC",
    "title": "Duxton 130cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC570133BC_f4df9ecf-0560-4128-afaf-2a4448b30715.jpg?v=1778649505"
  },
  {
    "sku": "A19421BLK",
    "title": "Dylan LED Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dylan-LED-Floor-Lamp-Mercator-6768_f743c7e6-2e27-4cd4-a792-860250343eb8.jpg?v=1778649510"
  },
  {
    "sku": "A19421WHT",
    "title": "Dylan LED Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dylan-LED-Floor-Lamp-Mercator-6768_f743c7e6-2e27-4cd4-a792-860250343eb8.jpg?v=1778649510"
  },
  {
    "sku": "A19421AB",
    "title": "Dylan LED Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dylan-LED-Floor-Lamp-Mercator-6768_f743c7e6-2e27-4cd4-a792-860250343eb8.jpg?v=1778649510"
  },
  {
    "sku": "A19411BLK",
    "title": "Dylan LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dylan-LED-Table-Lamp-Mercator-1978_13f1d0d1-7d8f-41ed-b067-b02ba275f7af.jpg?v=1778649514"
  },
  {
    "sku": "A19411CHY",
    "title": "Dylan LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dylan-LED-Table-Lamp-Mercator-1978_13f1d0d1-7d8f-41ed-b067-b02ba275f7af.jpg?v=1778649514"
  },
  {
    "sku": "A19411CHY",
    "title": "Dylan LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Dylan-LED-Table-Lamp-Mercator-6718_7239c780-0762-4913-b95a-b18e21504e68.jpg?v=1778649519"
  },
  {
    "sku": "FC368143BB",
    "title": "Eagle 141cm DC Ceiling Fans with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368143BB_fad70625-1712-4d94-8e3d-1bc385d0bf53.jpg?v=1778649524"
  },
  {
    "sku": "FC368143GR",
    "title": "Eagle 141cm DC Ceiling Fans with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368143BB_fad70625-1712-4d94-8e3d-1bc385d0bf53.jpg?v=1778649524"
  },
  {
    "sku": "FC368143WH",
    "title": "Eagle 141cm DC Ceiling Fans with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368143BB_fad70625-1712-4d94-8e3d-1bc385d0bf53.jpg?v=1778649524"
  },
  {
    "sku": "FC368143RB",
    "title": "Eagle 141cm DC Ceiling Fans with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368143BB_fad70625-1712-4d94-8e3d-1bc385d0bf53.jpg?v=1778649524"
  },
  {
    "sku": "FC360143BB",
    "title": "Eagle II 141cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eagle-DC-Ceiling-Fan-with-Remote-Mercator-9236_2183f9bd-e7a8-4223-aab8-db46c9ba0cc2.jpg?v=1778649530"
  },
  {
    "sku": "FC360143RB",
    "title": "Eagle II 141cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eagle-DC-Ceiling-Fan-with-Remote-Mercator-9236_2183f9bd-e7a8-4223-aab8-db46c9ba0cc2.jpg?v=1778649530"
  },
  {
    "sku": "FC360123BB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC360123BB_4aa72a0e-553c-418a-ad22-a966ce11aba3.jpg?v=1778649535"
  },
  {
    "sku": "FC360123RB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC360123BB_4aa72a0e-553c-418a-ad22-a966ce11aba3.jpg?v=1778649535"
  },
  {
    "sku": "FC360123WH",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC360123BB_4aa72a0e-553c-418a-ad22-a966ce11aba3.jpg?v=1778649535"
  },
  {
    "sku": "FC360123BB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC360123BB_c7700378-8548-4ce1-912f-ee0347f3b8b9.jpg?v=1778649539"
  },
  {
    "sku": "FC360123RB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC360123BB_c7700378-8548-4ce1-912f-ee0347f3b8b9.jpg?v=1778649539"
  },
  {
    "sku": "FC368123BB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368123BB_0207779e-f326-46b4-a63e-312862c6e172.jpg?v=1778649543"
  },
  {
    "sku": "FC368123RB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368123BB_0207779e-f326-46b4-a63e-312862c6e172.jpg?v=1778649543"
  },
  {
    "sku": "FC368123BB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368123BB_f70bd3ba-a712-41c1-b287-9f1fcacb6edd.jpg?v=1778649548"
  },
  {
    "sku": "FC368123RB",
    "title": "Eagle II Lite 122cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368123BB_f70bd3ba-a712-41c1-b287-9f1fcacb6edd.jpg?v=1778649548"
  },
  {
    "sku": "FC360143RB",
    "title": "Eagle II Oil Rubbed Bronze 141cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eagle-DC-Ceiling-Fan-with-Remote-Mercator-6356_23b8cf83-77a5-4517-af56-33d9c726b749.jpg?v=1778649530"
  },
  {
    "sku": "FC360163BB",
    "title": "Eagle II XL 168cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eagle-XL-DC-Ceiling-Fan-with-Remote-Mercator-4866_041c39b4-4c11-4e6b-b655-c8e725064727.jpg?v=1778649551"
  },
  {
    "sku": "FC360163WH",
    "title": "Eagle II XL 168cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eagle-XL-DC-Ceiling-Fan-with-Remote-Mercator-4715_de3b54dd-f73e-440b-9730-572dcb0b08ef.jpg?v=1778649555"
  },
  {
    "sku": "FC360163BB",
    "title": "Eagle II XL 168cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eagle-XL-DC-Ceiling-Fan-with-Remote-Mercator-4715_de3b54dd-f73e-440b-9730-572dcb0b08ef.jpg?v=1778649555"
  },
  {
    "sku": "FC368163BB",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163BB_2abc085c-06fd-45b6-8e8d-701e7230ce3f.jpg?v=1778649559"
  },
  {
    "sku": "FC368163GR",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163BB_2abc085c-06fd-45b6-8e8d-701e7230ce3f.jpg?v=1778649559"
  },
  {
    "sku": "FC368163GR",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163GR_597953c8-0001-4a9c-99e2-34c5491a47f6.jpg?v=1778649559"
  },
  {
    "sku": "FC368163GR",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163GR_597953c8-0001-4a9c-99e2-34c5491a47f6.jpg?v=1778649559"
  },
  {
    "sku": "FC368163RB",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163RB_167f27dc-2a01-440f-bb55-29f89c5564cf.jpg?v=1778649565"
  },
  {
    "sku": "FC368163WH",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163RB_167f27dc-2a01-440f-bb55-29f89c5564cf.jpg?v=1778649565"
  },
  {
    "sku": "FC368163BB",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163RB_167f27dc-2a01-440f-bb55-29f89c5564cf.jpg?v=1778649565"
  },
  {
    "sku": "FC368163GR",
    "title": "Eagle XL 168cm DC Ceiling Fan with LED Light and Remote (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC368163RB_167f27dc-2a01-440f-bb55-29f89c5564cf.jpg?v=1778649565"
  },
  {
    "sku": "MXD1817L",
    "title": "Eastwood Large 7W LED Exterior Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eastwood-Large-7W-LED-Exterior-Wall-Light-Mercator-5161_75badfc4-db25-489b-9007-f00f81191382.jpg?v=1778649569"
  },
  {
    "sku": "A33511WHT",
    "title": "Eddie Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eddie-Table-Lamp-Mercator-7986_f8241ec9-59fb-439f-9b83-01d76fcddb87.jpg?v=1778649572"
  },
  {
    "sku": "MPLS510SMK",
    "title": "Eden 1Lt Light  Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eden-1Lt-Light-Pendant-Mercator-5407_728f4055-5ee8-4bde-9ca1-90357010e580.jpg?v=1778649575"
  },
  {
    "sku": "MTBL040",
    "title": "Edinburgh Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Edinburgh-Table-Lamp-Mercator-7580_cf41c101-53c9-4f09-b04c-d524e8eb401f.jpg?v=1778649578"
  },
  {
    "sku": "MPL506BRS",
    "title": "Edith 1Lt  Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Edith-1Lt-Pendant-Light-Mercator-8163_b1bb842b-0ba4-496b-95bf-afe74f9e8f0a.jpg?v=1778649581"
  },
  {
    "sku": "AUL042BLK",
    "title": "Edithvale Decorative Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL042BLK_d2f39e29-accc-4ef7-b17c-4c6355953440.jpg?v=1778649585"
  },
  {
    "sku": "FC1160133WH",
    "title": "Edrington 132cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1160133WH_4596a7dc-64a1-4d5b-a0ad-ce5166e24a58.jpg?v=1778649591"
  },
  {
    "sku": "FC1168133WH",
    "title": "Edrington 132cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1168133WH_a80bd701-42fa-42c4-959c-91f4349b162a.jpg?v=1778649617"
  },
  {
    "sku": "FC1160093WH",
    "title": "Edrington Mini 91cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1160093WH_1_a8b5fc8e-71d9-4b7b-9e2a-ab9b707f1c5a.jpg?v=1778649645"
  },
  {
    "sku": "FC1168093WH",
    "title": "Edrington Mini 91cm AC LED Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC1168093WH_5eeb43a6-01d0-43a4-b6e6-141d1bba7d6a.jpg?v=1778649669"
  },
  {
    "sku": "MD4106W-CCT",
    "title": "Eko 6W 70mm LED 3CCT Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eko-6W-70mm-LED-3CCT-Downlight-Mercator-7568_92d94b65-ed6a-4930-9803-e6b613a7a7fd.jpg?v=1778649694"
  },
  {
    "sku": "MD4212W-CCT",
    "title": "Eko-120 12W 120mm LED 3CCT Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eko-120-12W-120mm-LED-3CCT-Downlight-Mercator-2292_d010fa10-fbec-4bc3-8f68-301f088c9379.jpg?v=1778649697"
  },
  {
    "sku": "MD4209W-CCT",
    "title": "Eko-2 9W 90mm 3CCT LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eko-2-9W-90mm-3CCT-LED-Downlight-Mercator-3214_9877febe-c868-483d-a317-0eaf2d1dc0d6.jpg?v=1778649700"
  },
  {
    "sku": "MD4209WP10",
    "title": "Eko-2 9W 90mm 3CCT LED Downlight With Plug Base - 10 Pack",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eko-2-9W-90mm-3CCT-LED-Downlight-With-Plug-Base-10-Pack-Mercator-1965_c7d3db00-a188-43d0-8d89-a1fb4abb04a7.jpg?v=1778649705"
  },
  {
    "sku": "MXW1012",
    "title": "Elaine Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Elaine-Wall-Light-Mercator-859_fb8c5a0b-1280-45f9-94a5-91ed26be9340.jpg?v=1778649717"
  },
  {
    "sku": "MXW1010",
    "title": "Elan Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Elan-Wall-Light-Mercator-285_813dea99-258e-4738-b85e-fe3906fbdf51.jpg?v=1778649720"
  },
  {
    "sku": "MXW1020",
    "title": "Eleanor Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eleanor-Wall-Light-Mercator-6146_2722bbc3-6e52-40db-b556-c8e66ad73888.jpg?v=1778649724"
  },
  {
    "sku": "MD595W-CCT",
    "title": "Elias 12W LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Elias-12W-LED-Downlight-Mercator-6329_0c5bc975-8038-4a47-8d0b-9503e58db9f9.jpg?v=1778649737"
  },
  {
    "sku": "MD595B-CCT",
    "title": "Elias 12W LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Elias-12W-LED-Downlight-Mercator-6329_0c5bc975-8038-4a47-8d0b-9503e58db9f9.jpg?v=1778649737"
  },
  {
    "sku": "MXD1020",
    "title": "Elise 10W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Elise-10W-LED-Up-Down-Wall-Light-Mercator-3548_653c4535-d4e3-4d17-a4bc-af3466d5263f.jpg?v=1778649741"
  },
  {
    "sku": "MXD1021",
    "title": "Elise 18W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Elise-18W-LED-Up-Down-Wall-Light-Mercator-7574_b7efb0e3-320c-4b98-a23a-24ad1c8746a7.jpg?v=1778649745"
  },
  {
    "sku": "MXD1030",
    "title": "Eliza II 11W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eliza-II-16W-LED-Wall-Light-Mercator-7122_78805ad5-c3bf-4069-ad08-63c61a731564.jpg?v=1778649749"
  },
  {
    "sku": "MXD1032",
    "title": "Eliza II 11W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eliza-II-16W-LED-Wall-Light-Mercator-7122_78805ad5-c3bf-4069-ad08-63c61a731564.jpg?v=1778649749"
  },
  {
    "sku": "MXD1033",
    "title": "Eliza II 8W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eliza-II-8W-LED-Wall-Light-Mercator-9163_bcbf626d-c386-4c18-bf51-2d4f4f983dae.jpg?v=1778649754"
  },
  {
    "sku": "MXD1031",
    "title": "Eliza II 8W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eliza-II-8W-LED-Wall-Light-Mercator-9163_bcbf626d-c386-4c18-bf51-2d4f4f983dae.jpg?v=1778649754"
  },
  {
    "sku": "MTBL003",
    "title": "Ellie Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ellie-Table-Lamp-Mercator-3730_5b14a8fe-6e52-4a5e-a03b-213ed800a5b5.jpg?v=1778649757"
  },
  {
    "sku": "A46111NVY",
    "title": "Elliot Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Elliot-Table-Lamp-Mercator-5996_cadcccb5-dc33-4baa-9404-f15833b8a1a6.jpg?v=1778649761"
  },
  {
    "sku": "MTBL058GRN",
    "title": "Elric Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTBL058GRN_1_e7f5df51-49e6-494e-b631-856ffef1b0ce.jpg?v=1778649766"
  },
  {
    "sku": "BE350ESPWH",
    "title": "Emeline II Large Round Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emeline-II-Large-Round-Exhaust-Fan-with-LED-Light-Mercator-2205_7bfc5fa0-0402-4245-a5d6-31b819ebc970.jpg?v=1778649770"
  },
  {
    "sku": "BE330ESPBK",
    "title": "Emeline II Large Square Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emeline-II-Large-Square-Exhaust-Fan-with-LED-Light-Mercator-3299_905a23b3-7500-4289-be29-f26a0f54931b.jpg?v=1778649774"
  },
  {
    "sku": "BE330ESPWH",
    "title": "Emeline II Large Square Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emeline-II-Large-Square-Exhaust-Fan-with-LED-Light-Mercator-3299_905a23b3-7500-4289-be29-f26a0f54931b.jpg?v=1778649774"
  },
  {
    "sku": "BE340ESPWH",
    "title": "Emeline II Small Round Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE340ESPWH_e1fdb91f-1eba-4f48-a55c-a12b6a0d234b.jpg?v=1778649778"
  },
  {
    "sku": "BE320ESPWH",
    "title": "Emeline II Small Square Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emeline-II-Small-Square-Exhaust-Fan-with-LED-Light-Mercator-8565_0089caa8-70c9-412d-bb7c-07972165f0fe.jpg?v=1778649782"
  },
  {
    "sku": "A42822BRS",
    "title": "Emilia 2 Light Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emilia-2-Light-Floor-Lamp-Mercator-331_a5e7f64e-b521-425a-a635-fafb8f832184.jpg?v=1778649785"
  },
  {
    "sku": "A42822BLK",
    "title": "Emilia 2 Light Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emilia-2-Light-Floor-Lamp-Mercator-331_a5e7f64e-b521-425a-a635-fafb8f832184.jpg?v=1778649785"
  },
  {
    "sku": "MXW1011",
    "title": "Emilia Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emilia-Wall-Light-Mercator-5069_28b182c8-4e0e-4ae6-b3e2-088dd90e604d.jpg?v=1778649789"
  },
  {
    "sku": "A10933RBLK",
    "title": "Emily 3 Head Industrial Round Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emily-3Lt-Industrial-Round-Spotlight-Mercator-6858_7ad6aa38-c2f7-44e8-9197-76e3a46aa76c.jpg?v=1778649792"
  },
  {
    "sku": "A10933BLK",
    "title": "Emily 3 Head Industrial Straight Bar Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emily-3Lt-Industrial-Straight-Bar-Spotlight-Mercator-8196_6c9a4ec9-7f45-4a59-aa84-564753106c3c.jpg?v=1778649797"
  },
  {
    "sku": "A10931BLK",
    "title": "Emily 4W LED Industrial Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emily-1-Lt-Industrial-Spotlight-Mercator-3385_f716f074-3535-43fd-9b34-89eb791042af.jpg?v=1778649802"
  },
  {
    "sku": "MXW1060",
    "title": "Emma LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Emma-LED-Wall-Light-Mercator-5924_91949eca-076c-4ede-9ed8-e2e1eb4e0b55.jpg?v=1778649806"
  },
  {
    "sku": "MSL213",
    "title": "Epsilon II 2000lm Solar Streetlight with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Epsilon-II-2000lm-Solar-Streetlight-with-Remote-Mercator-5943_ea0a399d-3613-4ab5-8ec2-bfa0b6453cdc.jpg?v=1778649810"
  },
  {
    "sku": "MSL215",
    "title": "Epsilon II 3600lm Solar Streetlight with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Epsilon-II-3600lm-Solar-Streetlight-with-Remote-Mercator-983_e13c72bc-0049-4f48-bed5-294f298f45c4.jpg?v=1778649814"
  },
  {
    "sku": "MD455S-CCT",
    "title": "Equinox 3 14W  3CCT LED Gimbal LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD455S-CCT_b9208110-3039-47fc-9d87-25ba7c3fdb33.jpg?v=1778649819"
  },
  {
    "sku": "MD455W-CCT",
    "title": "Equinox 3 14W  3CCT LED Gimbal LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD455S-CCT_b9208110-3039-47fc-9d87-25ba7c3fdb33.jpg?v=1778649819"
  },
  {
    "sku": "MD450S-CCT",
    "title": "Equinox III 16W LED Fixed Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Equinox-3-16W-LED-Fixed-Downlight-Mercator-1194_208f9811-f61d-432c-a2ab-d55ccc1463c9.jpg?v=1778649824"
  },
  {
    "sku": "MXW1021",
    "title": "Erika Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Erika-Wall-Light-Mercator-6820_75144414-c5a6-4a1b-b37c-e45d2389daae.jpg?v=1778649828"
  },
  {
    "sku": "MD8213CCT",
    "title": "Esta 13W Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Esta-13W-Downlight-Mercator-3244_46252673-f983-4dd8-a081-330a5563eb3b.jpg?v=1778649832"
  },
  {
    "sku": "MD8215CCT",
    "title": "Esta 15W Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Esta-15W-Downlight-Mercator-8681_5a5c5a2e-8b39-4271-85cd-9aca6e4ec3af.jpg?v=1778649835"
  },
  {
    "sku": "MD8220CCT",
    "title": "Esta 20W Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Esta-20W-Downlight-Mercator-7945_1e8d62ed-7326-4fff-8332-06793a4bb046.jpg?v=1778649838"
  },
  {
    "sku": "MD8209CCT",
    "title": "Esta 9W Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Esta-9W-Downlight-Mercator-8717.jpg?v=1778649843"
  },
  {
    "sku": "MXW1013",
    "title": "Eva Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eva-Wall-Light-Mercator-9135_27867f1f-390d-4ada-8bc3-a75db44eebcc.jpg?v=1778649847"
  },
  {
    "sku": "MX1611GT",
    "title": "Eve Exterior Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Eve-Exterior-Wall-Light-Mercator-354_f052c7f7-3547-44aa-8f8d-d78b0f89e560.jpg?v=1778649851"
  },
  {
    "sku": "MXD1010",
    "title": "Evora 10W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Evora-10W-LED-Up-Down-Wall-Light-Mercator-4445_d27152b5-5ccb-4ebb-b4f4-d1e751cd46b4.jpg?v=1778649855"
  },
  {
    "sku": "MXD1011",
    "title": "Evora 18W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Evora-18W-LED-Up-Down-Wall-Light-Mercator-8908_496593ae-9555-4f47-96f7-48c8c2402dc6.jpg?v=1778649858"
  },
  {
    "sku": "MTBL045",
    "title": "Fabian Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fabian-Table-Lamp-Mercator-6393_555b52ab-d44e-4e9c-92f4-8c9ded864f5a.jpg?v=1778649865"
  },
  {
    "sku": "MTBL035",
    "title": "Fairfield Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fairfield-Table-Lamp-Mercator-1036_6ebd9cdc-fbc0-4c7a-ad92-990a6c386cea.jpg?v=1778649869"
  },
  {
    "sku": "MPLS519AB",
    "title": "Fallon 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fallon-1Lt-Pendant-Light-Mercator-9578_a88f3b17-62f3-488a-98d5-a1fc2ba0ee35.jpg?v=1778649874"
  },
  {
    "sku": "MPLS519BC",
    "title": "Fallon 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fallon-1Lt-Pendant-Light-Mercator-9578_a88f3b17-62f3-488a-98d5-a1fc2ba0ee35.jpg?v=1778649874"
  },
  {
    "sku": "MPLS519BC",
    "title": "Fallon 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fallon-1Lt-Pendant-Light-Mercator-4953_313f8d07-69df-4185-bcb3-4ad5b1174276.jpg?v=1778649877"
  },
  {
    "sku": "MGL062WSB-D",
    "title": "Fancy Round 3000K B15 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fancy-3000K-B15-Round-LED-Globe-Mercator-252_8f398c3d-ed90-4c71-8f32-99a2e6442af6.jpg?v=1778649880"
  },
  {
    "sku": "MGL062WSE-D",
    "title": "Fancy Round 3000K E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fancy-3000K-E14-Round-LED-Globe-Mercator-6298_c8a9aa26-b84e-4071-bd4f-728bfc1ab202.jpg?v=1778649885"
  },
  {
    "sku": "MGL062DSB-D",
    "title": "Fancy Round 5700K B15 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fancy-5700K-B15-Round-LED-Globe-Mercator-2228_a63aa9ef-590d-4261-8597-8405e775b903.jpg?v=1778649889"
  },
  {
    "sku": "MGL062DSE-D",
    "title": "Fancy Round 5700K E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fancy-5700K-E14-Round-LED-Globe-Mercator-2751_ea901a4b-f837-4bf2-b66a-0948a4958417.jpg?v=1778649893"
  },
  {
    "sku": "9E14LED13",
    "title": "Fancy Round Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fancy-Round-Filament-Globe-Mercator-7874_375524f0-e704-4bb9-89eb-b5fc737fd551.jpg?v=1778649897"
  },
  {
    "sku": "S9B15LED13",
    "title": "Fancy Round Iku Smart Wi-Fi B15 LED Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B15LED13_20779a32-1c93-4045-8847-3387c255279e.jpg?v=1778649902"
  },
  {
    "sku": "S9E14LED13",
    "title": "Fancy Round Iku Smart Wi-Fi E14 LED Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E14LED13_861dbba7-25f6-44e8-806f-2254b66f6ec6.jpg?v=1778649906"
  },
  {
    "sku": "S9B15LED13-ZB",
    "title": "Fancy Round Iku Smart Zigbee B15 LED Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9B15LED13-ZB_c6c01782-bef6-4682-a287-7984dc99ad44.jpg?v=1778649910"
  },
  {
    "sku": "S9E14LED13-ZB",
    "title": "Fancy Round Iku Smart Zigbee E14 LED Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000017Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E14LED13-ZB_dc5da72c-65a0-4cfc-b569-4a5c582e54a0.jpg?v=1778649914"
  },
  {
    "sku": "A57211",
    "title": "Farrow Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Farrow-Table-Lamp-Mercator-885_5f5150d4-6732-4f20-8bd1-4029538af402.jpg?v=1778649919"
  },
  {
    "sku": "XBH1521WH",
    "title": "FASCIA COMPLETE DOMINO CCT LED",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XBH1611WH",
    "title": "FASCIA COMPLETE FOR DOMINI WH",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "MPLS016BLK",
    "title": "Fawkner 1Lt  Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fawkner-1Lt-Light-Pendant-Mercator-3207_20f07f48-296c-4953-985d-71fdd2826503.jpg?v=1778649923"
  },
  {
    "sku": "MPLS511BLK-L",
    "title": "Felton 1Lt Light Large Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Felton-1Lt-Light-Large-Pendant-Mercator-3582_c3fdf319-6223-4521-af8c-119ff1e07270.jpg?v=1778649928"
  },
  {
    "sku": "MPLS511BLK-S",
    "title": "Felton 1Lt Light Small Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Feton-1Lt-Light-Small-Pendant-Mercator-4531_c6dbe6f2-2576-4c82-a10f-4cdbe43d072b.jpg?v=1778649932"
  },
  {
    "sku": "MPLS511WHT-S",
    "title": "Felton 1Lt Light Small Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Feton-1Lt-Light-Small-Pendant-Mercator-4531_c6dbe6f2-2576-4c82-a10f-4cdbe43d072b.jpg?v=1778649932"
  },
  {
    "sku": "MLVA001WH",
    "title": "Festoon LED String Lights-10 Pack",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Festoon-LED-String-Lights-10-Pack-Mercator-8126_74da1d78-fb68-4d6a-aa22-bb420dbb407d.jpg?v=1778649935"
  },
  {
    "sku": "MLVA001WH",
    "title": "Festoon Light 10 Pack Warm White",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "ML7224WHT",
    "title": "Fitzgerald 1Lt LED Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fitzgerald-1Lt-LED-Pendant-Light-Mercator-6898_08bb3562-bf8b-4558-97b9-78c5e3d380c6.jpg?v=1778649940"
  },
  {
    "sku": "ML7224WHT",
    "title": "Fitzgerald 1Lt LED Pendant Light (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fitzgerald-1Lt-LED-Pendant-Light-Mercator-6898_9ecb87c5-0eca-4784-8919-ca1b09ccdef6.jpg?v=1778649945"
  },
  {
    "sku": "MTFL036",
    "title": "Flemington Pleated Shade Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Flemington-Pleated-Shade-Floor-Lamp-Mercator-3816_dc2716c0-0fb3-4fb1-9cd3-49e731d4098e.jpg?v=1778649948"
  },
  {
    "sku": "MTBL036",
    "title": "Flemington Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Flemington-Table-Lamp-Mercator-7230_f126c67c-02af-4124-8d67-cc8742e84277.jpg?v=1778649951"
  },
  {
    "sku": "MX1210O-CCT-SEN",
    "title": "Fletcher II Oval LED Bunker Light with Sensor and CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MX1210O-CCT-SEN_1_63f9ca50-a4e3-4608-acc4-68b7466d5f2d.jpg?v=1778649955"
  },
  {
    "sku": "MX1210O-CCT",
    "title": "Fletcher II Oval LED CCT Bunker Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MX1210O-CCT_23227715-2850-4ebc-bc30-13fe43bb5a27.jpg?v=1778649959"
  },
  {
    "sku": "MX1210R-CCT-SEN",
    "title": "Fletcher II Round LED Bunker Light with Sensor and CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MX1210R-CCT-SEN_1_d9be6108-cf2b-44c2-93f0-8f3f66df93fa.jpg?v=1778649962"
  },
  {
    "sku": "MX1210R-CCT",
    "title": "Fletcher II Round LED CCT Bunker Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MX1210R-CCT_da3838c0-076b-415c-abc7-02ee62db77c7.jpg?v=1778649966"
  },
  {
    "sku": "MX1210O",
    "title": "Fletcher Oval LED Bunker Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fletcher-Oval-LED-Bunker-Light-Mercator-40919346_46d6026c-c0e8-418a-9555-a23983afb76b.jpg?v=1778649970"
  },
  {
    "sku": "MX1210O-SEN",
    "title": "Fletcher Oval LED Bunker Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fletcher-Oval-LED-Bunker-Light-with-Sensor-Mercator-40919633_edbf3b68-9d17-44a5-a667-a5adb7793162.jpg?v=1778649973"
  },
  {
    "sku": "MX1210R",
    "title": "Fletcher Round LED Bunker Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fletcher-Round-LED-Bunker-Light-Mercator-40919270_1adfaba3-251b-49d6-b052-035f91d6587f.jpg?v=1778649976"
  },
  {
    "sku": "MX1210R-SEN",
    "title": "Fletcher Round LED Bunker Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fletcher-Round-LED-Bunker-Light-with-Sensor-Mercator-40919747_9487d548-df55-43bd-b6bb-66ad65023eee.jpg?v=1778649979"
  },
  {
    "sku": "A18711BLK",
    "title": "Flick LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Flick-LED-Table-Lamp-Mercator-4004_81402241-e87a-4406-a94d-3abb796a38c0.jpg?v=1778649983"
  },
  {
    "sku": "AUL1075BLK",
    "title": "Flick LED Task lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1075BLK_e823250c-e8f2-435d-bdd8-3507ef073a02.jpg?v=1778649987"
  },
  {
    "sku": "SMI7040",
    "title": "Ford Batten Light Zigbee",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000001Z_Data_Sheet.pdf?v=1776418650",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005688_Pairing_Guide.pdf?v=1776418627",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ford-Batten-Light-Zigbee-Mercator-3723_5733c322-e026-40e1-974b-80b6ce504170.jpg?v=1778649990"
  },
  {
    "sku": "SMI7040-WIFI",
    "title": "Ford Iku Smart Wi-Fi Batten Light",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000001W_Data_Sheet.pdf?v=1776416525",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005687_Pairing_Guide.pdf?v=1776416599",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMI7040_WIFI_3b4c8eba-34b4-4045-aa10-86b843634f4a.jpg?v=1778649994"
  },
  {
    "sku": "MA2418-5",
    "title": "Franklin 18W LED Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Franklin-18W-LED-Ceiling-Light-Mercator-6018.jpg?v=1778649998"
  },
  {
    "sku": "MA2424-5",
    "title": "Franklin 24W LED Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Franklin-24W-LED-Ceiling-Light-Mercator-1859_44823706-bc71-4a28-b0da-7bcde9551114.jpg?v=1778650001"
  },
  {
    "sku": "MA1018CCT",
    "title": "Franklin II 18W LED Ceiling Light With Adjustable CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Franklin-II-18W-LED-Ceiling-Light-Mercator-3591_94d6b032-e9d4-4891-b6b8-cf125647f8d9.jpg?v=1778650004"
  },
  {
    "sku": "MA1024CCT",
    "title": "Franklin II 24W LED Ceiling Light with Adjustable CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Franklin-II-24W-LED-Ceiling-Light-Mercator-7829_92a2829b-6b50-4c95-9b5e-b6e618380eb1.jpg?v=1778650008"
  },
  {
    "sku": "MA1036CCT",
    "title": "Franklin II 36W Ceiling LED Light  With Adjustable CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Franklin-II-36W-Ceiling-LED-Light-With-Adjustable-CCT-Mercator-5074_fc58df26-5e01-4c28-bc48-3bbb4648255d.jpg?v=1778650012"
  },
  {
    "sku": "MTBL023BLK",
    "title": "Freya Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Freya-Table-Lamp-Mercator-4894_0202ef4f-2435-48b9-9273-0800eb52cf56.jpg?v=1778650017"
  },
  {
    "sku": "MTBL023WHT",
    "title": "Freya Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Freya-Table-Lamp-Mercator-4894_0202ef4f-2435-48b9-9273-0800eb52cf56.jpg?v=1778650017"
  },
  {
    "sku": "MTBL047",
    "title": "Fynn Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Fynn-Table-Lamp-Mercator-4214_c685d677-7524-41b3-b075-606ddecef066.jpg?v=1778650020"
  },
  {
    "sku": "9E27LED30",
    "title": "G125  E27 Decorative Globe Magician Dot",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-E27-Decorative-Globe-Magician-Dot-Mercator-91_cfb1f752-cf14-4210-a5c9-f705c4af85e8.jpg?v=1778650024"
  },
  {
    "sku": "9E27LEDSP125DHB",
    "title": "G125 2700K E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-2700K-E27-Filament-Globe-Mercator-963_41136ccb-384c-4002-aa6d-e4e30cfd2c51.jpg?v=1778650028"
  },
  {
    "sku": "9B22LED30",
    "title": "G125 B22 Decorative Globe Magician Dot",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-B22-Decorative-Globe-Magician-Dot-Mercator-2974_114f2343-12e6-4419-ba86-ca59ffd0f86c.jpg?v=1778650032"
  },
  {
    "sku": "9B22LED29",
    "title": "G125 B22 Decorative Globe Magician Net",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-B22-Decorative-Globe-Magician-Net-Mercator-351_a0c062b2-5aa4-47b8-80c4-c82b9db283ee.jpg?v=1778650036"
  },
  {
    "sku": "9B22LED27",
    "title": "G125 B22 Vintage Decorative Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-B22-Vintage-Decorative-Globe-Mercator-3704_15290ef5-0cbf-4d2f-a7f4-d446bf25a45e.jpg?v=1778650040"
  },
  {
    "sku": "9B22LED24",
    "title": "G125 B22 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-B22-Vintage-Decorative-LED-Globe-Mercator-1349_d252fda2-9b47-4735-9ffc-28816587be5b.jpg?v=1778650045"
  },
  {
    "sku": "MGL274",
    "title": "G125 Decorative E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-Decorative-E27-LED-Globe-Mercator-9237_021a5c03-c847-43bd-b867-bce8b509e39c.jpg?v=1778650049"
  },
  {
    "sku": "9E27LED29",
    "title": "G125 E27 Decorative Globe Magician Net",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-E27-Decorative-Globe-Magician-Net-Mercator-5472_9c90e14a-2833-4276-b316-a46c862dbdc2.jpg?v=1778650053"
  },
  {
    "sku": "9E27LEDSP125DC",
    "title": "G125 E27 Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-E27-Filament-LED-Globe-Mercator-592_fea7eeb5-022f-4727-9c9c-adcd96a07100.jpg?v=1778650056"
  },
  {
    "sku": "9E27LED27",
    "title": "G125 E27 Vintage Decorative Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-E27-Vintage-Decorative-Globe-Mercator-3048_c508f78c-deae-47bf-bcc5-933ed5413854.jpg?v=1778650059"
  },
  {
    "sku": "9E27LED24",
    "title": "G125 E27 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-E27-Vintage-Decorative-LED-Globe-Mercator-4840_855cfb25-a071-45be-a10f-890e9a9041a1.jpg?v=1778650063"
  },
  {
    "sku": "9E27LED15A",
    "title": "G125 Filament Sphere LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G125-Filament-Sphere-LED-Globe-Mercator-9221_81684475-7ded-4f41-947f-74c7fd527fde.jpg?v=1778650067"
  },
  {
    "sku": "MGL068D",
    "title": "G4 Cool White LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G4-6500K-LED-Globe-Mercator-1645_dce020c3-31fa-4d6a-a3e1-a5d4a5f1154f.jpg?v=1778650071"
  },
  {
    "sku": "MGL068W",
    "title": "G4 Warm White LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G4-3000K-LED-Globe-Mercator-4862_2a8bfd27-cc41-4ea7-8078-2a874d322894.jpg?v=1778650075"
  },
  {
    "sku": "MGL069D",
    "title": "G9 Cool White LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL069D_2d34ac90-f448-4bb5-b9ea-16e68e583e8c.jpg?v=1778650079"
  },
  {
    "sku": "MGL069W",
    "title": "G9 Warm White LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL069W_178e67b1-40af-4aa6-b478-d1e534c3ee71.jpg?v=1778650083"
  },
  {
    "sku": "9B22LEDSP95DC",
    "title": "G95 B22 Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G95-B22-Filament-LED-Globe-Mercator-1444_99cfbdb6-3e3d-4506-af3e-1348d6bf1f79.jpg?v=1778650086"
  },
  {
    "sku": "9B22LED23",
    "title": "G95 B22 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G95-B22-Vintage-Decorative-LED-Globe-Mercator-8318_90823595-169f-46be-a424-7c5126e78f77.jpg?v=1778650090"
  },
  {
    "sku": "9E27LEDSP95DHB",
    "title": "G95 E27 750lm Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G95-E27-750lm-Filament-LED-Globe-Mercator-5547_6dd275e8-5285-444b-ae17-747f82de4495.jpg?v=1778650096"
  },
  {
    "sku": "9E27LEDSP95DC",
    "title": "G95 E27 810lm Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G95-E27-810lm-Filament-LED-Globe-Mercator-7936_ac4015f2-32b4-4cb9-a9dd-504260f705e5.jpg?v=1778650100"
  },
  {
    "sku": "9E27LED23",
    "title": "G95 E27 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G95-E27-Vintage-Decorative-LED-Globe-Mercator-8648_a558f70a-bb5b-4491-9b0f-6af0ed6c8452.jpg?v=1778650103"
  },
  {
    "sku": "9E27LEDG95A",
    "title": "G95 Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/G95-Filament-LED-Globe-Mercator-328_3b2e2a96-a1a2-4ec4-9437-d0e507ef0493.jpg?v=1778650107"
  },
  {
    "sku": "MPLS035",
    "title": "Garcelle 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPLS035_0ce447c9-5367-491f-a569-a851507f95f0.jpg?v=1778650182"
  },
  {
    "sku": "A42922BC",
    "title": "Georgia LED Mother & Child Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Georgia-LED-Mother-Child-Floor-Lamp-Mercator-3082_74bf1fbb-1af5-44cd-9c1d-481b60a0982e.jpg?v=1778650185"
  },
  {
    "sku": "MD635S-5",
    "title": "Gizmo 12W 5000K LED Fixed Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD635S-5_6e0d0eab-620b-4b65-9568-de1e41f47f1b.jpg?v=1778650189"
  },
  {
    "sku": "MD635W-5",
    "title": "Gizmo 12W 5000K LED Fixed Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD635S-5_6e0d0eab-620b-4b65-9568-de1e41f47f1b.jpg?v=1778650189"
  },
  {
    "sku": "MD630S-3",
    "title": "Gizmo 7W 3000K LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD630S-3_0ba98f4f-aa06-4613-a85a-03afef8d292b.jpg?v=1778650194"
  },
  {
    "sku": "MD630W-5",
    "title": "Gizmo 7W 5000K LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD630W-5_53cac5a3-bea0-461f-be00-aa7d394996ab.jpg?v=1778650197"
  },
  {
    "sku": "MP9131",
    "title": "Gladiator 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Gladiator-1Lt-Pendant-Light-Mercator-3521_b53d1afe-2c2e-40b8-8562-85b2f6740250.jpg?v=1778650201"
  },
  {
    "sku": "GO92093BLK",
    "title": "Go Mast 1M Track & Accessories",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mast-Three-1000mm-Circuit-Tracks-Accessories-L-Shape-Mercator-4901_293c1fa4-bbcc-438a-9e93-ede17fd6125d.jpg?v=1778650205"
  },
  {
    "sku": "GO92093WHT",
    "title": "Go Mast 1M Track & Accessories",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mast-Three-1000mm-Circuit-Tracks-Accessories-L-Shape-Mercator-4901_293c1fa4-bbcc-438a-9e93-ede17fd6125d.jpg?v=1778650205"
  },
  {
    "sku": "GO92093-2BLK",
    "title": "Go Mast 2M Track Accessory",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Track-Accessories-LED-Track-Light-Mercator-807_50fbf47b-b552-4827-8099-5fed0ec7e48a.jpg?v=1778650209"
  },
  {
    "sku": "GO92093-2WHT",
    "title": "Go Mast 2M Track Accessory",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Track-Accessories-LED-Track-Light-Mercator-807_50fbf47b-b552-4827-8099-5fed0ec7e48a.jpg?v=1778650209"
  },
  {
    "sku": "9GU10LED9D-3",
    "title": "GU10 3000K Dimmable LED  Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-3000K-Dimmable-LED-Globe-Mercator-1000_5f69431b-9803-4f45-af76-ba9d9869dd02.jpg?v=1778650112"
  },
  {
    "sku": "9GU10LED9-3",
    "title": "GU10 3000K Non-Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-3000K-Non-Dimmable-LED-Globe-Mercator-8740_5f4a44ad-d6de-4a97-a38e-06605bf9933b.jpg?v=1778650115"
  },
  {
    "sku": "9GU10LED9D-4",
    "title": "GU10 4000K Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-4000K-Dimmable-LED-Globe-Mercator-1832_713be3a4-7790-42a6-a167-161c3f60fc7d.jpg?v=1778650120"
  },
  {
    "sku": "9GU10LED9-4",
    "title": "GU10 4000K Non-Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-4000K-Non-Dimmable-LED-Globe-Mercator-3030_af69dce3-422a-4b13-b969-4b55d9934d7a.jpg?v=1778650124"
  },
  {
    "sku": "9GU10LED9D-5",
    "title": "GU10 5000K Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-5000K-Dimmable-LED-Globe-Mercator-7356_acec2701-8a5e-4f7c-b715-dcc0c417c307.jpg?v=1778650127"
  },
  {
    "sku": "9GU10LED9-5",
    "title": "GU10 5000K Non-Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-5000K-Non-Dimmable-LED-Globe-Mercator-5615_bef3ee71-690d-4d69-b959-e77544ae76fb.jpg?v=1778650132"
  },
  {
    "sku": "MGL080D-D",
    "title": "GU10 Day Light Dim36D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL080D-D_16dba3d1-36d3-4f60-83a2-a91b43d99fe9.jpg?v=1778650135"
  },
  {
    "sku": "MGL082D-D",
    "title": "GU10 Day Light Dim60D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL082D-D_a6e709f0-568e-4a7f-8227-3f13e1e12e36.jpg?v=1778650139"
  },
  {
    "sku": "MGL082GD",
    "title": "GU10 Day Light Glass Dim60D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-5700K-Glass-Dim60D-LED-Globe-Mercator-7990_d62ced87-4772-4e98-83b2-b95477d72bbb.jpg?v=1778650143"
  },
  {
    "sku": "MGL080GD",
    "title": "GU10 Glass Day Light Dim36D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-Glass-5700K-Dim36D-LED-Globe-Mercator-7215_e9203572-8f23-49dd-8c38-3c122087ac05.jpg?v=1778650147"
  },
  {
    "sku": "S9GU10LED5",
    "title": "GU10 Iku Smart Wi-Fi Dimmable Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000015W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9GU10LED5_4f1af509-f0a6-499e-90f9-d396657022c9.jpg?v=1778650151"
  },
  {
    "sku": "S9GU10LED5-RGB",
    "title": "GU10 Iku Smart Wi-Fi Dimmable RGB Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000015W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9GU10LED5-RGB_80e0713e-aeb4-48c8-8162-ed992a59c9c1.jpg?v=1778650155"
  },
  {
    "sku": "S9GU10LED5-ZB",
    "title": "GU10 Iku Smart Zigbee Dimmable Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000015Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9GU10LED5-ZB_5c74fda8-e5b3-4817-8c9c-23ea83fc03ce.jpg?v=1778650158"
  },
  {
    "sku": "S9GU10LED5-RGB-Z",
    "title": "GU10 Iku Smart Zigbee Dimmable RGB Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000015Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9GU10LED5-RGB-Z_65e60afe-50e6-4466-9665-478aa91c40e8.jpg?v=1778650162"
  },
  {
    "sku": "MGL080W-D",
    "title": "GU10 Warm White Dim36D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL080W-D_842a9fc1-4e6a-4ba5-804c-7ae6090a295b.jpg?v=1778650166"
  },
  {
    "sku": "MGL082GW",
    "title": "GU10 Warm White Dim60D Glass LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-3000K-Dim60D-Glass-LED-Globe-Mercator-7675_9e6d989f-cc80-4d6e-9864-195a64bf1f21.jpg?v=1778650170"
  },
  {
    "sku": "MGL082W-D",
    "title": "GU10 Warm White Dim60D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL082W-D_8fdd6a15-0bfe-43ab-a280-dbf356f103de.jpg?v=1778650175"
  },
  {
    "sku": "MGL080GW",
    "title": "GU10 Warm White Glass LED Dim36D Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/GU10-3000K-Glass-LED-Dim36D-Globe-Mercator-8077_bebc7df2-5913-4797-9205-ee369fc8aadb.jpg?v=1778650178"
  },
  {
    "sku": "FC1110143WH",
    "title": "Guardian 142cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Guardian-DC-Ceiling-Fan-with-Remote-Mercator-2442_0d472c4c-a9c0-4ab0-937b-8207b12ea863.jpg?v=1778650215"
  },
  {
    "sku": "MD555S-3",
    "title": "Gusto 35W 3000K LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD555S-3_69c48df7-fe74-497f-931f-26363698be0f.jpg?v=1778650219"
  },
  {
    "sku": "MA9371CL",
    "title": "Gwen Clear Glass DIY Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Glenn-Clear-Glass-DIY-Light-Mercator-215_61a23dfc-d446-41d4-b825-f36f0de47162.jpg?v=1778650222"
  },
  {
    "sku": "MA97BLK",
    "title": "Gypsy Cord Set With Plug Black",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Gypsy-Cord-Set-With-Plug-Black-Mercator-7312_94c20dbb-ec31-46cc-b368-0d132f7dc645.jpg?v=1778650226"
  },
  {
    "sku": "MFL002",
    "title": "Hadley Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Hadley-Floor-Lamp-Mercator-8788_ad678dd5-d29e-4b9d-bbe5-b1536259d493.jpg?v=1778650233"
  },
  {
    "sku": "MG8731S",
    "title": "Hampton 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Hampton-1Lt-Small-Pendant-Light-Mercator-6041_cd89334b-9a63-434a-bfa2-1bcbff31a20e.jpg?v=1778650237"
  },
  {
    "sku": "MG8733L",
    "title": "Hampton 3Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Hampton-3Lt-Large-Pendant-Light-Mercator-8869_6c7b8919-e3bd-426a-b731-ef460367abef.jpg?v=1778650240"
  },
  {
    "sku": "FC050135AB",
    "title": "Hayman 132cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Hayman-AC-Ceiling-Fan-Mercator-1647_68083de8-3eb5-471e-8633-1ea847447807.jpg?v=1778650243"
  },
  {
    "sku": "FC490135AB",
    "title": "Healey 133cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC490135AB_57137f79-6ca9-48ba-b557-89552c2d2f52.jpg?v=1778650247"
  },
  {
    "sku": "FC490135RB",
    "title": "Healey 133cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC490135AB_57137f79-6ca9-48ba-b557-89552c2d2f52.jpg?v=1778650247"
  },
  {
    "sku": "XBH1514",
    "title": "HEAT LAMP R7S 800W SUITS DOMIN",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "MSL2520",
    "title": "Helios Solar Batten With PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Helios-Solar-Batten-With-PIR-Sensor-Mercator-2233_30d674d7-8c22-487e-ae20-4ef3b7577fbe.jpg?v=1778650251"
  },
  {
    "sku": "MTBL018AB",
    "title": "Hilda Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Hilda-Table-Lamp-Mercator-9107_ad87d4b4-9866-4517-9b79-40d8ba787dcb.jpg?v=1778650254"
  },
  {
    "sku": "MPLS024NAT",
    "title": "Hobart 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Hobart-1Lt-Pendant-Light-Mercator-117_6b58a635-c8c8-4267-af56-6e7ebbd7dd98.jpg?v=1778650258"
  },
  {
    "sku": "FC880153BK",
    "title": "Iceman 152cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC880153BK_cd2ed3c7-1d77-4891-a15b-3d7766cbcd31.jpg?v=1778650276"
  },
  {
    "sku": "FC880153WH",
    "title": "Iceman 152cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC880153BK_cd2ed3c7-1d77-4891-a15b-3d7766cbcd31.jpg?v=1778650276"
  },
  {
    "sku": "FC880153CY",
    "title": "Iceman 152cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC880153BK_cd2ed3c7-1d77-4891-a15b-3d7766cbcd31.jpg?v=1778650276"
  },
  {
    "sku": "FC888153BK",
    "title": "Iceman 152cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC888153BK_95b6e647-b9c5-4e28-a5ba-67f73d905377.jpg?v=1778650282"
  },
  {
    "sku": "FC888153WH",
    "title": "Iceman 152cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC888153BK_95b6e647-b9c5-4e28-a5ba-67f73d905377.jpg?v=1778650282"
  },
  {
    "sku": "FC888153CY",
    "title": "Iceman 152cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC888153BK_95b6e647-b9c5-4e28-a5ba-67f73d905377.jpg?v=1778650282"
  },
  {
    "sku": "MC1003",
    "title": "Ikon 24W Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ikon-24W-Ceiling-Light-Mercator-5481_c6955c7e-bcae-450b-8c02-4761295fe7ba.jpg?v=1778650286"
  },
  {
    "sku": "MC1004",
    "title": "Ikon 36W Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ikon-36W-Ceiling-Light-Mercator-8424_3bf5b41a-15de-4f13-bf67-5e37ec70f0c2.jpg?v=1778650290"
  },
  {
    "sku": "MPH1000",
    "title": "Iku 1100W Smart WIFI Panel Heater",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPH1000_864c0c65-7f07-47a3-9e76-062c72f8394d.png?v=1778650307"
  },
  {
    "sku": "MPH1500",
    "title": "Iku 1600W Smart WIFI Panel Heater",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPH1500_af7d00fb-a6ed-492d-a9e3-116647a7870d.png?v=1778650312"
  },
  {
    "sku": "MPH2000",
    "title": "Iku 2000W Smart WIFI Panel Heater",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPH2000_d859a0ba-8c0d-4ffb-9967-5448cf10e20c.png?v=1778650317"
  },
  {
    "sku": "MPH2400",
    "title": "Iku 2400W Smart WIFI Panel Heater",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPH2400_fc3a3c13-6368-4b52-a831-d92d0fbd189e.png?v=1778650321"
  },
  {
    "sku": "CB001",
    "title": "Iku Contractor Box",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CB001_7b7e9f22-f620-478e-aca1-e673cfc44e7a.jpg?v=1778650327"
  },
  {
    "sku": "SXSEN002PIR",
    "title": "Iku Smart 360D Surface Mount PIR Sensor",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000022W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005829_Pairing_Guide.pdf?v=1776661657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SXSEN002PIR_57a67ba4-c75f-4b49-a66b-16922ae86da2.jpg?v=1778650331"
  },
  {
    "sku": "SPLUG07",
    "title": "IKUU SMART ADAPTOR WITH THERMO",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "SSC04G-LTE",
    "title": "Iku Smart Cooper Rechargeable PTZ Security Camera",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC04G-LTE_Mercator_Datasheet_17_Jan_2025_04_01_15_6789d7732026b_12581_1.pdf?v=1779175340",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC04G-LTE_MRIN007966_2_OL.pdf?v=1776661659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC04G-LTE_01_a296ea3f-f7cb-4e85-9978-5b6e0172f107.jpg?v=1778650337"
  },
  {
    "sku": "SMA071-BT",
    "title": "Iku Smart Entrance Lock with Bluetooth and Backlit Keypad",
    "product_spec": "",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN007806_OL.pdf?v=1787722316",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA071-BT.png?v=1787722371"
  },
  {
    "sku": "SMA072-BT",
    "title": "Iku Smart Entrance Lock with Bluetooth and Fingerprint Sensor",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000054B.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN007127_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA072-BT_80a7cf3e-b7ae-44dd-ab85-4539a9d46ac1.jpg?v=1778650341"
  },
  {
    "sku": "SSC079",
    "title": "Iku Smart Nash Wi-Fi Rechargeable Security Camera",
    "product_spec": "",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC079_MRIN008262_OL.pdf?v=1776661659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC079_1_2cd34beb-f9ec-44ab-8138-8b6ef313b8bd.jpg?v=1778650353"
  },
  {
    "sku": "SHA171",
    "title": "Iku Smart Wi-Fi  Kettle 1.7L",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006176_OL.pdf?v=1778481447",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006175_OL.pdf?v=1778481447",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SHA171_aa8693e8-62ee-41a2-a3aa-fbf5f4d8711f.jpg?v=1778650369"
  },
  {
    "sku": "SMLD233",
    "title": "Iku Smart Wi-Fi 2m Strip Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMLD233_816a53f1-ab20-4b63-9858-a80d5ae7be6b.jpg?v=1778650373"
  },
  {
    "sku": "SMLD552-WIFI",
    "title": "Iku Smart Wi-Fi 5m COB Strip Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMLD552-WIFI_747f2d83-a29f-46d1-86db-efa6e528486f.jpg?v=1778650376"
  },
  {
    "sku": "SMLD533",
    "title": "Iku Smart Wi-Fi 5m Strip Light",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000024W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005575_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMLD533_a153b2a3-cfcb-43bb-a1f4-7bfde6bea43c.jpg?v=1778650379"
  },
  {
    "sku": "SSWF01G-WIFI",
    "title": "Iku Smart Wi-Fi AC Fan Controller With Light Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000027W_v2.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005494_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWF01G_2bc74904-21f7-4994-a53d-fd9212c5091a.jpg?v=1778650383"
  },
  {
    "sku": "SSC069",
    "title": "Iku Smart Wi-Fi Bullet Security Camera",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000055W.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN007187_Pairing_Guide.pdf?v=1776661660",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC069_3ee4c01e-c9e5-48d2-9e6f-fc92a6653068.jpg?v=1778650387"
  },
  {
    "sku": "SSWMPIR-WIFI",
    "title": "Iku Smart Wi-Fi Combination Sensor Switch",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWMPIR-WIFI_fcb7c942-e4a9-41b5-a5f6-49b3aa9e3848.jpg?v=1778650391"
  },
  {
    "sku": "SSW01GBC-WIFI",
    "title": "Iku Smart Wi-Fi Curtain & Blinds Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000048W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006697_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GBC-WIFI_bfcd1ef6-595a-44ef-8ebc-e065c908c3ee.jpg?v=1778650395"
  },
  {
    "sku": "SSWM-DIM",
    "title": "Iku Smart Wi-Fi Dimmer Mechanism",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000044W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006254_Pairing_Guide.pdf?v=1776661657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWM-DIM_cd2e85e2-0b42-4b43-b1d4-885bfc95817b.jpg?v=1778650398"
  },
  {
    "sku": "SSW02GX-WIFI",
    "title": "Iku Smart Wi-Fi Double 2-Way Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000045W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006705_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW02GX-WIFI_bc12ed0b-d979-4014-9a9f-6f835baeba07.jpg?v=1778650402"
  },
  {
    "sku": "SPPUSB02G-WIFI",
    "title": "Iku Smart Wi-Fi Double Power Point with USB Dual A",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPPUSB02G-WIFI_c11615dd-46a8-4674-ac12-b2aaf6da5e51.jpg?v=1778650406"
  },
  {
    "sku": "SSW02G-WIFI",
    "title": "Iku Smart Wi-Fi Double Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000029W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005669_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW02G-WIFI_c517ef5b-7e3d-4e91-9855-aabe09f01b9f.jpg?v=1778650409"
  },
  {
    "sku": "SSW05G-WIFI",
    "title": "Iku Smart Wi-Fi Five Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000046W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006705_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW05G-WIFI_15e35988-1f18-401e-8391-b39482f09256.jpg?v=1778650412"
  },
  {
    "sku": "SMA018-WIFI",
    "title": "Iku Smart Wi-Fi Garage Door Control Kit",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000042W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006452_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA018-WIFI_906967fd-82d0-48e4-8148-47888c71fb54.jpg?v=1778650417"
  },
  {
    "sku": "SSC009",
    "title": "Iku Smart Wi-Fi Indoor Pan & Tilt Security Camera",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC009_1e6313bc-00ff-45c2-8381-a170f0392dee.jpg?v=1778650425"
  },
  {
    "sku": "SSC010",
    "title": "Iku Smart Wi-Fi Indoor Pan and Tilt Security Camera",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC010_835e1a51-2a0e-409f-8610-33a1be5c9357.jpg?v=1778650428"
  },
  {
    "sku": "SSC336",
    "title": "Iku Smart Wi-Fi Indoor Stationary Security Camera",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000003W_Data_Sheet.pdf?v=1776419602",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005227_3_Pairing_Guide.pdf?v=1776419624",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC336_6486a175-4337-4d0d-894b-3f68cc1d459e.jpg?v=1778650432"
  },
  {
    "sku": "SISW11-WIFI",
    "title": "Iku Smart Wi-Fi Inline Module Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000051W_v2.pdf?v=1778738592",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006904_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SISW11-WIFi_ae5015c3-4f93-4745-b5ac-e4092c5e67dd.jpg?v=1778650436"
  },
  {
    "sku": "SISWD01-WIFI",
    "title": "Iku Smart Wi-Fi Inline Switch With Dimmer",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000033W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005701_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SISWD01-WIFI_09e89a8c-4ccf-48c3-a8f9-e64f8123ecbc.jpg?v=1778650440"
  },
  {
    "sku": "SISWD11-WIFI",
    "title": "Ikuu Smart Wi-Fi Inline Switch With Dimmer - Momentary Press Switch Compatible",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000052W_v2.pdf?v=1778738693",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006906_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SISWD11-WIFI_a73e5b7a-3cca-4bb9-9816-63628ac72b7e.jpg?v=1778650293"
  },
  {
    "sku": "SXSEN003PIR",
    "title": "Iku Smart Wi-Fi IP65 Smart Outdoor Sensor",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000038W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005833_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SXSEN003PIR_08e13e02-94f3-439f-8d4a-87b20bfea2f6.jpg?v=1778650420"
  },
  {
    "sku": "SSWD01G-WIFI",
    "title": "Iku Smart Wi-Fi Light Dimmer Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000026W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005596_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWD01G-WIFI_3070cb86-11b6-4f43-838d-83dfaf6fb0f0.jpg?v=1778650444"
  },
  {
    "sku": "SSWMODPIR-WIFI",
    "title": "Iku Smart Wi-Fi Lux/Pir Wall Plate with Temperature Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWMODPIR-WIFI_545e7d56-cb83-492f-bf0c-aaa3d59644bf.jpg?v=1778650448"
  },
  {
    "sku": "SMA05",
    "title": "Iku Smart Wi-Fi Motion Sensor",
    "product_spec": "",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA05_MRIN007596_OL.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA05_aa46581a-6223-499b-98ac-c7397eb7731a.jpg?v=1778650452"
  },
  {
    "sku": "SPLUG03",
    "title": "Iku Smart Wi-Fi Outdoor Single Adapter",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000041W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006221_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPLUG03_b9b133c0-8043-40ec-a1a3-bf9880824bb0.jpg?v=1778650456"
  },
  {
    "sku": "SPB04U",
    "title": "Iku Smart WI-FI Outlet Power board plus 2 USB",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000021W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005155_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPB04U_a38e06f3-bcb6-43ac-9b64-d9b6da60cb79.jpg?v=1778650356"
  },
  {
    "sku": "SPBS01G-WIFI",
    "title": "Iku Smart Wi-Fi Plug Base With Clear Rear Cover",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000035W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005233_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPBS01G-WIFI_a9453452-30cc-4970-aebf-4981beb7b4d6.jpg?v=1778650459"
  },
  {
    "sku": "SSWM10-WIFI",
    "title": "Ikuu Smart Wi-Fi Push Switch Mechanism - Neutral Required",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000049W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005943_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWM10-WIFI_3e4842d2-7585-47e3-a8c9-9d0cacb4bf3d.jpg?v=1778650296"
  },
  {
    "sku": "SSWM-WIFI",
    "title": "Iku Smart Wi-Fi Push Switch Mechanism - No Neutral Required",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000025W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005943_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWM-WIFI_3b04ae69-ab53-4d17-b17e-5682927b2501.jpg?v=1778650463"
  },
  {
    "sku": "SSW04G-WIFI",
    "title": "Iku Smart Wi-Fi Quad Gang Light Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000029W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005669_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW04G-WIFI_654c14b3-bb4c-4e64-baa0-9990a0421654.jpg?v=1778650467"
  },
  {
    "sku": "SPLUGR01",
    "title": "Iku Smart WI-FI Re-Wireable Plug",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000034W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005192_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPLUGR01_b2cb04ca-5107-4cfa-aa50-f85c64c92700.jpg?v=1778650360"
  },
  {
    "sku": "SSC078",
    "title": "Iku Smart Wi-Fi Rechargeable Security Camera",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSC078_4dea7f19-f773-499b-8d04-9ac06fb014aa.jpg?v=1778650470"
  },
  {
    "sku": "SDC57",
    "title": "Iku Smart Wi-Fi Rechargeable Video Doorbell",
    "product_spec": "",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SDC57_MRIN007729_OL.pdf?v=1776661659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SDC57_44ddb4ac-6e40-4b92-a208-8a1de0d30238.jpg?v=1778650473"
  },
  {
    "sku": "SMFL20W",
    "title": "Iku Smart Wi-Fi Ridley Flood Light",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000013W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005478_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMFL20W_eaec82e3-4af5-474c-ab94-4e638ab9d56c.jpg?v=1778650477"
  },
  {
    "sku": "SSWRM-WIFI",
    "title": "Iku Smart Wi-Fi Rotary Dimmer Mechanism",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000050W_v2.pdf?v=1778739097",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006752_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWRM-WIFI_1c53b544-8c84-4585-a49f-6fea659d40f4.jpg?v=1778650481"
  },
  {
    "sku": "SSW01GX-WIFI",
    "title": "Iku Smart Wi-Fi Single 2-Way Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000045W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006705_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GX-WIFI_8a51e04c-9041-4595-b810-1d502354c354.jpg?v=1778650486"
  },
  {
    "sku": "SPLUG02",
    "title": "Iku Smart WI-FI Single Adaptor",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005145_2_Pairing_Guide.pdf?v=1776661656",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005154_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPLUG02_64d721a2-67f1-41c7-b05e-0b03a18fcfb3.jpg?v=1778650365"
  },
  {
    "sku": "SSW01GHW-WIFI",
    "title": "Iku Smart Wi-Fi Single Gang Handwave Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000053W.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006741_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GHW-WIFI_29e33b2e-0e09-4c83-b649-a488e5fba727.jpg?v=1778650491"
  },
  {
    "sku": "SSW01G-WIFI",
    "title": "Iku Smart Wi-Fi Single Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000029W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005669_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01G-WIFI_8be3110d-9eef-4815-a722-b1ea2bb36947.jpg?v=1778650495"
  },
  {
    "sku": "SSW06G-WIFI",
    "title": "Iku Smart Wi-Fi Six Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000046W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006705_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW06G-WIFI_02ecdcda-fcc5-48e1-a179-721d573fcace.jpg?v=1778650498"
  },
  {
    "sku": "SPPUSB02GC-WIFI",
    "title": "Iku Smart Wi-Fi Touch Control Double Power Point With USB A+C",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000028W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005485_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPPUSB02GC-WIFI_8928e912-aaa7-4383-b4c0-85d95ae6013a.jpg?v=1778650502"
  },
  {
    "sku": "SSW03G-WIFI",
    "title": "Iku Smart Wi-Fi Triple Switch",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW03G-WIFI_cba2fd77-7cf2-4571-8fa0-8ccc7defd7c2.jpg?v=1778650506"
  },
  {
    "sku": "SDC8G",
    "title": "Iku Smart Wi-Fi Video Doorbell",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000009W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005181_3_Pairing_Guide.pdf?v=1776661659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SDC8G_d4428c6f-efd4-4842-a9bb-3f858b33b937.jpg?v=1778650510"
  },
  {
    "sku": "SPP02G-WIFI",
    "title": "Iku Smart WiFi Double Power Point",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPP02G-WIFI_6a29ba92-122e-4946-a772-ef69d2b806f7.jpg?v=1778650515"
  },
  {
    "sku": "SPP02GIP-WIFI",
    "title": "Iku Smart WiFi IP54 Double Power Point",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000011W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005485_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Iku__Smart__WiFi__IP54__Double__Power__Point_098c6c82-5d56-482a-90c6-1965a42512e6.jpg?v=1778650518"
  },
  {
    "sku": "SPP04G-WIFI",
    "title": "Iku Smart WiFi Quad Power Point",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000028W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005492_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPP04G-WIFI_883a9e45-657c-4543-9975-1fd559efced9.jpg?v=1778650521"
  },
  {
    "sku": "SPP01G-WIFI",
    "title": "Iku Smart WiFi Single Power Point",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000028W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005485_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPP01G-WIFI_cffa3aa7-df51-48a8-9d66-cf01e72deb58.jpg?v=1778650524"
  },
  {
    "sku": "SSW01GX-ZB",
    "title": "Iku Smart Zigbee 1 Gang 2 Way Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000045Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GX-ZB_bb643002-63f5-4c9a-9577-0ba47652bc92.jpg?v=1778650527"
  },
  {
    "sku": "SMCL01-ZB",
    "title": "Iku Smart Zigbee 24W LED Ceiling Light",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000007Z_Data_Sheet.pdf?v=1776661272",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005518_Pairing_Guide.pdf?v=1776661446",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMCL01-ZB_48a5790e-bebc-48f5-87e5-b4cc8a3640e6.jpg?v=1778650530"
  },
  {
    "sku": "SMLD233-ZB",
    "title": "Iku Smart Zigbee 2m Strip Light",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000024Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005570_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMLD233-ZB_627159d1-f670-478f-95ed-e5c76a88b2de.jpg?v=1778650534"
  },
  {
    "sku": "SMLD552-ZB",
    "title": "Iku Smart Zigbee 5m COB Strip Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMLD552-ZB_8c57851c-26e2-4ec6-9775-d389344dc6c5.jpg?v=1778650537"
  },
  {
    "sku": "SMLD533-ZB",
    "title": "Iku Smart Zigbee 5m Strip Light",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000024Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005570_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMLD533-ZB_c47dd560-dd0d-4510-97ab-3ac2e3181a62.jpg?v=1778650541"
  },
  {
    "sku": "SSWF01G",
    "title": "Iku Smart Zigbee AC Fan Controller With Light Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000027Z_v2.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005501_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWF01G_5e0796ca-6212-423d-a6a1-f3b425dd73a4.jpg?v=1778650546"
  },
  {
    "sku": "SSWMPIR-ZB",
    "title": "Iku Smart Zigbee Combination Sensor Switch",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWMPIR-ZB_a07b54d8-b66f-45bd-8df4-c93c15df0da1.jpg?v=1778650550"
  },
  {
    "sku": "SMA04-ZB",
    "title": "Iku Smart Zigbee Contact Sensor",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000023Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005217_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA04-ZB.png?v=1793185149"
  },
  {
    "sku": "SSW01GBC-ZB",
    "title": "Iku Smart Zigbee Curtain & Blinds Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000048Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006699_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GBC-ZB_af5cc565-d47d-4e2c-8cff-b0462929c169.jpg?v=1778650554"
  },
  {
    "sku": "SSWM-DIMZ",
    "title": "Iku Smart Zigbee Dimmer Mechanism",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000044Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006253_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWM-DIMZ_ff9b9e73-71f9-4b9c-9ba2-11dc0e2da61c.jpg?v=1778650558"
  },
  {
    "sku": "SSW02GX-ZB",
    "title": "Iku Smart Zigbee Double 2-Way Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000045Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW02GX-ZB_cf85cfec-c205-450a-a29b-96500fb9e133.jpg?v=1778650637"
  },
  {
    "sku": "SSW02GN-ZB",
    "title": "Iku Smart Zigbee Double Gang Light Switch with Neutral",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000047Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW02GN-ZB_a5b2692c-7d43-45b6-95eb-63c6786b31d8.jpg?v=1778650641"
  },
  {
    "sku": "SPP02G",
    "title": "Iku Smart Zigbee Double Power Point",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPP02G_8dee5962-f756-485b-961b-20af6420b62d.jpg?v=1778650647"
  },
  {
    "sku": "SPPUSB02GMBK",
    "title": "Iku Smart Zigbee Double Power Point With USB Dual A",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPPUSB02GMBK_ab6630f6-6503-41fd-aa49-83c55b295aa4.jpg?v=1778650650"
  },
  {
    "sku": "SSW02GMBK",
    "title": "Iku Smart Zigbee Double Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000029Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005751_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW02GMBK_7bc0d118-a7f1-46cc-8174-b31e4b653fcc.jpg?v=1778650654"
  },
  {
    "sku": "SSW02G",
    "title": "Iku Smart Zigbee Double Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000029Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005751_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW02GMBK_7bc0d118-a7f1-46cc-8174-b31e4b653fcc.jpg?v=1778650654"
  },
  {
    "sku": "SSW05G-ZB",
    "title": "Iku Smart Zigbee Five Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000047Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW05G-ZB_f274d353-0067-4647-afdd-43b2b4de0037.jpg?v=1778650660"
  },
  {
    "sku": "SGW002",
    "title": "Iku Smart Zigbee Home Hub",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000036A_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005179_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SGW002_e118cd7a-66ff-48cc-947d-74d844e199d1.jpg?v=1778650662"
  },
  {
    "sku": "SISW11-ZB",
    "title": "Iku Smart Zigbee Inline Module Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000051Z_v2.pdf?v=1778738640",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006900_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SISW11-ZB_a34bf707-0423-417b-9fad-73ad066155f7.jpg?v=1778650670"
  },
  {
    "sku": "SISW01",
    "title": "Iku Smart Zigbee Inline Switch",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SISW01_2058da24-9986-4718-aa7c-a8eca49b28b3.jpg?v=1778650674"
  },
  {
    "sku": "SISWD01",
    "title": "Iku Smart Zigbee Inline Switch With Dimmer",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000033Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005702_Pairing_Guide.pdf?v=1776661657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SISWD01_52ccb3a4-2da0-4920-a566-4aa0190e3c6a.jpg?v=1778650679"
  },
  {
    "sku": "SISWD11-ZB",
    "title": "Iku Smart Zigbee Inline Switch With Dimmer - Momentary Press Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000052W_v2.pdf?v=1778738693",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006902_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SISWD11-ZB_ab854ca3-6455-4555-b510-c35241f52f4f.jpg?v=1778650683"
  },
  {
    "sku": "SPP02GIP",
    "title": "Iku Smart Zigbee IP54 Double Power Point",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000011Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005484_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPP02GIP_1_4765b824-0457-4880-8a07-998452a6dd57.jpg?v=1778650666"
  },
  {
    "sku": "SSWD01G",
    "title": "Iku Smart Zigbee Light Dimmer Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000026Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005590_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWD01G_516e3d00-b690-4018-a77f-cefb54b0b5d4.jpg?v=1778650687"
  },
  {
    "sku": "SSWD01GMBK",
    "title": "Iku Smart Zigbee Light Dimmer Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000026Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005590_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWD01G_516e3d00-b690-4018-a77f-cefb54b0b5d4.jpg?v=1778650687"
  },
  {
    "sku": "SSWMODPIR-ZB",
    "title": "Iku Smart Zigbee Lux/Pir Wall Plate with Temperature Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWMODPIR-ZB_95730971-5f61-4700-a8f4-5a9ee3c3a7ef.jpg?v=1778650691"
  },
  {
    "sku": "SMA02P",
    "title": "Iku Smart Zigbee Motion Detector",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000023Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005217_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA02P_0d4f1872-d3d7-4bb5-bbf9-ac2a2d1c284c.jpg?v=1778650695"
  },
  {
    "sku": "SPBS01G",
    "title": "Iku Smart Zigbee Plug Base With Clear Rear Cover",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000035Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005216_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPBS01G_ad8aa6d9-550f-43b7-97e5-12d595dc4706.jpg?v=1778650699"
  },
  {
    "sku": "SGW003",
    "title": "Iku Smart Zigbee Pro Hub",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SGW003_1_c64055a3-a8ff-4209-8589-646dcb489e58.jpg?v=1778650703"
  },
  {
    "sku": "SSWM10-ZB",
    "title": "Ikuu Smart Zigbee Push Switch Mechanism - Neutral Required",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000049Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005814_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWM10-ZB_e7dbf762-e16b-4aa9-9d77-d0f954d616f2.jpg?v=1778650300"
  },
  {
    "sku": "SSWM",
    "title": "Ikuu Smart Zigbee Push Switch Mechanism - No Neutral Required",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWM_93fe1de6-c7df-4315-b721-dc62218e897f.jpg?v=1778650304"
  },
  {
    "sku": "SSW04GN-ZB",
    "title": "Iku Smart Zigbee Quad Gang Light Switch with Neutral",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000047Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW04GN-ZB_2aeaca78-67c4-4b17-a90c-c0fc37415596.jpg?v=1778650707"
  },
  {
    "sku": "SPP04G",
    "title": "Iku Smart Zigbee Quad Power Point",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000028Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005565_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPP04G_a2fb26dd-fc0e-4f1a-8ba8-600ef213c37c.jpg?v=1778650711"
  },
  {
    "sku": "SSW04GMBK",
    "title": "Iku Smart Zigbee Quad Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000029Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005751_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW04GMBK_6743aeeb-587a-42a6-96b0-9b19a4882b20.jpg?v=1778650716"
  },
  {
    "sku": "SMFL20W-ZB",
    "title": "Iku Smart Zigbee Ridley Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMFL20W-ZB_405327e8-da7c-4a0c-b42a-7544d02c387f.jpg?v=1778650720"
  },
  {
    "sku": "SSWRM-ZB",
    "title": "Iku Smart Zigbee Rotary Dimmer Mechanism",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000050Z_v2.pdf?v=1778739127",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006754_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSWRM-WIFI_f59fd03e-b87f-4e5c-9626-801d42c0ba82.jpg?v=1778650724"
  },
  {
    "sku": "SSW01GHW-ZB",
    "title": "Iku Smart Zigbee Single Gang Handwave Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000053Z.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006743_Pairing_Guide.pdf?v=1776661657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GHW-ZB_239776b8-68e3-4f6b-b10d-e189694b3719.jpg?v=1778650728"
  },
  {
    "sku": "SSW01GN-ZB",
    "title": "Iku Smart Zigbee Single Gang Light Switch with Neutral",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000047Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GN-ZB-1_1_17c44f8e-1340-4532-9cf8-15f13da5917b.jpg?v=1778650732"
  },
  {
    "sku": "SPP01G",
    "title": "Iku Smart Zigbee Single Power Point",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000028Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005484_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPP01G_e2050cac-d527-4025-8d81-51010bc4618f.jpg?v=1778650736"
  },
  {
    "sku": "SSW01GMBK",
    "title": "Iku Smart Zigbee Single Switch Matt Black",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW01GMBK_03017232-5bb5-4b0e-b982-719f54af654b.jpg?v=1778650740"
  },
  {
    "sku": "SSW06G-ZB",
    "title": "Iku Smart Zigbee Six Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000047Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW06G-ZB_79c77376-ec31-46e4-a6e4-780df583b9cb.jpg?v=1778650744"
  },
  {
    "sku": "SSW03GN-ZB",
    "title": "Iku Smart Zigbee Triple Gang Light Switch with Neutral",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000047Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006707_Pairing_guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW03GN-ZB_c2466a88-598a-4388-b552-3fd657731330.jpg?v=1778650748"
  },
  {
    "sku": "SSW03GMBK",
    "title": "Iku Smart Zigbee Triple Switch",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SSW03GMBK_8fafa85d-0271-41b9-b766-addd059a8af6.jpg?v=1778650752"
  },
  {
    "sku": "SMA011-ZB",
    "title": "Iku Smart Zigbee Wireless Dimmer Dial Switch",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000043Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN006451_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMA011-ZB_5da336d0-9bd3-49d6-9706-e0e7f4dea6f5.jpg?v=1778650757"
  },
  {
    "sku": "MP9031",
    "title": "Industry 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Industry-1Lt-Pendant-Light-Mercator-495_8cb77c50-3a18-4585-9fb3-5402c62f14c1.jpg?v=1778650760"
  },
  {
    "sku": "FC1108133WH",
    "title": "Instinct 137cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Instinct-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-4633_ad54cd59-e269-49d3-9a17-d6c463fe6f77.jpg?v=1778650764"
  },
  {
    "sku": "FC1108133BB",
    "title": "Instinct 137cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Instinct-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-4633_ad54cd59-e269-49d3-9a17-d6c463fe6f77.jpg?v=1778650764"
  },
  {
    "sku": "FC1108133WH",
    "title": "Instinct 137cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Instinct-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-4633_e05d7e44-c5b8-4ffc-a03f-29ec9a77ddd2.jpg?v=1778650767"
  },
  {
    "sku": "FC1100133WH",
    "title": "Instinct 137cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Instinct-DC-Ceiling-Fan-with-Remote-Mercator-3817_0aff83d5-c453-4350-844c-a701a793605a.jpg?v=1778650771"
  },
  {
    "sku": "FC1100133BB",
    "title": "Instinct 137cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Instinct-DC-Ceiling-Fan-with-Remote-Mercator-3817_0aff83d5-c453-4350-844c-a701a793605a.jpg?v=1778650771"
  },
  {
    "sku": "FC1100133WH",
    "title": "Instinct White 137cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Instinct-DC-Ceiling-Fan-with-Remote-Mercator-3817_f6eb38aa-38a8-4c78-810d-f31db18d4084.jpg?v=1778650774"
  },
  {
    "sku": "XSEN003PIR",
    "title": "IP65 PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/IP65-PIR-Sensor-Mercator-382_b5de20ea-6d66-4b46-a366-9d3f58b6e2fa.jpg?v=1778650264"
  },
  {
    "sku": "XSEN003PIR-BLK",
    "title": "IP65 PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/IP65-PIR-Sensor-Mercator-382_b5de20ea-6d66-4b46-a366-9d3f58b6e2fa.jpg?v=1778650264"
  },
  {
    "sku": "XSEN006WHT",
    "title": "IP66 Sensor Indoor/Outdoor Infrared Motion Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/IP66-Sensor-Indoor-Outdoor-Infrared-Motion-Sensor-Mercator-1775_6072c48a-e5d9-4ea9-ae97-5944c4b2f3a7.jpg?v=1778650269"
  },
  {
    "sku": "QS15G2",
    "title": "IP66 Weatherproof Sunset Switch",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/QS15G2.png?v=1779787950"
  },
  {
    "sku": "SBIR01",
    "title": "IR Blaster with Humidity Sensor And Temperature Sensor",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000018W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005145_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/IR-Blaster-with-Humidity-Sensor-And-Temperature-Sensor-Mercator-9240_bdd4a0bb-ada1-428f-ac71-73b96be58bb5.jpg?v=1778650272"
  },
  {
    "sku": "A39221",
    "title": "Iris Adjustable Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Iris-Adjustable-Floor-Lamp-Mercator-8972_1c0c8918-1779-4262-b30e-77c0392ef0cc.jpg?v=1778650778"
  },
  {
    "sku": "A39211",
    "title": "Iris Adjustable Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Iris-Adjustable-Table-Lamp-Mercator-2072_095d8fd4-25f9-4de3-a18e-81c4706d736c.jpg?v=1778650782"
  },
  {
    "sku": "FF93316WH",
    "title": "Ivan 40cm Wall Fan with Pull Cords",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ivan-40cm-Wall-Fan-with-Pull-Cords-Mercator-3076_48e8a9d3-802b-4596-823d-161f61e0343d.jpg?v=1778650793"
  },
  {
    "sku": "FF92316WH",
    "title": "Ivan 40cm Wall Fan with Remote Control",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ivan-40cm-Wall-Fan-with-Remote-Control-Mercator-9430.jpg?v=1778650797"
  },
  {
    "sku": "MA4671BCH",
    "title": "Jake Opal Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jake-Opal-Ceiling-Fixture-Mercator-9125_9addefb1-b80c-4a8c-9b34-eb262a83aefc.jpg?v=1778650806"
  },
  {
    "sku": "MA4671BLK",
    "title": "Jake Opal Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jake-Opal-Ceiling-Fixture-Mercator-9125_9addefb1-b80c-4a8c-9b34-eb262a83aefc.jpg?v=1778650806"
  },
  {
    "sku": "MA4671BCH",
    "title": "Jake Opal Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jake-Opal-Ceiling-Fixture-Mercator-9125_fa3285be-0f8f-4308-90b4-4388c9884b2b.jpg?v=1778650809"
  },
  {
    "sku": "MWL011",
    "title": "Jakob Wood Indoor Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jakob-Wood-Indoor-Wall-Light-Mercator-7012_bc728404-2ed9-4634-aab6-c09ed49a3123.jpg?v=1778650812"
  },
  {
    "sku": "MA3928-3",
    "title": "Jazz 28W 3000K LED Ceiling Light with White Rim",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jazz-28W-3000K-LED-Ceiling-Light-Mercator-8951_a79628d4-6505-4a6b-b4f9-1695b3a054ea.jpg?v=1778650816"
  },
  {
    "sku": "MA3928-6",
    "title": "Jazz 28W 6000K LED Ceiling Light with White Rim",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jazz-28W-6000K-LED-Ceiling-Light-Mercator-6341_f97cdaac-1438-4eaa-bbba-3a17ef19bf75.jpg?v=1778650819"
  },
  {
    "sku": "MW6818WHT-CCT",
    "title": "Jerome 18W LED Wall Light with CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jerome-18W-LED-Wall-Light-with-CCT-Mercator-6790_0c55f24e-4eb2-4a1f-aacc-edbd7c348f0c.jpg?v=1778650823"
  },
  {
    "sku": "MW6818BLK-CCT",
    "title": "Jerome 18W LED Wall Light with CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jerome-18W-LED-Wall-Light-with-CCT-Mercator-6790_0c55f24e-4eb2-4a1f-aacc-edbd7c348f0c.jpg?v=1778650823"
  },
  {
    "sku": "MW2902BLK-CCT",
    "title": "JESSICA II 10W LED WALL LIGHT CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MW2902BLK_fa7d5755-3965-4f72-b43a-0d20b71eae30.jpg?v=1778650802"
  },
  {
    "sku": "MW2902WHT-CCT",
    "title": "JESSICA II 10W LED WALL LIGHT CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MW2902BLK_fa7d5755-3965-4f72-b43a-0d20b71eae30.jpg?v=1778650802"
  },
  {
    "sku": "MTL012WHT",
    "title": "Jonte  Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jonte-Table-Lamp-Mercator-7347_b533f1bc-a24f-435e-a411-f1036b8f64e0.jpg?v=1778650827"
  },
  {
    "sku": "MTBL021GRY",
    "title": "Jordana Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Jordana-Table-Lamp-Mercator-305_f8294b9a-03b4-40b5-ad66-f6651ce5bb02.jpg?v=1778650831"
  },
  {
    "sku": "FC2118133WH",
    "title": "Jota 132cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2118133WH_50fb83f6-27e7-48df-80a7-cb749f77c651.jpg?v=1778650837"
  },
  {
    "sku": "FC2118133WH",
    "title": "Jota 132cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/JOTA_3B_52_DC_Series_w_Light_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2118133WH_a0518d25-f35e-40ee-aef4-c23b4ad1deb1.jpg?v=1778650862"
  },
  {
    "sku": "FC2118133BK",
    "title": "Jota 132cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/JOTA_3B_52_DC_Series_w_Light_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2118133WH_a0518d25-f35e-40ee-aef4-c23b4ad1deb1.jpg?v=1778650862"
  },
  {
    "sku": "FC2118133DT",
    "title": "Jota 132cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/JOTA_3B_52_DC_Series_w_Light_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2118133WH_a0518d25-f35e-40ee-aef4-c23b4ad1deb1.jpg?v=1778650862"
  },
  {
    "sku": "FC2110133WH",
    "title": "Jota 132cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2110133WH_d158a765-ede0-4936-bc1e-5f8ca9e56b85.jpg?v=1778650886"
  },
  {
    "sku": "FC2110133WH",
    "title": "Jota 132cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/JOTA_3B_52_DC_Series_no_Light_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2110133WH_5d293b28-d673-4b06-92cf-90b4a284a712.jpg?v=1778650910"
  },
  {
    "sku": "FC2110133BK",
    "title": "Jota 132cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/JOTA_3B_52_DC_Series_no_Light_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2110133WH_5d293b28-d673-4b06-92cf-90b4a284a712.jpg?v=1778650910"
  },
  {
    "sku": "FC2110133DT",
    "title": "Jota 132cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/JOTA_3B_52_DC_Series_no_Light_OL.pdf?v=1790747504",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2110133WH_5d293b28-d673-4b06-92cf-90b4a284a712.jpg?v=1778650910"
  },
  {
    "sku": "FC2118134WH",
    "title": "Jota 4B 132cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2118134WH_3e49ff88-771f-4525-8b41-1db64c168a16.jpg?v=1778650934"
  },
  {
    "sku": "FC2110134WH",
    "title": "Jota 4B 132cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2110134WH_de682d62-1182-4ba5-9d6f-59ac18bdd60f.jpg?v=1778650955"
  },
  {
    "sku": "FC2118093WH",
    "title": "Jota Mini 92cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2118093WH_8b9c36b0-30c6-4a17-9e4e-b2a3eba8bead.jpg?v=1778650982"
  },
  {
    "sku": "FC2110093WH",
    "title": "Jota Mini 92cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2110093WH_ada78a38-691f-49cd-ab1c-087b91e52056.jpg?v=1778651005"
  },
  {
    "sku": "FC2118123WH",
    "title": "Jota S 122cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2118123WH_ca5dffdf-427b-4d87-bb27-a023b640bb1c.jpg?v=1778651027"
  },
  {
    "sku": "FC2110123WH",
    "title": "Jota S 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC2110123WH_047d8001-c4a0-40ed-95b8-ed9c14022244.jpg?v=1778651055"
  },
  {
    "sku": "FC1128143BB",
    "title": "Juno 142cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Juno-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-6784_3cc3c771-e0ed-41a5-9f90-c77d7fb6f851.jpg?v=1778651079"
  },
  {
    "sku": "FC1120143WW",
    "title": "Juno 142cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Juno-DC-Ceiling-Fan-with-Remote-Mercator-7579_19042d78-57fe-4f04-82f1-e420f755bc78.jpg?v=1778651084"
  },
  {
    "sku": "FC1120143BB",
    "title": "Juno 142cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Juno-DC-Ceiling-Fan-with-Remote-Mercator-7579_19042d78-57fe-4f04-82f1-e420f755bc78.jpg?v=1778651084"
  },
  {
    "sku": "FC1120143BB",
    "title": "Juno Black 142cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Juno-DC-Ceiling-Fan-with-Remote-Mercator-7058_d371d3f7-a22f-4025-83b5-6d81792160fb.jpg?v=1778651087"
  },
  {
    "sku": "BH182ESWWH",
    "title": "Jupiter CCT 3 in 1 Bathroom Solution",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BH182ESWWH_9e415ffc-8e6a-49e7-9340-04c8ab1e526a.jpg?v=1778651091"
  },
  {
    "sku": "BH182ESWBK",
    "title": "Jupiter CCT 3 in 1 Bathroom Solution",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BH182ESWWH_9e415ffc-8e6a-49e7-9340-04c8ab1e526a.jpg?v=1778651091"
  },
  {
    "sku": "MWL012",
    "title": "Kaden Wall Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Kaden-Wall-Lamp-Mercator-7660_96ae1456-1a01-4ca6-85f1-f85b0894d332.jpg?v=1778651093"
  },
  {
    "sku": "MTBL016",
    "title": "Kai Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Kai-Table-Lamp-Mercator-5237_9de8a6c0-7cbe-4272-b76e-0250c1e04f76.jpg?v=1778651097"
  },
  {
    "sku": "MTBL030",
    "title": "Kari Wood Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Kari-Wood-Table-Lamp-Mercator-4023_17a310a9-cf0c-4346-9642-85af3ec3550c.jpg?v=1778651101"
  },
  {
    "sku": "MK1020",
    "title": "Keith LED Worklight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Keith-LED-Worklight-Mercator-4592_2d3379ff-20ba-4e96-b3fb-6db88fa203c3.jpg?v=1778651104"
  },
  {
    "sku": "FC190139RB",
    "title": "Kewarra 133cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Kewarra-AC-Ceiling-Fan-Mercator-376_6ff13dfe-09e9-4cd4-8812-12d98b3ef49e.jpg?v=1778651107"
  },
  {
    "sku": "MTBL050",
    "title": "Khari Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Khari-Table-Lamp-Mercator-5414_ef7e5351-90c0-4051-8e53-e171f9bb1ea4.jpg?v=1778651110"
  },
  {
    "sku": "MG2831S",
    "title": "Kirby 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Kirby-1Lt-Pendant-Light-Mercator-3523_b55fc4f0-e60b-43c2-885c-e3e6be44ad00.jpg?v=1778651114"
  },
  {
    "sku": "MTBL015",
    "title": "Koa Textured Ceramic Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Koa-Textured-Ceramic-Table-Lamp-Mercator-9356_b50ca211-8fb7-44d0-97fd-fbb6307da210.jpg?v=1778651117"
  },
  {
    "sku": "MTL003BLU",
    "title": "Koda Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Koda-Table-Lamp-Mercator-4911_960b3bfb-51d5-4a15-add1-45c50861b044.jpg?v=1778651123"
  },
  {
    "sku": "MP3531S",
    "title": "Kosta 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Kosta-1Lt-Small-Pendant-Light-Mercator-1484_b4b0333e-ab5c-4652-99f9-b6b6d81fa0e5.jpg?v=1778651136"
  },
  {
    "sku": "MTBL064",
    "title": "Kove Ceramic Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTBL064_1_c6c7588f-2ded-441d-a960-17fc0b4984b9.jpg?v=1778651139"
  },
  {
    "sku": "MG4131L",
    "title": "Kristov 1Lt  Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Kristov-1Lt-Small-Pendant-Light-Mercator-6269_50ffe5eb-11f5-4e3d-b561-9c92ae8e3d7c.jpg?v=1778651142"
  },
  {
    "sku": "FG252134",
    "title": "LAMP DIFFUSER ONLY CAPRICE",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "FG922124",
    "title": "LAMP DIFFUSER ONLY GLASS",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "MWL001BRS",
    "title": "Lana Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lana-Wall-Light-Mercator-7403_bed26755-cb9b-42fa-a55c-e33ff8329b08.jpg?v=1778651148"
  },
  {
    "sku": "MWL001SN",
    "title": "Lana Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lana-Wall-Light-Mercator-7403_bed26755-cb9b-42fa-a55c-e33ff8329b08.jpg?v=1778651148"
  },
  {
    "sku": "MWL001BRS",
    "title": "Lana Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lana-Wall-Light-Mercator-7403_481b7c65-1f5d-45c1-b91a-c500111fd768.jpg?v=1778651151"
  },
  {
    "sku": "MF4318",
    "title": "Lara 18W LED CCT Batten Fix Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lara-18W-LED-CCT-Batten-Fix-Light-Mercator-6679_0e2b7ae3-7ae2-45e1-99ba-ec5066a607af.jpg?v=1778651155"
  },
  {
    "sku": "MF4304",
    "title": "Lara 4W LED CCT Batten Fix Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lara-4W-LED-CCT-Batten-Fix-Light-Mercator-5384_99177116-ea53-423d-b893-a3060f3114fc.jpg?v=1778651158"
  },
  {
    "sku": "MF4309",
    "title": "Lara 9W LED CCT Batten Fix Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lara-9W-LED-CCT-Batten-Fix-Light-Mercator-8158_2b8accd2-bf4e-43a2-aab3-01d8b7bc693f.jpg?v=1778651162"
  },
  {
    "sku": "MG6531L",
    "title": "Laya 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Laya-1Lt-Large-Pendant-Light-Mercator-4291_f1ee7891-f381-470c-9e47-b032ccd72b71.jpg?v=1778651165"
  },
  {
    "sku": "MG6531S",
    "title": "Laya 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Laya-1Lt-Small-Pendant-Light-Mercator-9195_d9ceab42-3a79-48a8-924d-68152b722615.jpg?v=1778651169"
  },
  {
    "sku": "AUL1073WHT",
    "title": "Lennox Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1073WHT_5bbbfe52-5e08-43ba-8242-ca57354816a6.jpg?v=1778651173"
  },
  {
    "sku": "MW5611BRZ",
    "title": "Leona Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Leona-Wall-Light-Mercator-515_2590a7cd-8c0e-4923-93ac-441df8c733ff.jpg?v=1778651178"
  },
  {
    "sku": "MW5611BLK",
    "title": "Leona Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Leona-Wall-Light-Mercator-515_2590a7cd-8c0e-4923-93ac-441df8c733ff.jpg?v=1778651178"
  },
  {
    "sku": "MI9000",
    "title": "Lift Shaft Single T8 LED Tube Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lift-Shaft-Single-T8-LED-Tube-Batten-Light-Mercator-8958_3548af95-d39f-44ec-ac36-7a95e28433b7.jpg?v=1778651182"
  },
  {
    "sku": "MI9200",
    "title": "Lift Shaft Twin T8 LED Tube Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lift-Shaft-Twin-T8-LED-Tube-Batten-Light-Mercator-6532_e81ffc99-f8d0-47f6-bbea-9b9f494a28aa.jpg?v=1778651186"
  },
  {
    "sku": "MG6123",
    "title": "Liverpool 3Lt Round Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Liverpool-3Lt-Round-Pendant-Light-Mercator-3568_77f43157-8ce1-46e3-b6aa-64924bcdfff2.jpg?v=1778651190"
  },
  {
    "sku": "MG6124",
    "title": "Liverpool 4Lt Round Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Liverpool-4Lt-Round-Pendant-Light-Mercator-5432_13734ca2-7847-4890-ad2f-c7d69b57b2eb.jpg?v=1778651193"
  },
  {
    "sku": "MG6125",
    "title": "Liverpool 5Lt Oval Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Liverpool-5Lt-Oval-Pendant-Light-Mercator-4658_b76b6671-d4bc-45eb-a483-2dec81f41145.jpg?v=1778651196"
  },
  {
    "sku": "MLC001",
    "title": "Load Correction Device",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Load-Correction-Device-Mercator-3827_1cb48349-d60d-428d-a254-8a4a760c7e57.jpg?v=1778651199"
  },
  {
    "sku": "A46321AB",
    "title": "Logan Uplighter Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Logan-Uplighter-Floor-Lamp-Mercator-2006_f8d8c4c6-2c50-4d69-ab75-58a000d0b403.jpg?v=1778651203"
  },
  {
    "sku": "MG4931BLK",
    "title": "Lois 1Lt Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lois-1Lt-Pendant-Mercator-5738_5e0661b5-07e6-4118-8ce8-7a9d2c14b23b.jpg?v=1778651206"
  },
  {
    "sku": "FC920124WH",
    "title": "Lonsdale 120cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lonsdale-AC-Ceiling-Fan-Mercator-3855.jpg?v=1778651225"
  },
  {
    "sku": "FC922124WH",
    "title": "Lonsdale 120cm AC Ceiling Fan with Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lonsdale-AC-Ceiling-Fan-with-Light-Mercator-6144_cce442af-9139-43b3-9c35-def9b8ade888.jpg?v=1778651230"
  },
  {
    "sku": "FC922124RWH",
    "title": "Lonsdale 120cm AC Ceiling Fan with Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lonsdale-AC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-8477.jpg?v=1778653770"
  },
  {
    "sku": "FC922124RBC",
    "title": "Lonsdale 120cm AC Ceiling Fan with Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lonsdale-AC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-8477.jpg?v=1778653770"
  },
  {
    "sku": "FC1138153BK",
    "title": "Lora 152cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lora-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-1683_268a7276-7688-4c36-9f1f-890fa2b39c28.jpg?v=1778651396"
  },
  {
    "sku": "FC1130153WH",
    "title": "Lora 152cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lora-DC-Ceiling-Fan-with-Remote-Mercator-9865_d53d2075-9fac-47ec-8914-25439fa6c267.jpg?v=1778651399"
  },
  {
    "sku": "A40211",
    "title": "Lottie Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lottie-Table-Lamp-Mercator-1143_f71ae0bf-795d-4b40-a1e6-4f739c64bbe6.jpg?v=1778651402"
  },
  {
    "sku": "MA4918",
    "title": "Lovato 18W LED Ceiling Light CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lovato-18W-LED-Ceiling-Light-Mercator-3524_2412f659-e347-4304-9068-05342fd44f5f.jpg?v=1778651406"
  },
  {
    "sku": "MA4930",
    "title": "Lovato 30W LED Ceiling Light CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lovato-30W-LED-Ceiling-Light-Mercator-3978_1ea6efa6-50c5-4204-9618-ec1cb6efb859.jpg?v=1778651410"
  },
  {
    "sku": "MI8540TRI",
    "title": "Luca 120cm Dual power Tri-proof LED Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Luca-IP65-120cm-20-40W-Dual-Power-LED-Batten-Light-Mercator-6020_ff556f09-7930-47a6-bb98-dbd4e10297f9.jpg?v=1778651416"
  },
  {
    "sku": "MI8520TRI",
    "title": "Luca 60cm Dual power Tri-proof LED Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Luca-IP65-60cm-10-20W-Dual-Power-LED-Batten-Light-Mercator-474_1ffd5b39-dbfc-43db-a542-c7a9038099a6.jpg?v=1778651418"
  },
  {
    "sku": "MPLS007",
    "title": "Lucian 1Lt Mini Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lucian-1Lt-Mini-Pendant-Light-Mercator-4253_1df31ea5-73b9-42ec-acab-d681efaf8f4f.jpg?v=1778651422"
  },
  {
    "sku": "MTBL014BLK",
    "title": "Luciano Opal Ball Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Luciano-Opal-Ball-Table-Lamp-Mercator-1880_ab9c3e94-fbaf-4a15-9282-f3616f479cba.jpg?v=1778651426"
  },
  {
    "sku": "A38111WHT",
    "title": "Lucy Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lucy-Table-Lamp-Mercator-5943_f8bfd787-a8fd-4c17-8dfd-b557d36270d6.jpg?v=1778651431"
  },
  {
    "sku": "FC550134BK",
    "title": "Luna 130cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Luna-Ceiling-Fan-Mercator-3617_8d94f0f9-736d-4bec-ae3b-9c61c6abb412.jpg?v=1778651443"
  },
  {
    "sku": "FC550134BS",
    "title": "Luna 130cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Luna-Ceiling-Fan-Mercator-3617_8d94f0f9-736d-4bec-ae3b-9c61c6abb412.jpg?v=1778651443"
  },
  {
    "sku": "MPLS516",
    "title": "Mackenzie 1Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mackenzie-1Lt-Light-Pendant-Mercator-1787_3f84c07a-ea4d-4430-b7f7-19fea9353b49.jpg?v=1778651482"
  },
  {
    "sku": "MG1631M-BLK",
    "title": "Madrid 1Lt Medium Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Madrid-1Lt-Medium-Pendant-Light-Mercator-1003_58ef9ace-a3ee-4252-987e-2b034ec01f70.jpg?v=1778651485"
  },
  {
    "sku": "MG1631S",
    "title": "Madrid 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Madrid-1Lt-Small-Pendant-Light-Mercator-6499_d74f81ad-2384-48a9-884e-26dcfaeb5fb2.jpg?v=1778651489"
  },
  {
    "sku": "MG1631S-BLK",
    "title": "Madrid 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Madrid-1Lt-Small-Pendant-Light-Mercator-6499_d74f81ad-2384-48a9-884e-26dcfaeb5fb2.jpg?v=1778651489"
  },
  {
    "sku": "MTBL033",
    "title": "Maidstone Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Maidstone-Table-Lamp-Mercator-8333_2a8a0b7a-4fdc-418e-8430-5b43734f2992.jpg?v=1778651493"
  },
  {
    "sku": "MX88011S",
    "title": "Maine Coach Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Maine-Coach-Light-Mercator-962_702b2489-c1e7-486d-92a5-723e6d46b503.jpg?v=1778651498"
  },
  {
    "sku": "FC757124WH",
    "title": "Major 122cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Major-AC-Ceiling-Fan-with-LED-Light-Mercator-8249_95bff80e-320f-4c50-9533-41f3e0c560ef.jpg?v=1778651511"
  },
  {
    "sku": "MG6221L",
    "title": "Manchester 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Manchester-1Lt-Large-Pendant-Light-Mercator-5798_4ee5ed62-bbc2-47d8-bf9b-a85eff41bb63.jpg?v=1778651514"
  },
  {
    "sku": "MG6221S",
    "title": "Manchester 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Manchester-1Lt-Small-Pendant-Light-Mercator-3141.jpg?v=1778651517"
  },
  {
    "sku": "MG6223",
    "title": "Manchester 3Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Manchester-3Lt-Small-Pendant-Light-Mercator-6163_3c3fb55f-c708-4f48-9a8a-54161eadf256.jpg?v=1778651522"
  },
  {
    "sku": "MG6271",
    "title": "Manchester DIY Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Manchester-Outdoor-DIY-Ceiling-Fixture-Mercator-1547_af6a782a-2c91-4fa6-a702-687574b68bc0.jpg?v=1778651525"
  },
  {
    "sku": "FLF022BCN",
    "title": "MANTRA 2X15W E27 CFL BC FAN LT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "FLF022WHN",
    "title": "MANTRA 2X15W E27 CFL WH FAN LT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "FLF022BCN",
    "title": "Mantra 2x15W E27 Fan Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FLF022AB.jpg?v=1778651530"
  },
  {
    "sku": "FLF022WHN",
    "title": "Mantra 2x15W E27 Fan Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FLF022AB.jpg?v=1778651530"
  },
  {
    "sku": "A57411GRN",
    "title": "Marie Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marie-Table-Lamp-Mercator-7041_9413fadb-0ee5-4454-b203-fc01fd50948b.jpg?v=1778651534"
  },
  {
    "sku": "MG3981",
    "title": "Marilyn Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marilyn-Floor-Lamp-Mercator-1489_89ac725f-0d01-46f1-bc4e-590c6dd8a74a.jpg?v=1778651537"
  },
  {
    "sku": "MG3961",
    "title": "Marilyn Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marilyn-Table-Lamp-Mercator-8383_fabc2982-7860-4fcb-b888-fdc0c1fa2d70.jpg?v=1778651541"
  },
  {
    "sku": "32316-47",
    "title": "Marina Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marina-Floor-Lamp-Mercator-7519_d3482305-d43c-415d-95e5-c466d9baaa2d.jpg?v=1778651544"
  },
  {
    "sku": "31316-47",
    "title": "Marina Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marina-Table-Lamp-Mercator-9596_1ee31f17-c5cd-486f-a420-d793efae3f02.jpg?v=1778651548"
  },
  {
    "sku": "MBL002BLK",
    "title": "Marshall 18W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marshall-18W-LED-Wall-Light-Mercator-4078_2247ae4a-c40e-4c03-8f98-959be90085d0.jpg?v=1778651553"
  },
  {
    "sku": "MBL002WHT",
    "title": "Marshall 18W LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marshall-18W-LED-Wall-Light-Mercator-4078_2247ae4a-c40e-4c03-8f98-959be90085d0.jpg?v=1778651553"
  },
  {
    "sku": "MXD1035",
    "title": "Marvin II LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marvin-II-LED-Up-Down-Wall-Light-Mercator-6493_e64c3d33-2c6a-46ef-b073-cfd89410fe4e.jpg?v=1778651557"
  },
  {
    "sku": "MXD1035-SEN",
    "title": "Marvin II LED Up/Down Wall Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Marvin-II-LED-Up-Down-Wall-Light-with-Sensor-Mercator-1476_e898b801-d66b-4034-8302-cec23f6a7b90.jpg?v=1778651560"
  },
  {
    "sku": "MW4811CH",
    "title": "Mason Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mason-Wall-Light-Mercator-7020_fb1a77f2-5fde-4634-846c-0a3c9c8d291f.jpg?v=1778651564"
  },
  {
    "sku": "GO9209IBLK",
    "title": "Mast Three Circuit Tracks & Accessories I Shape",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mast-Three-Circuit-Tracks-Accessories-I-Shape-Mercator-676_1aec30bd-5624-444e-b062-25f36aab752e.jpg?v=1778651568"
  },
  {
    "sku": "GO9209IWHT",
    "title": "Mast Three Circuit Tracks & Accessories I Shape",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mast-Three-Circuit-Tracks-Accessories-I-Shape-Mercator-676_1aec30bd-5624-444e-b062-25f36aab752e.jpg?v=1778651568"
  },
  {
    "sku": "GO9209LBLK",
    "title": "Mast Three Circuit Tracks & Accessories L Shape",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mast-Three-Circuit-Tracks-Accessories-L-Shape-Mercator-8889_b50bb613-b3d7-4724-81cb-8b790abdd0b8.jpg?v=1778651571"
  },
  {
    "sku": "GO9209LWHT",
    "title": "Mast Three Circuit Tracks & Accessories L Shape",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mast-Three-Circuit-Tracks-Accessories-L-Shape-Mercator-8889_b50bb613-b3d7-4724-81cb-8b790abdd0b8.jpg?v=1778651571"
  },
  {
    "sku": "MD385W-TRI",
    "title": "Mateo 15W LED Tri-Colour Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mateo-15W-LED-Tri-Colour-Downlight-Mercator-9949_eb69a147-94dc-4d7b-9921-fe7ebc1b9d8f.jpg?v=1778651575"
  },
  {
    "sku": "MD380W-TRI",
    "title": "Mateo 9W Tri-Colour LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mateo-9W-Tri-Colour-LED-Downlight-Mercator-9835_f640dc04-b7f8-465f-9254-3ff1b4e15e2f.jpg?v=1778651578"
  },
  {
    "sku": "MD664B",
    "title": "Matthis 12W Down-Rod Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Matthis-12W-Down-Rod-Downlight-Mercator-9635_ffac7cba-2a6b-4457-a4f9-962f0680d8a8.jpg?v=1778651582"
  },
  {
    "sku": "MD664W",
    "title": "Matthis 12W Down-Rod Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Matthis-12W-Down-Rod-Downlight-Mercator-9635_ffac7cba-2a6b-4457-a4f9-962f0680d8a8.jpg?v=1778651582"
  },
  {
    "sku": "MA7111",
    "title": "Maxim Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Maxim-Wall-Light-Mercator-6842_16e05075-981e-4d01-a184-524761a71aca.jpg?v=1778651586"
  },
  {
    "sku": "MPLS028L-BLK",
    "title": "Medine 1Lt Large LED with Remote Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Medine-1Lt-Large-LED-with-Remote-Pendant-Light-Mercator-8948_9283c8c4-d71f-45eb-ac05-81091a9f671e.jpg?v=1778651589"
  },
  {
    "sku": "MPLS028L-BLK",
    "title": "Medine 1Lt Large LED with Remote Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Medine-1Lt-Large-LED-with-Remote-Pendant-Light-Mercator-8948_09f2ac9a-0903-4b55-a381-0d388ebe70bd.jpg?v=1778651593"
  },
  {
    "sku": "MPLS028S-BLK",
    "title": "Medine 1Lt Small LED with Remote Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Medine-1Lt-Small-LED-with-Remote-Pendant-Light-Mercator-7572_14f4f649-748f-48c9-b422-180fed79e491.jpg?v=1778651596"
  },
  {
    "sku": "MPLS028S-BRS",
    "title": "Medine 1Lt Small LED with Remote Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Medine-1Lt-Small-LED-with-Remote-Pendant-Light-Mercator-7572_14f4f649-748f-48c9-b422-180fed79e491.jpg?v=1778651596"
  },
  {
    "sku": "MPLS028S-BLK",
    "title": "Medine 1Lt Small LED with Remote Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Medine-1Lt-Small-LED-with-Remote-Pendant-Light-Mercator-7572_3879ece1-9616-484d-836a-a810cb158409.jpg?v=1778651600"
  },
  {
    "sku": "MTBL027",
    "title": "Meira Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Meira-Table-Lamp-Mercator-898_37ad5a81-6b4a-4ae9-a25a-40e64f20609d.jpg?v=1778651605"
  },
  {
    "sku": "MP7131LBLK",
    "title": "Melba 1Lt Long Glass Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Melba-1Lt-Long-Glass-Pendant-Light-Mercator-5849_564b934b-0327-4d00-8185-97a73b953529.jpg?v=1778651618"
  },
  {
    "sku": "MP7131S",
    "title": "Melba 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Melba-1Lt-Small-Pendant-Light-Mercator-9925_b8be99b2-0539-4e8c-a8e2-5eabbccfa0c6.jpg?v=1778651621"
  },
  {
    "sku": "MP7131SBLK",
    "title": "Melba 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Melba-1Lt-Small-Pendant-Light-Mercator-9925_b8be99b2-0539-4e8c-a8e2-5eabbccfa0c6.jpg?v=1778651621"
  },
  {
    "sku": "MTBL040L-GRY",
    "title": "Mentone Large Textured Concrete Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mentone-Large-Textured-Concrete-Table-Lamp-Mercator-1332_349632df-eaa0-4698-907a-c29729308471.jpg?v=1778651624"
  },
  {
    "sku": "MTBL040S-GRY",
    "title": "Mentone Small Textured Concrete Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mentone-Small-Textured-Concrete-Table-Lamp-Mercator-5702_d9b6a396-e365-4c3d-bec3-12d0f142665e.jpg?v=1778651628"
  },
  {
    "sku": "FC828134BHA",
    "title": "Mercator Black Smart Grid Connect 132cm 4 Blade Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC828134BHA.jpg?v=1779274757"
  },
  {
    "sku": "SGW103",
    "title": "Mercator Iku Matter Pro Hub",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000068M.pdf?v=1778045168",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SGW103_MRIN008605_OL.pdf?v=1778196902",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SGW103HERO_RGB_ec5a594f-8d91-4990-b382-1a3ec5aac494.webp?v=1778651631"
  },
  {
    "sku": "SPPUSB02GC-ZB",
    "title": "Mercator Iku Smart Zigbee Touch Control Double Power Point With USB A+C",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000067Z.pdf?v=1779247350",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPPUSB02GC-ZB_b8b9aa98-015d-4dd6-9ab4-baf968d2ac2e.jpg?v=1778651635"
  },
  {
    "sku": "SPPUSB02GCMBK-ZB",
    "title": "Mercator Iku Smart Zigbee Touch Control Double Power Point With USB A+C",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000067Z.pdf?v=1779247350",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SPPUSB02GC-ZB_b8b9aa98-015d-4dd6-9ab4-baf968d2ac2e.jpg?v=1778651635"
  },
  {
    "sku": "MLC001",
    "title": "MERCATOR LOAD CORRECTION",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "FC8128133WHA",
    "title": "Mercator White Smart Grid Connect 132cm 3 Blade Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC8128133WHA.jpg?v=1779269975"
  },
  {
    "sku": "BE6000SPWH",
    "title": "Mercator Zealine 255 DC Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE6000SPWH_8c95f2ca-8e2e-4e96-b701-39bf49aabeb7.jpg?v=1778651639"
  },
  {
    "sku": "BE600ESPWH",
    "title": "Mercator Zealine 255 DC with CCT LED Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE600ESPWH_64b3be39-6841-4285-9601-63c5db9f09ad.jpg?v=1778651642"
  },
  {
    "sku": "BE6100SPWH",
    "title": "Mercator Zealine 300 DC Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE6100SPWH_7e5752bc-6f5e-480d-b4c5-ca6cfab3e4c6.jpg?v=1778651647"
  },
  {
    "sku": "BE610ESPWH",
    "title": "Mercator Zealine 300 DC with CCT LED Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE610ESPWH_130ba071-896f-48f4-b38f-fe5297029556.jpg?v=1778651650"
  },
  {
    "sku": "MTBL009WHT",
    "title": "Mercer Decorative Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mercer-Decorative-Table-Lamp-Mercator-8384_cdf50550-b482-4822-b53c-b38afab8b0c8.jpg?v=1778651653"
  },
  {
    "sku": "BH212ESWBK",
    "title": "Mercury CCT 3 in 1 Bathroom Solution",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mercury-CCT-3-in-1-Bathroom-Solution-Mercator-1559_bcee8e24-273e-4c12-ab94-9b9983fb795b.jpg?v=1778651657"
  },
  {
    "sku": "BH212ESWWH",
    "title": "Mercury CCT 3 in 1 Bathroom Solution",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mercury-CCT-3-in-1-Bathroom-Solution-Mercator-1559_bcee8e24-273e-4c12-ab94-9b9983fb795b.jpg?v=1778651657"
  },
  {
    "sku": "BH202ESWWH",
    "title": "Mercury Lite 3-in-1 Bathroom Heater with Exhaust Fan and CCT LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BH202ESWWH_1_3da7a346-b14d-4a6c-b906-4f91689ea300.jpg?v=1778651661"
  },
  {
    "sku": "MF3625CCT",
    "title": "Metro 25W LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Metro-25W-LED-CCT-Batten-Light-Mercator-395_da079c1f-e9bf-45fc-87d7-8330d2ebff52.jpg?v=1778651664"
  },
  {
    "sku": "MF3648CCT",
    "title": "Metro 48W LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Metro-48W-LED-CCT-Batten-Light-Mercator-3547_9a15df48-16b2-4916-a486-4a3cd3a62bbc.jpg?v=1778651667"
  },
  {
    "sku": "MD599S-5",
    "title": "Mezzo 12W 5000K LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MD599S-5_8b309d66-cc0d-4788-8e4d-bc1264b5bf92.jpg?v=1778651672"
  },
  {
    "sku": "XSEN003MW-BLK",
    "title": "Microwave Outdoor Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Microwave-Outdoor-Sensor-Mercator-6353_b2c41100-6060-4235-8c1b-9587804593ec.jpg?v=1778651677"
  },
  {
    "sku": "BS132ESWWH",
    "title": "Midas Duo 3-in-1 Bathroom Heater with Exhaust Fan and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Midas-Duo-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-LED-Light-Mercator-40920541_ce17f2c4-70b8-4f0f-a82b-553b51884a33.jpg?v=1778651681"
  },
  {
    "sku": "BS134ESWWH",
    "title": "Midas Quattro 3-in-1 Bathroom Heater with Exhaust Fan and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Midas-Quattro-3-in-1-Bathroom-Heater-with-Exhaust-Fan-and-LED-Light-Mercator-40921019_d4cae819-0028-406a-8578-c03a5e300e1e.jpg?v=1778651685"
  },
  {
    "sku": "MFL044",
    "title": "Mika Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mika-Floor-Lamp-Mercator-788_1d258624-1119-4586-bce2-944923f5a93f.jpg?v=1778651689"
  },
  {
    "sku": "MTBL044",
    "title": "Mika Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mika-Table-Lamp-Mercator-8733_432c8da1-bafc-443a-b0f5-1a05f85c4127.jpg?v=1778651703"
  },
  {
    "sku": "MPLS509WHT",
    "title": "Milford 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPLS509WHT_84943f88-ce3a-4682-a607-956168456da6.jpg?v=1778651706"
  },
  {
    "sku": "MC1000BKCCT",
    "title": "Millan 18W LED CCT Ceiling Light with Black Trim",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Millan-18W-Integrated-LED-ceiling-Light-Mercator-3330_1804042a-f361-4470-a0aa-c27686a671a3.jpg?v=1778651709"
  },
  {
    "sku": "MC1001BKCCT",
    "title": "Millan 24W LED CCT Ceiling Light With Black Trim",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Millan-24W-Integrated-LED-ceiling-Light-Mercator-8802_e32c0931-4432-4c77-8f4a-45629f0091f0.jpg?v=1778651712"
  },
  {
    "sku": "FC628133GWH",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC628133GWH_8a89b92f-1859-4306-9ac9-c16b3c68c1a7.png?v=1778651717"
  },
  {
    "sku": "FC628133GBK",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC628133GWH_8a89b92f-1859-4306-9ac9-c16b3c68c1a7.png?v=1778651717"
  },
  {
    "sku": "FC628133GBC",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC628133GWH_8a89b92f-1859-4306-9ac9-c16b3c68c1a7.png?v=1778651717"
  },
  {
    "sku": "FC628133GBK",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with LED Light and Remote",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000006W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005892_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC628133GBK_36ce7eed-1d50-4ceb-ae0f-a60844e77095.png?v=1778651721"
  },
  {
    "sku": "FC620133GBK",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with Remote",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000006W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005892_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC620133GBK_659b3618-a6d2-45ca-87e4-7eb384949068.png?v=1778651726"
  },
  {
    "sku": "FC620133GWH",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with Remote",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000006W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005892_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC620133GBK_659b3618-a6d2-45ca-87e4-7eb384949068.png?v=1778651726"
  },
  {
    "sku": "FC620133GBC",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with Remote",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000006W_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005892_Pairing_Guide.pdf?v=1776661658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC620133GBK_659b3618-a6d2-45ca-87e4-7eb384949068.png?v=1778651726"
  },
  {
    "sku": "FC620133GBK",
    "title": "Minota 132cm DC Iku Smart Wi-Fi Ceiling Fans with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC620133GBK_c7035272-1121-4c9e-8e98-d5dc8dc1ab02.png?v=1778651729"
  },
  {
    "sku": "MG4031L",
    "title": "Moby 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Moby-1Lt-Large-Pendant-Light-Mercator-3462_f1990c94-efd0-4dae-b724-fd9cbe2ef34b.jpg?v=1778651732"
  },
  {
    "sku": "MG4031S",
    "title": "Moby 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Moby-1Lt-Small-Pendant-Light-Mercator-8157_eae0c783-6739-4cf5-aedf-8ab8a0ac42f3.jpg?v=1778651736"
  },
  {
    "sku": "MG4061",
    "title": "Moby Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Moby-Table-Lamp-Mercator-5986_5194ec9e-884a-4cda-9c15-85a00fae7550.jpg?v=1778651740"
  },
  {
    "sku": "MPLS005",
    "title": "MOD 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MOD-1Lt-Pendant-Light-Mercator-6314_301fad81-f614-4314-baae-8c5e4b3aebfe.jpg?v=1778651451"
  },
  {
    "sku": "MPLS005SMK",
    "title": "MOD 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MOD-1Lt-Pendant-Light-Mercator-6314_301fad81-f614-4314-baae-8c5e4b3aebfe.jpg?v=1778651451"
  },
  {
    "sku": "A13111BLK",
    "title": "Modd Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Modd-Table-Lamp-Mercator-6675_642dd2d7-cefd-4179-bdae-bc593391ca2e.jpg?v=1778651744"
  },
  {
    "sku": "A48611AB",
    "title": "Molly Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A48611AB_9839aaaf-bfb4-4bd0-8e57-3220921b9988.jpg?v=1778651747"
  },
  {
    "sku": "MG6031L",
    "title": "Morrissey 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Morrissey-1Lt-Large-Pendant-Light-Mercator-3757_b150b58d-4c59-431d-9559-9d1247de70c9.jpg?v=1778651750"
  },
  {
    "sku": "MG6031S",
    "title": "Morrissey 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Morrissey-1Lt-Small-Pendant-Light-Mercator-2020_27e05033-bfc8-454f-8bcc-a985cfa878bf.jpg?v=1778651755"
  },
  {
    "sku": "MGL090GD",
    "title": "MR16 Day Light Dim36D Glass LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MR16-5700K-Dim36D-Glass-LED-Globe-Mercator-6432_8537af60-5e59-4af9-8a75-a5c38214fe28.jpg?v=1778651456"
  },
  {
    "sku": "MGL090D-D",
    "title": "MR16 Day Light Dim36D LED  Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL090D-D_25216875-776e-4daa-acf3-2bf2c9ff0b58.jpg?v=1778651459"
  },
  {
    "sku": "MGL092GD",
    "title": "MR16 Day Light Dim60D Glass LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MR16-5700K-Dim60D-Glass-LED-Globe-Mercator-6802_c559302d-6f1c-4db6-8913-500689fa9368.jpg?v=1778651463"
  },
  {
    "sku": "MGL092D-D",
    "title": "MR16 Day Light Dim60D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL092D-D_841ef977-c680-4f99-9ccc-3e5a7b367eb6.jpg?v=1778651466"
  },
  {
    "sku": "MGL090GW",
    "title": "MR16 Warm White Dim36D Glass LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MR16-3000K-Dim36D-Glass-LED-Globe-Mercator-617_6ae83e09-f558-49f4-bfe4-013f35848124.jpg?v=1778651469"
  },
  {
    "sku": "MGL090W-D",
    "title": "MR16 Warm White Dim36D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL090W-D_30266b5d-6f25-47a1-8f11-f6fbe81be000.jpg?v=1778651472"
  },
  {
    "sku": "MGL092GW",
    "title": "MR16 Warm White Dim60D Glass LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MR16-3000K-Dim60D-Glass-LED-Globe-Mercator-6891_d9f02c29-32b1-4309-96a8-ff67d18e5e8f.jpg?v=1778651475"
  },
  {
    "sku": "MGL092W-D",
    "title": "MR16 Warm White Dim60D LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MGL092W-D_ba858bfe-5ad5-4a2e-9acf-a0708eee9d9c.jpg?v=1778651478"
  },
  {
    "sku": "X330MWDIM",
    "title": "Multi-Way Universal Rotary Dimmer",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Multi-Way-Universal-Rotary-Dimmer-Mercator-1792_de0d2ca8-8679-45aa-8859-be39957bf9de.jpg?v=1778651757"
  },
  {
    "sku": "MA906W-SN",
    "title": "Murano 15cm Alabaster DIY Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Murano-15cm-Alabaster-DIY-Ceiling-Fixture-Mercator-737_1f4ece60-f3e5-4442-8a44-28e15a58184a.jpg?v=1778651762"
  },
  {
    "sku": "MA906C-BLK",
    "title": "Murano 15cm Alabaster DIY Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Murano-15cm-Alabaster-DIY-Ceiling-Fixture-Mercator-737_1f4ece60-f3e5-4442-8a44-28e15a58184a.jpg?v=1778651762"
  },
  {
    "sku": "MA908W-SN",
    "title": "Murano 20cm Alabaster DIY Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Murano-20cm-Alabaster-DIY-Ceiling-Fixture-Mercator-3437_014948d4-89b9-4215-b9ef-96e2e973f2b2.jpg?v=1778651766"
  },
  {
    "sku": "MTBL066",
    "title": "Nami Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTBL066_03094a94-76b3-4a57-a47b-b1725fa7f3b3.png?v=1778651769"
  },
  {
    "sku": "A57811",
    "title": "Natalia Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Natalia-Table-Lamp-Mercator-8385_d85e6c5d-3c5c-4e8c-8910-2554d12b452e.jpg?v=1778651773"
  },
  {
    "sku": "FC708134BK",
    "title": "Nemoi 137cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nemoi-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-3711_22f287d6-69f3-489f-9e6a-bf93ab20afae.jpg?v=1778651778"
  },
  {
    "sku": "FC708134WH",
    "title": "Nemoi 137cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nemoi-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-3711_22f287d6-69f3-489f-9e6a-bf93ab20afae.jpg?v=1778651778"
  },
  {
    "sku": "FC700134WH",
    "title": "Nemoi 137cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nemoi-DC-Ceiling-Fan-with-Remote-Mercator-7418_d6b7c440-a240-46e6-ad17-f46154c6edc1.jpg?v=1778651800"
  },
  {
    "sku": "FC700134BK",
    "title": "Nemoi 137cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nemoi-DC-Ceiling-Fan-with-Remote-Mercator-7418_d6b7c440-a240-46e6-ad17-f46154c6edc1.jpg?v=1778651800"
  },
  {
    "sku": "FC700134WHHA",
    "title": "Nemoi 137cm DC Iku Smart Wi-Fi Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC700134WHHA_d03ef611-756b-4fac-b859-29119495678d.jpg?v=1778651829"
  },
  {
    "sku": "FC700134BKHA",
    "title": "Nemoi 137cm DC Iku Smart Wi-Fi Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC700134WHHA_d03ef611-756b-4fac-b859-29119495678d.jpg?v=1778651829"
  },
  {
    "sku": "FC708134WHHA",
    "title": "Nemoi 137cm DC Iku Smart Wi-Fi Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC708134WHHA_523039fa-2759-405d-bd5d-9240bce89231.jpg?v=1778651852"
  },
  {
    "sku": "FC708134BKHA",
    "title": "Nemoi 137cm DC Iku Smart Wi-Fi Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC708134WHHA_523039fa-2759-405d-bd5d-9240bce89231.jpg?v=1778651852"
  },
  {
    "sku": "FC700133WH",
    "title": "Nemoi 3B 137cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC700133WH_d3098e7c-7e57-448c-95d8-2088383e0e59.jpg?v=1778651877"
  },
  {
    "sku": "FC700133BK",
    "title": "Nemoi 3B 137cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC700133WH_d3098e7c-7e57-448c-95d8-2088383e0e59.jpg?v=1778651877"
  },
  {
    "sku": "FC708133WH",
    "title": "Nemoi 3B 137cm DC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC708133WH_2dce63b7-63e1-42dd-a7f5-bb56cbf0acd5.jpg?v=1778651900"
  },
  {
    "sku": "FC708133BK",
    "title": "Nemoi 3B 137cm DC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC708133WH_2dce63b7-63e1-42dd-a7f5-bb56cbf0acd5.jpg?v=1778651900"
  },
  {
    "sku": "FC708124BK",
    "title": "Nemoi Lite 122cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC708124BK_49f583a3-96cc-450a-8776-a9ea55f81df3.jpg?v=1778651921"
  },
  {
    "sku": "FC708124WH",
    "title": "Nemoi Lite 122cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC708124BK_49f583a3-96cc-450a-8776-a9ea55f81df3.jpg?v=1778651921"
  },
  {
    "sku": "FC700124WH",
    "title": "Nemoi Lite 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC700124WH_6a056540-6c78-4cdf-bc19-ec6b4fb668fa.jpg?v=1778651942"
  },
  {
    "sku": "FC700124BK",
    "title": "Nemoi Lite 122cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC700124WH_6a056540-6c78-4cdf-bc19-ec6b4fb668fa.jpg?v=1778651942"
  },
  {
    "sku": "ML10028CCT",
    "title": "Neo 28W LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Neo-28W-LED-CCT-Batten-Light-Mercator-644_c3bc4c2e-2107-48b4-8992-a995275d2897.jpg?v=1778651961"
  },
  {
    "sku": "ML10040CCT",
    "title": "Neo 40W LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Neo-40W-LED-CCT-Batten-Light-Mercator-3509_037507b1-6331-4a87-91da-48f0d27b4b6c.jpg?v=1778651966"
  },
  {
    "sku": "MXC1010BGE",
    "title": "Nepean II Exterior Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nepean-II-Exterior-Wall-Light-Mercator-2656_7177729f-4bd5-47d5-bbc1-e4c6ee49b826.jpg?v=1778651971"
  },
  {
    "sku": "MXC1010BLK",
    "title": "Nepean II Exterior Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nepean-II-Exterior-Wall-Light-Mercator-2656_7177729f-4bd5-47d5-bbc1-e4c6ee49b826.jpg?v=1778651971"
  },
  {
    "sku": "MPLS019",
    "title": "Newport 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Newport-1Lt-Pendant-Light-Mercator-6067_791380de-c4cc-44ad-ad62-e5a5e38c60c6.jpg?v=1778651988"
  },
  {
    "sku": "MXS0450",
    "title": "Nexa Solar Security Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nexa-Solar-Security-Light-with-PIR-Sensor-Mercator-4467_916b0914-f05e-41ee-8cd2-ab415a4282d9.jpg?v=1778651991"
  },
  {
    "sku": "MXD1050WHT",
    "title": "Nico II LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nico-II-LED-Up-Down-Wall-Light-Mercator-5397_14c40504-adc9-4def-9063-eed9b88d492a.jpg?v=1778651995"
  },
  {
    "sku": "MXD1050BLK",
    "title": "Nico II LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nico-II-LED-Up-Down-Wall-Light-Mercator-5397_14c40504-adc9-4def-9063-eed9b88d492a.jpg?v=1778651995"
  },
  {
    "sku": "SMCL01",
    "title": "Nikola 22W Iku Smart WIFI LED Ceiling Light",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000007W_Data_Sheet.pdf?v=1776661541",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005235_Pairing_Guide.pdf?v=1776661563",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMCL01_e6b1aed6-fa68-4da7-abe9-2c3e7e879ad8.jpg?v=1778652000"
  },
  {
    "sku": "A20034AB",
    "title": "Noah 4 X 5W GU10 Spotlight - Brass & Black Finish",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Noah-4Lt-Spotlight-Mercator-9051_909c46d8-fd16-4ae1-9fa0-c79e88e38366.jpg?v=1778652006"
  },
  {
    "sku": "A20031AB",
    "title": "Noah 5W LED Spotlight - Brass & Black Finish",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Noah-1Lt-Spotlight-Mercator-773_eb7b5bdb-ce18-4a4f-9f82-1f5888a6496c.jpg?v=1778652011"
  },
  {
    "sku": "MP4931L-BLK",
    "title": "Noel 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Noel-1Lt-Large-Pendant-Light-Mercator-9563_635e92f3-aa6b-4d85-af2b-aeca2b2749ca.jpg?v=1778652014"
  },
  {
    "sku": "MP4931S-BLK",
    "title": "Noel 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Noel-1Lt-Small-Pendant-Light-Mercator-2473_7f8b0531-ba3d-4e67-954d-6fab730338e0.jpg?v=1778652019"
  },
  {
    "sku": "MP4931S-WHT",
    "title": "Noel 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Noel-1Lt-Small-Pendant-Light-Mercator-2473_7f8b0531-ba3d-4e67-954d-6fab730338e0.jpg?v=1778652019"
  },
  {
    "sku": "MTK2212WHCCT",
    "title": "Nolan 13W LED Track Light Single Head",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTK2212WHCCT_985d9477-76cf-4f6e-b541-72633dc7ebf4.jpg?v=1778652024"
  },
  {
    "sku": "MTK2212BKCCT",
    "title": "Nolan 13W LED Track Light Single Head",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTK2212WHCCT_985d9477-76cf-4f6e-b541-72633dc7ebf4.jpg?v=1778652024"
  },
  {
    "sku": "MDET566",
    "title": "Non-Contact Ac Voltage Tester",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Non-Contact-Ac-Voltage-Tester-Mercator-8910_30df3d94-3447-4dc4-a268-4e57510f8f13.jpg?v=1778652028"
  },
  {
    "sku": "MTBL022BLK",
    "title": "Nora Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nora-Table-Lamp-Mercator-7614_068791b2-9bcf-48fb-a315-e545a9ba448f.jpg?v=1778652034"
  },
  {
    "sku": "MPLS021BLK",
    "title": "Northcote 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Northcote-1Lt-Pendant-Light-Mercator-5030_f6d4bedf-20db-47b9-8491-608ae27f0231.jpg?v=1778652038"
  },
  {
    "sku": "MPLS021WHT",
    "title": "Northcote 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Northcote-1Lt-Pendant-Light-Mercator-5030_f6d4bedf-20db-47b9-8491-608ae27f0231.jpg?v=1778652038"
  },
  {
    "sku": "MTBL419",
    "title": "Nouveau Noa Terrazzo Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nouveau-Noa-Terrazzo-Table-Lamp-Mercator-2630_184c8b3c-0cc2-449a-8ebc-74a869805c30.jpg?v=1778652043"
  },
  {
    "sku": "BE3500SPWH",
    "title": "Novaline II Large Round Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Novaline-II-Large-Round-Exhaust-Fan-Mercator-8714_2874e36f-fbff-4608-9b49-7200f1f1e719.jpg?v=1778652047"
  },
  {
    "sku": "BE3300SPWH",
    "title": "Novaline II Large Square Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Novaline-II-Large-Square-Exhaust-Fan-Mercator-6451_170f2bc6-3124-4de7-bee1-3149767b848f.jpg?v=1778652052"
  },
  {
    "sku": "BE3400SPWH",
    "title": "Novaline II Small Round Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Novaline-II-Small-Round-Exhaust-Fan-Mercator-1717_ea8e8fb0-da43-4e17-94d8-3a78072d1722.jpg?v=1778652056"
  },
  {
    "sku": "BE3200SPWH",
    "title": "Novaline II Small Square Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Novaline-II-Small-Square-Exhaust-Fan-Mercator-9886_f4260bc7-3849-47b1-b37f-a560ccd2fca7.jpg?v=1778652059"
  },
  {
    "sku": "MTBL042BLK",
    "title": "Nuri Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Nuri-Table-Lamp-Mercator-9027_6d0e419a-937f-4d3b-a63f-b95d539afa7c.jpg?v=1778652064"
  },
  {
    "sku": "MP3731XL",
    "title": "Oasis 1Lt Extra Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Oasis-1Lt-Extra-Large-Pendant-Light-Mercator-8725_7ba9e5a3-a0f8-431a-891f-469b336feb8a.jpg?v=1778652082"
  },
  {
    "sku": "MP3731L",
    "title": "Oasis 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Oasis-1Lt-Large-Pendant-Light-Mercator-4609_9ec41f3a-becf-42d6-8669-316c7b650880.jpg?v=1778652085"
  },
  {
    "sku": "MP3731S",
    "title": "Oasis 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Oasis-1Lt-Small-Pendant-Light-Mercator-7114_163de667-6ee3-4fa3-a16e-78d77eef1425.jpg?v=1778652089"
  },
  {
    "sku": "MA6000",
    "title": "Odean 24W LED CCT and Dimmable Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Oden-Ceiling-Light-Mercator-5890_7e25cc29-98cf-44a6-a2dd-e4e9331192a0.jpg?v=1778652092"
  },
  {
    "sku": "MPLS006BLK",
    "title": "Odin 1Lt LED Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Odin-1Lt-LED-Pendant-Mercator-1496_2b310e9f-17ce-4552-bc18-0c2ee7f03ba3.jpg?v=1778652096"
  },
  {
    "sku": "MPLS006BRS",
    "title": "Odin 1Lt LED Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Odin-1Lt-LED-Pendant-Mercator-1496_2b310e9f-17ce-4552-bc18-0c2ee7f03ba3.jpg?v=1778652096"
  },
  {
    "sku": "MPLS004WHT",
    "title": "Olena 1Lt  Light Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Olena-1Lt-Light-Pendant-Light-Mercator-9109_04b1c9e3-fe20-4255-896c-67b1c65a18e3.jpg?v=1778652102"
  },
  {
    "sku": "CE4123",
    "title": "Olympia 3Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Olympia-3Lt-Pendant-Light-Mercator-3156_5d22783d-14ad-4902-bb30-57daf970c278.jpg?v=1778652106"
  },
  {
    "sku": "CE4124",
    "title": "Olympia 4Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Olympia-4Lt-Pendant-Light-Mercator-5854_3cdfb96f-65f7-4a15-a47a-e552d5083cad.jpg?v=1778652109"
  },
  {
    "sku": "MXD6921BLK",
    "title": "Onyx 1Lt LED Security Floodlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Onyx-1Lt-LED-Security-Floodlight-Mercator-609_637248e2-a00a-4302-8167-6a04fe94bf9d.jpg?v=1778652112"
  },
  {
    "sku": "MXD6921BLK-SEN",
    "title": "Onyx 1Lt LED Security Floodlight with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Onyx-1Lt-LED-Security-Floodlight-with-PIR-Sensor-Mercator-201_7bf72403-d5c3-4f9d-896e-7938fe635480.jpg?v=1778652117"
  },
  {
    "sku": "MXD6923BLK-SEN",
    "title": "Onyx Triple Head LED Security Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Onyx-Triple-Head-LED-Security-Flood-Light-with-PIR-Sensor-Mercator-5538_58acc89b-a59a-4055-8c47-72e8422b2083.jpg?v=1778652120"
  },
  {
    "sku": "MXD6923BLK",
    "title": "Onyx Triple Head Security Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Onyx-Triple-Head-Security-Flood-Light-Mercator-2102_3edfd0f8-7d90-4c9c-9e59-38b0ad44124f.jpg?v=1778652124"
  },
  {
    "sku": "MXD6922BLK",
    "title": "Onyx Twin Head LED Security Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Onyx-Twin-Head-LED-Security-Flood-Light-Mercator-3173_19f5668a-54fd-4422-a463-1d2461cc3540.jpg?v=1778652144"
  },
  {
    "sku": "MXD6922BLK-SEN",
    "title": "Onyx Twin Head LED Security Flood Light with PIR Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Onyx-Twin-Head-LED-Security-Flood-Light-with-PIR-Sensor-Mercator-9419_a81c0fb3-3695-4183-a550-5ea8513d3ec7.jpg?v=1778652148"
  },
  {
    "sku": "MA1806SN",
    "title": "Opal 15cm Ball DIY Batten Fix",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Opal-15cm-Ball-DIY-Batten-Fix-Mercator-2927_f60ee197-9340-411f-b06f-4aeeed32d611.jpg?v=1778652161"
  },
  {
    "sku": "MA1806WHITE",
    "title": "Opal 15cm Ball DIY Batten Fix",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Opal-15cm-Ball-DIY-Batten-Fix-Mercator-2927_f60ee197-9340-411f-b06f-4aeeed32d611.jpg?v=1778652161"
  },
  {
    "sku": "MA1808WHITE",
    "title": "Opal 20cm DIY Batten Fix Ball Shade",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Opal-20cm-DIY-Batten-Fix-Ball-Shade-Mercator-6325_6597bfb1-33a9-4906-88e8-8d4d899279bf.jpg?v=1778652164"
  },
  {
    "sku": "MD510B-SW",
    "title": "Optica Trio 10W 1000lm LED Downlight Series 2",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Optica-Trio-10W-1000lm-LED-Downlight-Series-2-Mercator-8412_5af012c8-16eb-4214-8869-6e3f686d350b.jpg?v=1778652170"
  },
  {
    "sku": "MD510W-SW",
    "title": "Optica Trio 10W 1000lm LED Downlight Series 2",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Optica-Trio-10W-1000lm-LED-Downlight-Series-2-Mercator-8412_5af012c8-16eb-4214-8869-6e3f686d350b.jpg?v=1778652170"
  },
  {
    "sku": "MD510S-SW",
    "title": "Optica Trio 10W 1000lm LED Downlight Series 2",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Optica-Trio-10W-1000lm-LED-Downlight-Series-2-Mercator-8412_5af012c8-16eb-4214-8869-6e3f686d350b.jpg?v=1778652170"
  },
  {
    "sku": "MD490S-TRI",
    "title": "Optica Trio Lite 8W LED Tri-Colour Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Optica-Trio-Lite-8W-LED-Tri-Colour-Downlight-Mercator-5199_73fadffe-e5df-4c99-9a4b-538396f47e92.jpg?v=1778652176"
  },
  {
    "sku": "MWL008BLK",
    "title": "Osbourne LED Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Osbourne-LED-Wall-Light-Mercator-1976_1592bd71-93a4-4dc3-9a9d-618546730c83.jpg?v=1778652182"
  },
  {
    "sku": "MXD6711WHT",
    "title": "Otto II 1Lt LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-1Lt-LED-Flood-Light-Mercator-7670_0a881c81-8351-4c3f-b9d0-54a80bfffb1f.jpg?v=1778652195"
  },
  {
    "sku": "MXD6711SIL",
    "title": "Otto II 1Lt LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-1Lt-LED-Flood-Light-Mercator-7670_0a881c81-8351-4c3f-b9d0-54a80bfffb1f.jpg?v=1778652195"
  },
  {
    "sku": "MXD6711BLK",
    "title": "Otto II 1Lt LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-1Lt-LED-Flood-Light-Mercator-7670_0a881c81-8351-4c3f-b9d0-54a80bfffb1f.jpg?v=1778652195"
  },
  {
    "sku": "MXD6711BLK-SEN",
    "title": "Otto II 1Lt LED Security Floodlight with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-1Lt-LED-Security-Floodlight-with-Sensor-Mercator-2565_bb78a3ff-9815-4b09-8649-c7733171082b.jpg?v=1778652201"
  },
  {
    "sku": "MXD6711SIL-SEN",
    "title": "Otto II 1Lt LED Security Floodlight with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-1Lt-LED-Security-Floodlight-with-Sensor-Mercator-2565_bb78a3ff-9815-4b09-8649-c7733171082b.jpg?v=1778652201"
  },
  {
    "sku": "MXD6712BLK",
    "title": "Otto II 2Lt LED Black Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-2Lt-LED-Flood-Light-Mercator-9249_83bd216b-761f-4064-b323-0a982d4cf139.jpg?v=1778652208"
  },
  {
    "sku": "MXD6712WHT",
    "title": "Otto II 2Lt LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-2Lt-LED-Flood-Light-Mercator-9920_1802dc9c-2cb3-4aaa-96af-0ecca60dfe14.jpg?v=1778652208"
  },
  {
    "sku": "MXD6712SIL",
    "title": "Otto II 2Lt LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-2Lt-LED-Flood-Light-Mercator-9920_1802dc9c-2cb3-4aaa-96af-0ecca60dfe14.jpg?v=1778652208"
  },
  {
    "sku": "MXD6712BLK",
    "title": "Otto II 2Lt LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-2Lt-LED-Flood-Light-Mercator-9920_1802dc9c-2cb3-4aaa-96af-0ecca60dfe14.jpg?v=1778652208"
  },
  {
    "sku": "MXD6712BLK-SEN",
    "title": "Otto II 2Lt LED Security Floodlight with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-2Lt-LED-Security-Floodlight-with-Sensor-Mercator-6145_23dca05f-e5d6-487d-baa7-b894fc836b52.jpg?v=1778652213"
  },
  {
    "sku": "MXD6712WHT-SEN",
    "title": "Otto II 2Lt LED Security Floodlight with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-2Lt-LED-Security-Floodlight-with-Sensor-Mercator-6145_23dca05f-e5d6-487d-baa7-b894fc836b52.jpg?v=1778652213"
  },
  {
    "sku": "MXD6712SIL-SEN",
    "title": "Otto II 2Lt LED Security Floodlight with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Otto-II-2Lt-LED-Security-Floodlight-with-Sensor-Mercator-6145_23dca05f-e5d6-487d-baa7-b894fc836b52.jpg?v=1778652213"
  },
  {
    "sku": "A48211BC",
    "title": "Owen Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Owen-Table-Lamp-Mercator-9719_241dfd13-4857-44bc-87ce-7c850f86e205.jpg?v=1778652217"
  },
  {
    "sku": "MPLS030L-AMB",
    "title": "Paddington 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paddington-1Lt-Large-Pendant-Light-Mercator-4243_fecbb83e-51ae-4083-87d7-44407acf513b.jpg?v=1778652241"
  },
  {
    "sku": "MPLS030L-SMK",
    "title": "Paddington 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paddington-1Lt-Large-Pendant-Light-Mercator-4243_fecbb83e-51ae-4083-87d7-44407acf513b.jpg?v=1778652241"
  },
  {
    "sku": "MPLS030S-SMK",
    "title": "Paddington 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paddington-1Lt-Small-Pendant-Light-Mercator-5563_7cdc1f80-1392-4005-8aa8-2aa748f9ab04.jpg?v=1778652245"
  },
  {
    "sku": "MXB1BLK",
    "title": "Pagoda Post Top",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Pagoda-Post-Top-Mercator-6408_e7ff0a20-82e8-4c2f-9af0-75f257ab2aec.jpg?v=1778652253"
  },
  {
    "sku": "MXB1GR",
    "title": "Pagoda Post Top",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Pagoda-Post-Top-Mercator-6408_e7ff0a20-82e8-4c2f-9af0-75f257ab2aec.jpg?v=1778652253"
  },
  {
    "sku": "A11132CH",
    "title": "Paisley 2 X 4.5W Straight Bar LED Spotlight - Polished Chrome",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paisley-Round-LED-Spotlight-Plate-Mercator-6717_c6987f17-bd79-4761-abb0-97b4f892c069.jpg?v=1778652265"
  },
  {
    "sku": "A11133CH",
    "title": "Paisley 3 X 4.5W Round Plate LED Spotlight - Polished Chrome",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paisley-13-5W-Spotlight-Mercator-2917_00f2340e-e851-4834-8343-b558ac4fe716.jpg?v=1778652269"
  },
  {
    "sku": "A11131CH",
    "title": "Paisley 4.5W Round Plate LED Spotlight - Polished Chrome",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paisley-4-5W-Spotlight-Mercator-9848_615dc4c6-4b57-4648-9dbc-ce9616ae75d5.jpg?v=1778652273"
  },
  {
    "sku": "9E27LEDP38DL",
    "title": "PAR38 Day Light E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/PAR38-5700K-E27-LED-Globe-Mercator-8628_effc9892-8bcc-46dc-a852-409650b30278.jpg?v=1778652220"
  },
  {
    "sku": "S9E27LEDP38",
    "title": "PAR38 Iku Smart Wi-Fi Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000016W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005276_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LEDP38_0d722405-1ff3-49c3-878c-8ad6619bbc00.jpg?v=1778652225"
  },
  {
    "sku": "S9E27LEDP38-ZB",
    "title": "PAR38 Iku Smart Zigbee Globe",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000016Z_Data_Sheet.pdf?v=1776661625",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005534_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/S9E27LEDP38-ZB_f373f07b-e7cc-4f0a-9f7b-4450539e05b9.jpg?v=1778652228"
  },
  {
    "sku": "9E27LEDP38WW",
    "title": "PAR38 Warm White E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/PAR38-3000K-E27-LED-Globe-Mercator-7648_52e27bdf-6bc4-4c34-b717-2b8e07984c6d.jpg?v=1778652233"
  },
  {
    "sku": "MFL001",
    "title": "Parker Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Parker-Floor-Lamp-Mercator-1712.jpg?v=1778652278"
  },
  {
    "sku": "AUL027WHT",
    "title": "Parkville Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL027WHT_73e8ef18-ac2f-421a-a521-31f137c31f7f.jpg?v=1778652282"
  },
  {
    "sku": "AUL027BLK",
    "title": "Parkville Task Lamp (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL027BLK_4b5fe424-6f2a-4169-9ee0-cd14475a53c9.jpg?v=1778652287"
  },
  {
    "sku": "AUL027WHT",
    "title": "Parkville Task Lamp (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL027BLK_4b5fe424-6f2a-4169-9ee0-cd14475a53c9.jpg?v=1778652287"
  },
  {
    "sku": "A38011BC",
    "title": "Paro Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paro-Table-Lamp-Mercator-3946_50e76cde-f0b0-4346-ad0b-f0828d97758a.jpg?v=1778652292"
  },
  {
    "sku": "A29211WHT",
    "title": "Paxton Concrete Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Paxton-Concrete-Table-Lamp-Mercator-7567_e29599d7-a900-4997-9383-727b655afbcd.jpg?v=1778652295"
  },
  {
    "sku": "MG4231S",
    "title": "Peeta 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Peeta-1Lt-Small-Pendant-Light-Mercator-2026_f3771a5a-54d4-43f5-a7d9-f7cb736e736c.jpg?v=1778652297"
  },
  {
    "sku": "MA7851",
    "title": "Penta 1 Light E27 Round Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Penta-Ceiling-Light-Mercator-95_b96ebd23-2d87-43d0-b28f-475392df65f3.jpg?v=1778652301"
  },
  {
    "sku": "MA7871BC",
    "title": "Penta 30cm Glass DIY Ceiling Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Penta-30cm-Glass-DIY-Ceiling-Light-Mercator-2968_d2315d50-c4a4-4361-9196-9fda4b2ffdf7.jpg?v=1778652302"
  },
  {
    "sku": "FC740123WH",
    "title": "Phaser 127cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Phaser-50-AC-Ceiling-Fan-Mercator-3404_dd5e5a54-bda2-4cd0-9292-c51d09c341f4.jpg?v=1778652306"
  },
  {
    "sku": "FC747123WH",
    "title": "Phaser 127cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Phaser-50-AC-Ceiling-Fan-with-LED-Light-Mercator-1878_43b7f4e6-7ff3-45b2-baa1-ae8ad2e6e8a8.jpg?v=1778652310"
  },
  {
    "sku": "FC747143WH",
    "title": "Phaser 147cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Phaser-58-AC-Ceiling-Fan-with-LED-Light-Mercator-4112_841e6627-16f2-4d75-84a9-978cb77daf07.jpg?v=1778652313"
  },
  {
    "sku": "FC740093WH",
    "title": "Phaser 91cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Phaser-36-AC-Ceiling-Fan-Mercator-9280_06e86fdc-9e7b-44a0-af97-bff2570eaf6a.jpg?v=1778652316"
  },
  {
    "sku": "FC747093WH",
    "title": "Phaser 95cm AC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC747093WH_8e0ec567-d0e0-49ca-b3cd-d0ef181fce72.jpg?v=1778652319"
  },
  {
    "sku": "MXD1041",
    "title": "Piccolo II 12W LED Round Up/Down Coastal Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Piccolo-II-12W-LED-Round-Up-Down-Coastal-Wall-Light-Mercator-5284_2270be1a-41c8-49b2-9818-ac7ab33435f5.jpg?v=1778652322"
  },
  {
    "sku": "MXD1043",
    "title": "Piccolo II 12W LED Square Up/Down Coastal Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Piccolo-II-12W-LED-Square-Up-Down-Coastal-Wall-Light-Mercator-6764_63fe446a-f47c-4779-9b3e-3758a28f14ce.jpg?v=1778652327"
  },
  {
    "sku": "MXD1040",
    "title": "Piccolo II 6W LED Round Coastal Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Piccolo-II-6W-LED-Round-Up-Down-Coastal-Wall-Light-Mercator-2072_183888f2-f9da-434c-a3c0-9f34edd271e9.jpg?v=1778652330"
  },
  {
    "sku": "MXD1042",
    "title": "Piccolo II 6W LED Square Coastal Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Piccolo-II-6W-LED-Square-Up-Down-Coastal-Wall-Light-Mercator-6803_73c7b2f2-0b67-47db-8fd7-a0646a632303.jpg?v=1778652335"
  },
  {
    "sku": "MPLS508WHT",
    "title": "Picton 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Picton-1Lt-Pendant-Light-Mercator-7111_dab1a923-25b9-4973-9892-4f31221f90e8.jpg?v=1778652339"
  },
  {
    "sku": "XSEN002PIR",
    "title": "PIR Surface Mount Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/PIR-Surface-Mount-Sensor-Mercator-9681_5328018d-7065-405b-8bbe-2930113955d3.jpg?v=1778652237"
  },
  {
    "sku": "MF5020CCT",
    "title": "Polar 20W 600mm LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Polar-20W-600mm-LED-CCT-Batten-Light-Mercator-815_49d45f4d-950e-43a9-8b8b-f6aaf2a2632d.jpg?v=1778652343"
  },
  {
    "sku": "MF5040CCT",
    "title": "Polar 40W 1200mm LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Polar-40W-1200mm-LED-CCT-Batten-Light-Mercator-708_ba72ff46-fe3e-406a-a4b1-72c4f7f3e6fa.jpg?v=1778652346"
  },
  {
    "sku": "MTL013WHT",
    "title": "Portabella  Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Portabella-Table-Lamp-Mercator-9347_a5b6927e-0d14-40f1-8aad-5b816f46966f.jpg?v=1778652351"
  },
  {
    "sku": "MDET240",
    "title": "Power Outlet Tester Plug",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Power-Outlet-Tester-Plug-Mercator-1530_3e3f3d1b-764d-4845-9e62-81fda275c6cc.jpg?v=1778652363"
  },
  {
    "sku": "MPLS029L-BRS",
    "title": "Preston 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Preston-1Lt-Large-Pendant-Light-Mercator-3822_ea5005ab-52e5-4936-b536-4e94e19aa8ac.jpg?v=1778652369"
  },
  {
    "sku": "MPLS029S-BLK",
    "title": "Preston 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Preston-1Lt-Small-Pendant-Light-Mercator-1131_eaae3fa2-e6e3-4730-9b22-08118ebc3626.jpg?v=1778652373"
  },
  {
    "sku": "MPLS031",
    "title": "Preston 7Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Preston-7Lt-Light-Pendant-Mercator-1958_ab5a7a55-13f5-4f18-abdd-f376075556fe.jpg?v=1778652378"
  },
  {
    "sku": "MPLS031BLK",
    "title": "Preston 7Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Preston-7Lt-Light-Pendant-Mercator-1958_ab5a7a55-13f5-4f18-abdd-f376075556fe.jpg?v=1778652378"
  },
  {
    "sku": "CE9571-C",
    "title": "Primrose Acrylic Beads DIY Ceiling Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/CE9571-C_449fb7c3-4d78-43d4-9fed-26d678ce80cc.jpg?v=1778652382"
  },
  {
    "sku": "A34121",
    "title": "Prince Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Prince-Floor-Lamp-Mercator-6168_9afd313b-6132-484e-906b-3ed81373926a.jpg?v=1778652385"
  },
  {
    "sku": "MP4421",
    "title": "Prisma 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Prisma-1Lt-Pendant-Light-Mercator-1393_416ee397-8ef1-4e8f-876a-57846644e9e7.jpg?v=1778652388"
  },
  {
    "sku": "MGL070DSE",
    "title": "R39 Day Light E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R39-5700K-E14-LED-Globe-Mercator-3184_439e4376-7f3d-4deb-97e6-55e718a44a4f.jpg?v=1778652393"
  },
  {
    "sku": "MGL070WSE",
    "title": "R39 Warm White E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R39-3000K-E14-LED-Globe-Mercator-194_1f220150-8b48-403b-b2b6-a9b15dd00abe.jpg?v=1778652397"
  },
  {
    "sku": "MGL071DSE",
    "title": "R50 Day Light E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R50-5700K-E14-LED-Globe-Mercator-9501_27d7ce73-bcbb-430b-a5c3-343172f2d37c.jpg?v=1778652401"
  },
  {
    "sku": "MGL071WSE",
    "title": "R50 Warm White E14 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R50-3000K-E14-LED-Globe-Mercator-4845_edca2560-610b-4ec5-8e06-32b413a5b573.jpg?v=1778652406"
  },
  {
    "sku": "MGL072DE",
    "title": "R63 Day Light E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R63-5700K-E27-LED-Globe-Mercator-9298_409f1ab5-a5f2-4cff-9117-b7ba64eddc61.jpg?v=1778652410"
  },
  {
    "sku": "MGL072WE",
    "title": "R63 Warm White E27 LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R63-3000K-E27-LED-Globe-Mercator-4422_6194f60f-d898-48f9-b6cd-33e9cf291323.jpg?v=1778652414"
  },
  {
    "sku": "MGL282-D",
    "title": "R80 Day Light E27 Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R80-5700K-E27-Dimmable-LED-Globe-Mercator-7300_c7718977-f3df-48cf-b49d-27625b89bacf.jpg?v=1778652418"
  },
  {
    "sku": "MGL075DE",
    "title": "R80 Day Light E27 Non-Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R80-5700K-E27-Non-Dimmable-LED-Globe-Mercator-9679_8b4b5e21-aae4-4c8e-9980-7cdb33e1d5d0.jpg?v=1778652423"
  },
  {
    "sku": "MGL075WE",
    "title": "R80 Warm White E27 Non-Dimmable LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/R80-3000K-E27-Non-Dimmable-LED-Globe-Mercator-1438_ec65042d-4f23-4020-afdb-5278f2677e07.jpg?v=1778652427"
  },
  {
    "sku": "MG9233",
    "title": "Rafael 3Lt Bar Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rafael-3Lt-Bar-Pendant-Light-Mercator-8918_2063ad84-04de-434e-98cd-0a85058641bc.jpg?v=1778652446"
  },
  {
    "sku": "MX10112BLK",
    "title": "Raiden PAR38 LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Raiden-PAR38-LED-Flood-Light-Mercator-4377_c89e6e45-a93f-430f-a474-b8094bc87f7b.jpg?v=1778652451"
  },
  {
    "sku": "FC970133BK",
    "title": "Raptor 131cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC970133BK_5de81dee-d22b-4c77-b4d8-1b7e9123fc41.jpg?v=1778652456"
  },
  {
    "sku": "FC970133WH",
    "title": "Raptor 131cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC970133BK_5de81dee-d22b-4c77-b4d8-1b7e9123fc41.jpg?v=1778652456"
  },
  {
    "sku": "FC978133BK",
    "title": "Raptor 131cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC978133BK_1f79dcd7-2b11-40fa-86a6-2e75001a229e.jpg?v=1778652482"
  },
  {
    "sku": "FC978133WH",
    "title": "Raptor 131cm DC Ceiling Fan with Remote and LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC978133BK_1f79dcd7-2b11-40fa-86a6-2e75001a229e.jpg?v=1778652482"
  },
  {
    "sku": "FC970123BK",
    "title": "Raptor S 122cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC970123BK_687154ca-7836-43b9-82fd-a5a09b7b2716.jpg?v=1778652510"
  },
  {
    "sku": "FC970123WH",
    "title": "Raptor S 122cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC970123BK_687154ca-7836-43b9-82fd-a5a09b7b2716.jpg?v=1778652510"
  },
  {
    "sku": "FC978123WH",
    "title": "Raptor S 122cm DC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC978123BK_9c7080af-bbbf-4a61-98ef-fe0ffcebe541.jpg?v=1778652540"
  },
  {
    "sku": "FC978123BK",
    "title": "Raptor S 122cm DC Ceiling Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC978123BK_9c7080af-bbbf-4a61-98ef-fe0ffcebe541.jpg?v=1778652540"
  },
  {
    "sku": "XSEN005MW",
    "title": "Recessed Gimble Sensor Microwave Version",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Recessed-Gimble-Sensor-Microwave-Version-Mercator-5249_62109a5d-157c-4c49-9c46-60613d6acdde.jpg?v=1778652565"
  },
  {
    "sku": "XSEN005PIR",
    "title": "Recessed Gimble Sensor PIR Version",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Recessed-Gimble-Sensor-PIR-Version-Mercator-6115_c196de64-1c27-431e-9af1-2d55a7ddb7e4.jpg?v=1778652568"
  },
  {
    "sku": "MTBL002-S",
    "title": "Remi  Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Remi-Table-Lamp-Mercator-5084_500c4507-12f6-45c3-af94-b73c255ae39a.jpg?v=1778652572"
  },
  {
    "sku": "MTBL013-L",
    "title": "Remi Large Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Remi-Large-Table-Lamp-Mercator-1107_be81d6f3-41a2-4887-9066-bc87d755022e.jpg?v=1778652579"
  },
  {
    "sku": "FRM105",
    "title": "REMOTE HANDSET FOR TRINIDAD",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "FRMW105A",
    "title": "REMOTE RECEIVER & HANDSET",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "A21211WHT",
    "title": "Republic LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Republic-LED-Table-Lamp-Mercator-4630_a2d0e634-e0cb-4363-af75-e70f281e6458.jpg?v=1778652582"
  },
  {
    "sku": "W9B22LED15",
    "title": "Retro Large Sphere B22 4W LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Retro-Large-Sphere-B22-4W-LED-Globe-Mercator-9249_2c178e79-d1ef-40ba-8988-a536e4432655.jpg?v=1778652586"
  },
  {
    "sku": "W9B22LED17",
    "title": "Retro Traditional B22 4W LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Retro-Traditional-B22-4W-LED-Globe-Mercator-6453_36c27ff0-91e1-4eb8-b7f2-03c03414a926.jpg?v=1778652589"
  },
  {
    "sku": "BE390ESPWH",
    "title": "Revoline 290 Bathroom Exhaust Fan With 17W LED",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Revoline-290-Bathroom-Exhaust-Fan-With-17W-LED-Mercator-7740_35863661-ad47-4c58-971e-95b95063455d.jpg?v=1778652592"
  },
  {
    "sku": "BE380ESPWH",
    "title": "Revoline Bathroom Exhaust Fan With 13W LED",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Revoline-Bathroom-Exhaust-Fan-With-13W-LED-Mercator-3182_9474aeef-aa9d-44c2-8ebc-99d9171be27b.jpg?v=1778652597"
  },
  {
    "sku": "FRM87",
    "title": "RF Remote Set for AC Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FRM87_e17d6d61-192c-488d-b526-6eb43c4db20b.jpg?v=1778652436"
  },
  {
    "sku": "FRM97",
    "title": "RF Remote Set with LCD Display for AC Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FRM97_op_2b191efa-b3f4-40a1-a73c-59361a03140c.jpg?v=1778652441"
  },
  {
    "sku": "FC479180WH",
    "title": "Rhino 180cm DC Ceiling Fan Motor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC479180WH_7e09856d-380e-4bdf-a0fe-25a6ee36d4b8.jpg?v=1778652601"
  },
  {
    "sku": "FC479180BCFLNL",
    "title": "Rhino 182cm DC 6 Blade Ceiling Fanwith Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-DC-6-Blade-1-8m-Ceiling-Fan-Mercator-7982_a6361177-63e6-407a-8f3c-dcc045e2d0c1.jpg?v=1778652606"
  },
  {
    "sku": "FC479180GRFLNL",
    "title": "Rhino 182cm DC 6 Blade Ceiling Fanwith Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-DC-6-Blade-1-8m-Ceiling-Fan-Mercator-7982_a6361177-63e6-407a-8f3c-dcc045e2d0c1.jpg?v=1778652606"
  },
  {
    "sku": "FC479180GRFLWL",
    "title": "Rhino 182cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-1-8m-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-2463_a8daab91-5dd3-43bf-b0ac-12da065fe8ae.jpg?v=1778652610"
  },
  {
    "sku": "FC479180BCFLWL",
    "title": "Rhino 182cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-1-8m-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-2463_a8daab91-5dd3-43bf-b0ac-12da065fe8ae.jpg?v=1778652610"
  },
  {
    "sku": "FC479210GRFLWL",
    "title": "Rhino 213cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-2-1m-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-3087_b7f72e63-7663-4d93-a92d-16b9c87caf04.jpg?v=1778652615"
  },
  {
    "sku": "FC479210BCFLWL",
    "title": "Rhino 213cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-2-1m-DC-Ceiling-Fan-with-LED-Light-and-Remote-Mercator-3087_b7f72e63-7663-4d93-a92d-16b9c87caf04.jpg?v=1778652615"
  },
  {
    "sku": "FC479210GRFLNL",
    "title": "Rhino 213cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-2-1m-DC-Ceiling-Fan-with-Remote-Mercator-9054_56aa253a-d1f8-4194-9aac-47fddc2aa814.jpg?v=1778652619"
  },
  {
    "sku": "FC479210BCFLNL",
    "title": "Rhino 213cm DC Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-2-1m-DC-Ceiling-Fan-with-Remote-Mercator-9054_56aa253a-d1f8-4194-9aac-47fddc2aa814.jpg?v=1778652619"
  },
  {
    "sku": "FC479210WH",
    "title": "Rhino 6B 210cm DC Motor Ceiling Fan with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rhino-6B-2-1m-DC-Motor-Ceiling-Fan-with-Remote-Mercator-7844_20b9ba54-3699-4047-9ce6-f2da5f33f8f1.jpg?v=1778652623"
  },
  {
    "sku": "FC990186BCKIT",
    "title": "Rhino II 180cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC990186BCKIT_bf33dc35-e950-4a41-a363-43abfb5d825d.jpg?v=1778652626"
  },
  {
    "sku": "FC990186GRKIT",
    "title": "Rhino II 180cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC990186BCKIT_bf33dc35-e950-4a41-a363-43abfb5d825d.jpg?v=1778652626"
  },
  {
    "sku": "FC990186BCKIT",
    "title": "Rhino II 180cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC990186BCKIT_a81ac042-43e4-4794-9286-c9154bac59b5.jpg?v=1706499786"
  },
  {
    "sku": "FC998186GRKIT",
    "title": "Rhino II 180cm Graphite with Light Complete Kit with Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC998186GRKIT_88c3b1e0-e961-408a-bf22-19bbc4f98e74.jpg?v=1778652632"
  },
  {
    "sku": "FC998216BCKIT",
    "title": "Rhino II 210cm Brushed Chrome with Light Complete Kit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC998216BCKIT_8cd1c54c-026a-4efa-9200-578673a5238a.jpg?v=1778652636"
  },
  {
    "sku": "FC990216BCKIT",
    "title": "Rhino II 210cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC990216BCKIT_ec542faa-fdf3-4a8b-8187-6dc215556777.jpg?v=1778652639"
  },
  {
    "sku": "FC990216GRKIT",
    "title": "Rhino II 210cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC990216BCKIT_ec542faa-fdf3-4a8b-8187-6dc215556777.jpg?v=1778652639"
  },
  {
    "sku": "FC990216BCKIT",
    "title": "Rhino II 210cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC990216BCKIT_c7296fcf-828f-4b63-bb74-651003c5b739.jpg?v=1778652644"
  },
  {
    "sku": "FC990186GRKIT",
    "title": "Rhino II Graphite 180cm DC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC990186GRKIT_68611c09-8007-485f-affd-d45ede9aef66.jpg?v=1778652648"
  },
  {
    "sku": "MXD5312BLK",
    "title": "Rick Up & Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rick-Up-Down-Wall-Light-Mercator-3169_1aca35eb-cd57-410b-90dd-d5160b7a1c43.jpg?v=1778652651"
  },
  {
    "sku": "FF52316WH",
    "title": "Rider 40cm Wall Fan with Remote Control",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rider-40cm-Wall-Fan-with-Remote-Control-Mercator-755_e9edbb69-e435-484d-9507-f5c76b8d0d0c.jpg?v=1778652655"
  },
  {
    "sku": "MFL041",
    "title": "Robin Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Robin-Floor-Lamp-Mercator-3236_2167868a-e4f1-45eb-9dd8-a72cbaed82eb.jpg?v=1778652659"
  },
  {
    "sku": "MTBL041",
    "title": "Robin Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Robin-Table-Lamp-Mercator-4961_c98a13fc-31f0-4032-a9f5-474daf00097f.jpg?v=1778652674"
  },
  {
    "sku": "PBM003",
    "title": "Romu D600mm Round Bathroom Mirror",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Romu-D600mm-Round-Bathroom-Mirror-Mercator-8230_c48d85d2-347c-422c-a088-ba7d430dd802.jpg?v=1778652688"
  },
  {
    "sku": "CE3135",
    "title": "Rosa 5Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rosa-5Lt-Pendant-Light-Mercator-3360_f177a5c9-a64b-4b14-b48d-68227f0cf4e5.jpg?v=1778652693"
  },
  {
    "sku": "AUL023WHT",
    "title": "Rosanna Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL023WHT_940f66ac-c3a8-45a1-9413-d4b21dddc23c.jpg?v=1778652696"
  },
  {
    "sku": "MTL020BLK",
    "title": "Rupert LED Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTL020BLK_be384973-6586-45c4-ad53-ed0fd6206522.jpg?v=1778652701"
  },
  {
    "sku": "MTL020WHT",
    "title": "Rupert LED Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTL020BLK_be384973-6586-45c4-ad53-ed0fd6206522.jpg?v=1778652701"
  },
  {
    "sku": "MXB1020CCTBLK",
    "title": "Ryder LED Bunker Light with CCT",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Ryder-LED-Bunker-Light-with-CCT-Mercator-40919454_4ad8faae-7c1e-4e77-a639-ac8bc6f9edea.jpg?v=1778652706"
  },
  {
    "sku": "MW1811RWHT",
    "title": "Rye Round LED Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rye-Round-LED-Step-Wall-Light-Mercator-933_239bdefa-5700-4a9e-b205-42c396a6281b.jpg?v=1778652710"
  },
  {
    "sku": "MW1811RBLK",
    "title": "Rye Round LED Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rye-Round-LED-Step-Wall-Light-Mercator-933_239bdefa-5700-4a9e-b205-42c396a6281b.jpg?v=1778652710"
  },
  {
    "sku": "MW1811SWHT",
    "title": "Rye Square LED Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rye-Square-LED-Step-Wall-Light-Mercator-5114_eea6a2ee-f335-4f68-a912-5e622aec348b.jpg?v=1778652714"
  },
  {
    "sku": "MW1811SBLK",
    "title": "Rye Square LED Step Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rye-Square-LED-Step-Wall-Light-Mercator-5114_eea6a2ee-f335-4f68-a912-5e622aec348b.jpg?v=1778652714"
  },
  {
    "sku": "MTBL038",
    "title": "Rye Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Rye-Table-Lamp-Mercator-791_0ddee6f8-6586-4025-a0f1-5b5e1b4b1d73.jpg?v=1778652719"
  },
  {
    "sku": "ML3541",
    "title": "Sachi LED Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sachi-LED-Pendant-Light-Mercator-2328_6d6b78ac-3f24-4207-a5f6-d4f9a2ec97be.jpg?v=1778652762"
  },
  {
    "sku": "MXD6612BLK",
    "title": "Sanders 1Lt PAR38 LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sanders-1Lt-PAR38-LED-Flood-Light-Mercator-1791_e7a83a3f-c68e-4d82-8bee-d4936c894bbc.jpg?v=1778652765"
  },
  {
    "sku": "MXD6612BLK-SEN",
    "title": "Sanders 1Lt PAR38 LED Flood Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sanders-1Lt-PAR38-LED-Flood-Light-with-Sensor-Mercator-5156_b3ab74db-bca7-4f9f-b8ab-2c34f3bdef01.jpg?v=1778652768"
  },
  {
    "sku": "MXD6624BLK",
    "title": "Sanders 2Lt PAR38 LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sanders-2Lt-PAR38-LED-Flood-Light-Mercator-4534_61c92fd8-393c-499c-b258-01a232f43500.jpg?v=1778652772"
  },
  {
    "sku": "MXD6624BLK-SEN",
    "title": "Sanders 2Lt PAR38 LED Flood Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sanders-2Lt-PAR38-LED-Flood-Light-with-Sensor-Mercator-7449_4a446151-f291-4e31-a708-e8b79a518f5b.jpg?v=1778652775"
  },
  {
    "sku": "A13022WHT",
    "title": "Sara 2 Light Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-2-Light-Floor-Lamp-Mercator-6225_de763466-0b83-42c5-b7d8-c2da171c1e74.jpg?v=1778652778"
  },
  {
    "sku": "A13022BLK",
    "title": "Sara 2 Light Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-2-Light-Floor-Lamp-Mercator-6225_de763466-0b83-42c5-b7d8-c2da171c1e74.jpg?v=1778652778"
  },
  {
    "sku": "A13041BLK",
    "title": "Sara Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Clamp-Table-Lamp-Mercator-5070_bcc26e5a-0e46-4de7-9216-b02c42c11979.jpg?v=1778652798"
  },
  {
    "sku": "A13041YEL",
    "title": "Sara Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Clamp-Table-Lamp-Mercator-5070_bcc26e5a-0e46-4de7-9216-b02c42c11979.jpg?v=1778652798"
  },
  {
    "sku": "A13041WHT",
    "title": "Sara Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Clamp-Table-Lamp-Mercator-5070_bcc26e5a-0e46-4de7-9216-b02c42c11979.jpg?v=1778652798"
  },
  {
    "sku": "A13041BC",
    "title": "Sara Clamp Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Clamp-Table-Lamp-Mercator-5070_bcc26e5a-0e46-4de7-9216-b02c42c11979.jpg?v=1778652798"
  },
  {
    "sku": "A13021BLS",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021BLK",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021BLU",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021WHT",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021BC",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021GRY",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021RED",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021MNT",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021YEL",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021NAV",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_24509e16-8726-4091-a5ad-cff6d6f7bf48.jpg?v=1778652806"
  },
  {
    "sku": "A13021BLS",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021BLK",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021BLU",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021WHT",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021BC",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021RED",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021MNT",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021YEL",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021NAV",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-7628_7ca2be60-68c5-439d-9d78-2259c8f8ffe5.jpg?v=1778652814"
  },
  {
    "sku": "A13021WHT",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-4250_5cc363f1-0194-493c-a3e2-be33cb4b3944.jpg?v=1778652823"
  },
  {
    "sku": "A13021BC",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-4250_5cc363f1-0194-493c-a3e2-be33cb4b3944.jpg?v=1778652823"
  },
  {
    "sku": "A13021YEL",
    "title": "Sara Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Floor-Lamp-Mercator-4250_5cc363f1-0194-493c-a3e2-be33cb4b3944.jpg?v=1778652823"
  },
  {
    "sku": "A13011MNT",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011BC",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011YEL",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011BLU",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011WHT",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011BLK",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011RED",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011NAV",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-6794_f2cc6a41-9381-4b75-8282-02781a49e7d7.jpg?v=1778652830"
  },
  {
    "sku": "A13011BC",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-8297_8a827670-1754-4fc7-8814-6c4bf8f2eb85.jpg?v=1778652835"
  },
  {
    "sku": "A13011YEL",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-8297_8a827670-1754-4fc7-8814-6c4bf8f2eb85.jpg?v=1778652835"
  },
  {
    "sku": "A13011WHT",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-8297_8a827670-1754-4fc7-8814-6c4bf8f2eb85.jpg?v=1778652835"
  },
  {
    "sku": "A13011BLK",
    "title": "Sara Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-Table-Lamp-Mercator-8297_8a827670-1754-4fc7-8814-6c4bf8f2eb85.jpg?v=1778652835"
  },
  {
    "sku": "A13011BLK-USB",
    "title": "Sara USB Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-USB-Table-Lamp-Mercator-6057_1d458820-5bda-4f69-af0a-5d0e9c95bf5e.jpg?v=1778652840"
  },
  {
    "sku": "A13011BC-USB",
    "title": "Sara USB Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-USB-Table-Lamp-Mercator-6057_1d458820-5bda-4f69-af0a-5d0e9c95bf5e.jpg?v=1778652840"
  },
  {
    "sku": "A13011BLK-USB",
    "title": "Sara USB Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sara-USB-Table-Lamp-Mercator-6057_32f8afab-44f8-4e67-bcfc-2ffcbec994a1.jpg?v=1778652845"
  },
  {
    "sku": "MXD1060BLK",
    "title": "Sasha II LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sasha-II-LED-Up-Down-Wall-Light-Mercator-7872_a5640155-e945-42a4-ac4f-41e08a823ee4.jpg?v=1778652848"
  },
  {
    "sku": "MXD1060WHT",
    "title": "Sasha II LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sasha-II-LED-Up-Down-Wall-Light-Mercator-7872_a5640155-e945-42a4-ac4f-41e08a823ee4.jpg?v=1778652848"
  },
  {
    "sku": "FC560133BC",
    "title": "Savannah 130cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Savannah-Ceiling-Fan-Mercator-6961_e06c4a45-3f35-4fa6-895a-9950a08785f8.jpg?v=1778652853"
  },
  {
    "sku": "FC560133WH",
    "title": "Savannah 130cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Savannah-Ceiling-Fan-Mercator-6961_e06c4a45-3f35-4fa6-895a-9950a08785f8.jpg?v=1778652853"
  },
  {
    "sku": "MPLS013NAT",
    "title": "Sawyer 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sawyer-1Lt-Pendant-Light-Mercator-1813_c5a64ff1-bd95-448a-aad7-f6c992a2e21c.jpg?v=1778652857"
  },
  {
    "sku": "MFL013NAT",
    "title": "Sawyer Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sawyer-Floor-Lamp-Mercator-1401_4e55d13a-d862-415a-9c40-c65db7249f78.jpg?v=1778652862"
  },
  {
    "sku": "MFL013BLK",
    "title": "Sawyer Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sawyer-Floor-Lamp-Mercator-1401_4e55d13a-d862-415a-9c40-c65db7249f78.jpg?v=1778652862"
  },
  {
    "sku": "MTBL080NAT",
    "title": "Saxe Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTBL080NAT_c02cb4e7-73b5-4328-933c-8897ab324d4c.jpg?v=1778652867"
  },
  {
    "sku": "MTBL080BLK",
    "title": "Saxe Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MTBL080NAT_c02cb4e7-73b5-4328-933c-8897ab324d4c.jpg?v=1778652867"
  },
  {
    "sku": "MPLS533L",
    "title": "Sefina 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sefina-1Lt-Large-Pendant-Light-Mercator-5489_0eaea4b1-42ad-4cc7-84a4-d1d1ab173c20.jpg?v=1778652871"
  },
  {
    "sku": "MPLS533S",
    "title": "Sefina 1Lt Small Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sefina-1Lt-Small-Pendant-Light-Mercator-1529_9e08a60b-44b7-4860-aab9-39fa655a7663.jpg?v=1778652874"
  },
  {
    "sku": "MI7040CCTDP",
    "title": "Shaw 1200mm LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Shaw-1200mm-LED-CCT-Batten-Light-Mercator-3047_f516e3d1-2764-4ad4-89c2-a1226dcef6e9.jpg?v=1778652878"
  },
  {
    "sku": "MI7020CCTDP",
    "title": "Shaw 600mm LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Shaw-600mm-LED-CCT-Batten-Light-Mercator-850_0a633bd3-1bd1-4bae-bcd2-e7c38ba6868f.jpg?v=1778652883"
  },
  {
    "sku": "MWL013",
    "title": "Sinclair Up Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MWL013_1_90778d20-1720-4182-9031-6ccf2c9daf93.jpg?v=1778652887"
  },
  {
    "sku": "MWL014",
    "title": "Sinclair Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MWL014_1_45953f94-7a6f-4dc8-8da1-3d0fce2f1b4f.jpg?v=1778652891"
  },
  {
    "sku": "MXD6821BLK-SEN",
    "title": "Single Head COB LED Floodlight with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lumio-Single-Head-Cob-Led-Floodlight-with-Sensor-Mercator-22_dfcb14a3-f98c-4ec6-ae88-2cf79a8e192d.jpg?v=1778652897"
  },
  {
    "sku": "MXD6821BLK",
    "title": "Single Head COB LED Security Floodlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Cob-LED-Security-FloodLight-Mercator-4505_fa315391-6ad3-4e04-8f89-f38e28689a98.jpg?v=1778652901"
  },
  {
    "sku": "ML5018Y",
    "title": "Skeeta 18W Insect Repellent LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Skeeta-18W-Insect-Repellent-LED-Batten-Mercator-5023_15e7af8d-9ab7-418c-9a61-0bea0eb00793.jpg?v=1778652905"
  },
  {
    "sku": "ML5036Y",
    "title": "Skeeta 36W Insect Repellent LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Skeeta-36W-Insect-Repellent-LED-Batten-Mercator-9357_62fd4aa1-5e9a-49aa-8c6c-cce3d7ba1d45.jpg?v=1778652908"
  },
  {
    "sku": "BE240ESPWH",
    "title": "Skyline Round Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Skyline-Round-Exhaust-Fan-with-LED-Light-Mercator-7341_b791b320-7ef6-439d-8fbb-57f65aed2240.jpg?v=1778652912"
  },
  {
    "sku": "BE220FSPWH",
    "title": "Skyline T5 Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Skyline-T5-Exhaust-Fan-Mercator-4397_e3eee490-e9ca-48e0-b284-6f737848579a.jpg?v=1778652918"
  },
  {
    "sku": "AUL1110WHT",
    "title": "Slater LED USB Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1110WHT_5ed10437-c973-4467-8c97-cc4edf561896.jpg?v=1778652921"
  },
  {
    "sku": "GO9209SIBLK",
    "title": "Small Mast Three Circuit Tracks & Accessories I Shape",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Small-Mast-Three-Circuit-Tracks-Accessories-I-Shape-Mercator-629_acc7c142-dfd2-4b3a-bd4f-155509978400.jpg?v=1778652925"
  },
  {
    "sku": "GO9209SIWHT",
    "title": "Small Mast Three Circuit Tracks & Accessories I Shape",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Small-Mast-Three-Circuit-Tracks-Accessories-I-Shape-Mercator-629_acc7c142-dfd2-4b3a-bd4f-155509978400.jpg?v=1778652925"
  },
  {
    "sku": "MPL001L",
    "title": "Solara Large 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPL001L_Hero_d8401d43-02f3-4192-9dd0-b26115f6572a.jpg?v=1778652928"
  },
  {
    "sku": "MPL001S",
    "title": "Solara Small 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPL001S_Hero_8d59ecb9-baf1-4391-9cfc-42c3e816d993.jpg?v=1778652933"
  },
  {
    "sku": "MPL001R",
    "title": "Solara Spare Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MPL001R_Hero_92fc8526-5b5f-4a8c-b49e-7581e72fef27.jpg?v=1778652937"
  },
  {
    "sku": "MSL3050",
    "title": "Solitude 1000lm Solar Flood Light with Radar Sensor and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Solitude-1000lm-Solar-Flood-Light-with-Radar-Sensor-and-Remote-Mercator-7221_9ace4a13-db11-41d2-a2a1-d53a3ded1f19.jpg?v=1778652941"
  },
  {
    "sku": "MSL30100",
    "title": "Solitude 2000lm Solar Flood Light with Radar Sensor and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Solitude-2000lm-Solar-Flood-Light-with-Radar-Sensor-and-Remote-Mercator-4756_214c8f74-3a85-4a44-abd3-f187b76a27a2.jpg?v=1778652946"
  },
  {
    "sku": "A36011",
    "title": "Sonya Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sonya-Table-Lamp-Mercator-2891_8bb44baf-948f-4ddd-931a-2fff9d67cb28.jpg?v=1778652950"
  },
  {
    "sku": "MFL048",
    "title": "Sophia 2 Light Opal & Terrazzo Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sophia-2-Light-Opal-Terrazzo-Floor-Lamp-Mercator-6590_5bc6d584-ec73-494b-9629-e3f3f93a5718.jpg?v=1778652955"
  },
  {
    "sku": "MTBL048",
    "title": "Sophia Opal & Terrazzo Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sophia-Opal-Terrazzo-Table-Lamp-Mercator-1937_892d9fba-ae5a-4939-85e6-b48b9510568c.jpg?v=1778652958"
  },
  {
    "sku": "9B22LED15",
    "title": "Sphere 125 B22 4W LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sphere-125-B22-4W-LED-Globe-Mercator-238_4854d52e-f7e3-41d8-a7ea-4ccc7cbe5f7c.jpg?v=1778652961"
  },
  {
    "sku": "9E27LED15F",
    "title": "Sphere 125 E27 4W LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sphere-125-E27-4W-LED-Globe-Mercator-2082_e190c0ba-1b65-4930-a18c-a6558bf97630.jpg?v=1778652964"
  },
  {
    "sku": "MPLS026",
    "title": "Spotswood 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Spotswood-1Lt-Pendant-Light-Mercator-345_afbd3a69-c078-4c39-b421-0474184f5faa.jpg?v=1778652968"
  },
  {
    "sku": "MTBL026",
    "title": "Spotswood Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Spotswood-Table-Lamp-Mercator-2347_f7618279-6085-45a6-97b9-5e1177254cf9.jpg?v=1778652973"
  },
  {
    "sku": "MWL026",
    "title": "Spotswood Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Spotswood-Wall-Light-Mercator-6477_80f6363a-c41b-40c4-9258-52dadf997a0e.jpg?v=1778652977"
  },
  {
    "sku": "MGL285",
    "title": "ST26 B15 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST26-B15-Filament-Globe-Mercator-9099_05ce6499-fe68-4b9f-9737-0b504f7a2eb9.jpg?v=1778652723"
  },
  {
    "sku": "MGL284",
    "title": "ST26 E14 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST26-E14-Filament-Globe-Mercator-1909_23c9a648-a2cc-4d89-9a48-28c65678f4ed.jpg?v=1778652727"
  },
  {
    "sku": "9B22LED28",
    "title": "ST60  Vintage Decorative Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST60-Vintage-Decorative-Globe-Mercator-2985_5d69103d-ea04-4c94-ab4d-ebecab21d8a0.jpg?v=1778652731"
  },
  {
    "sku": "9E27LED28",
    "title": "ST60 E27 Vintage Decorative Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST60-E27-Vintage-Decorative-Globe-Mercator-8981_70886af5-497b-4f62-a5d3-e6c281d2fec2.jpg?v=1778652735"
  },
  {
    "sku": "9B22LEDST64DC",
    "title": "ST64 2700K B22 Pear Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST64-2700K-B22-Pear-Filament-LED-Globe-Mercator-6178_f849e5b2-c03f-4eee-8d5a-b9f69ee617dc.jpg?v=1778652738"
  },
  {
    "sku": "9E27LEDST64DC",
    "title": "ST64 2700K E27 Pear Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST64-2700K-E27-Pear-Filament-LED-Globe-Mercator-2626_309a5471-5ac6-4a83-b4f5-22655a85602c.jpg?v=1778652742"
  },
  {
    "sku": "9E27LEDST64DA",
    "title": "ST64 2700K E27 Pear Filament LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST64-2700K-E27-Pear-Filament-LED-Globe-Mercator-2626_309a5471-5ac6-4a83-b4f5-22655a85602c.jpg?v=1778652742"
  },
  {
    "sku": "9B22LED22",
    "title": "ST64 B22 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST64-B22-Vintage-Decorative-LED-Globe-Mercator-8141_8d41074a-5874-4067-af09-27df688b9653.jpg?v=1778652755"
  },
  {
    "sku": "9E27LED22",
    "title": "ST64 E27 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/ST64-E27-Vintage-Decorative-LED-Globe-Mercator-3197_b289bf45-8e6e-4361-abdc-64b26e5d1274.jpg?v=1778652759"
  },
  {
    "sku": "MA4571BC",
    "title": "Star 30cm DIY Batten Fixture",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Star-30cm-DIY-Ceiling-Light-Mercator-1739_1cd3df3b-739c-4c7d-b753-65180de1dd33.jpg?v=1778652981"
  },
  {
    "sku": "BE190ESPWH",
    "title": "Starline Round Exhaust Fan with LED Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Starline-Round-Exhaust-Fan-with-LED-Light-Mercator-322_f04e77d4-bf73-4b7d-89be-0143c249d4c7.jpg?v=1778652986"
  },
  {
    "sku": "BE550ESPWH",
    "title": "Steady DC 24/7 Exhaust Fan with CCT LED Remote Control",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE550ESPWH_5206010d-9a70-492b-ad7d-767dc59d082f.jpg?v=1778652989"
  },
  {
    "sku": "BE5500SPWH",
    "title": "Steady DC 24/7 Exhaust Fan with Remote Control",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE5500SPWH_d7087b4a-f60a-49f4-b2f4-6708353d1663.jpg?v=1778652992"
  },
  {
    "sku": "MX10630BLK-5",
    "title": "Surface 30W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Surface-30W-DIY-LED-Flood-Light-Mercator-3340_46567484-e12e-40b1-b2f1-2d1a584e3e9d.jpg?v=1778652996"
  },
  {
    "sku": "MX10630WHT-5",
    "title": "Surface 30W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Surface-30W-DIY-LED-Flood-Light-Mercator-3340_46567484-e12e-40b1-b2f1-2d1a584e3e9d.jpg?v=1778652996"
  },
  {
    "sku": "MX10650WHT-5",
    "title": "Surface 50W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Surface-50W-DIY-LED-Flood-Light-Mercator-9909_ae87c54b-72d8-4f85-b69a-8848c8e4b723.jpg?v=1778652999"
  },
  {
    "sku": "MX10650BLK-5",
    "title": "Surface 50W DIY LED Flood Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Surface-50W-DIY-LED-Flood-Light-Mercator-9909_ae87c54b-72d8-4f85-b69a-8848c8e4b723.jpg?v=1778652999"
  },
  {
    "sku": "MPLS512L",
    "title": "Sutton 1Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sutton-1Lt-Light-Pendant-Mercator-7502_cef7416e-cda3-4b62-907f-b1894ad86761.jpg?v=1778653004"
  },
  {
    "sku": "MD1671BC",
    "title": "Suzy 1 Light Cube DIY Fix Batten Shade",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Suzy-1-Light-Cube-DIY-Fix-Batten-Shade-Mercator-7047_af1c2097-c077-4721-afa0-1607d8e1dbc1.jpg?v=1778653008"
  },
  {
    "sku": "FC010124BC",
    "title": "Swift Metal 122cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-122cm-Mercator-4067_5d8f7292-0895-4969-81fa-79ffacb6afff.png?v=1778653012"
  },
  {
    "sku": "FC010124WH",
    "title": "Swift Metal 122cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-122cm-Mercator-4067_5d8f7292-0895-4969-81fa-79ffacb6afff.png?v=1778653012"
  },
  {
    "sku": "FC010124WH",
    "title": "Swift Metal 122cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-122cm-Mercator-8761_9d81f88b-0d60-4b5e-bc21-11c744e1a829.jpg?v=1778653015"
  },
  {
    "sku": "FC010134TT",
    "title": "Swift Metal 130cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-with-LED-and-Remote-Mercator-3491_c86606d0-77d7-4db3-98bd-aa1f1c1d757d.jpg?v=1778653019"
  },
  {
    "sku": "FC010144WH",
    "title": "Swift Metal 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-40921164_975a1249-88e5-42db-a3ad-dcce852a939a.jpg?v=1778653032"
  },
  {
    "sku": "FC010144SS",
    "title": "Swift Metal 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-40921164_975a1249-88e5-42db-a3ad-dcce852a939a.jpg?v=1778653032"
  },
  {
    "sku": "FC010144BC",
    "title": "Swift Metal 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-40921164_975a1249-88e5-42db-a3ad-dcce852a939a.jpg?v=1778653032"
  },
  {
    "sku": "FC010144WH",
    "title": "Swift Metal 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-40921164_db48afc5-c04e-4d4f-94d6-8dc400e9457b.jpg?v=1778653043"
  },
  {
    "sku": "FC010144SS",
    "title": "Swift Metal 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-40921164_db48afc5-c04e-4d4f-94d6-8dc400e9457b.jpg?v=1778653043"
  },
  {
    "sku": "FC010144WH",
    "title": "Swift Metal 142cm AC Ceiling Fan (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-40921164_0440aa87-5419-45da-a251-b19730d41151.jpg?v=1778653047"
  },
  {
    "sku": "FC010144SS",
    "title": "Swift Metal 142cm AC Ceiling Fan (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-40921164_0440aa87-5419-45da-a251-b19730d41151.jpg?v=1778653047"
  },
  {
    "sku": "FC010144BC",
    "title": "Swift Metal Brushed Chrome 142cm AC Ceiling Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Swift-Metal-Ceiling-Fan-142cm-Mercator-6425_27946c3c-34ee-48f4-b539-ed91ece0792f.jpg?v=1778653051"
  },
  {
    "sku": "MWL004BRS",
    "title": "Sylvia Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sylvia-Wall-Light-Mercator-7400_9b19e750-1454-494b-9856-48bf1b85e79f.jpg?v=1778653056"
  },
  {
    "sku": "MWL004BLK",
    "title": "Sylvia Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Sylvia-Wall-Light-Mercator-7400_9b19e750-1454-494b-9856-48bf1b85e79f.jpg?v=1778653056"
  },
  {
    "sku": "9B22LED20",
    "title": "T30 B22 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/T30-B22-Vintage-Decorative-LED-Globe-Mercator-3680_2c3722d0-67d3-42b0-886d-42e606664261.jpg?v=1778653062"
  },
  {
    "sku": "MGL280-D",
    "title": "T30 E27 Filament Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/T30-E27-Filament-Globe-Mercator-4656_671d275f-6b5c-4a68-adc6-1a3d700628d3.jpg?v=1778653065"
  },
  {
    "sku": "9E27LED20",
    "title": "T30 E27 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/T30-E27-Vintage-Decorative-LED-Globe-Mercator-4067_7190b455-c866-4a7a-9cf4-1ab0135a08bc.jpg?v=1778653070"
  },
  {
    "sku": "9B22LED21",
    "title": "T45 B22 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/T45-B22-Vintage-Decorative-LED-Globe-Mercator-8216_72ddf358-d10c-46c5-b4a4-82537ca837c2.jpg?v=1778653074"
  },
  {
    "sku": "9E27LED21",
    "title": "T45 E27 Vintage Decorative LED Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/T45-E27-Vintage-Decorative-LED-Globe-Mercator-6150_14b6e467-1417-466b-b393-329c00729017.jpg?v=1778653077"
  },
  {
    "sku": "MI7140CCTDP",
    "title": "Tanura 1200mm LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tanura-1200mm-LED-CCT-Batten-Light-Mercator-3574_ed226ffc-6bfb-44cc-8cf1-e9d10912e6d6.jpg?v=1778653082"
  },
  {
    "sku": "MI7120CCTDP",
    "title": "Tanura 600mm LED CCT Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tanura-600mm-LED-CCT-Batten-Light-Mercator-7102_92c0e03d-535a-470c-a61b-6925632c1d9a.jpg?v=1778653091"
  },
  {
    "sku": "MI67100D",
    "title": "Tarzen 100W LED Highbay",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tarzen-100W-LED-Highbay-Mercator-4911_19ef6c90-c3f7-46cd-bbb7-d293783dc024.jpg?v=1778653095"
  },
  {
    "sku": "MI67150D",
    "title": "Tarzen 150W LED Highbay",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tarzen-150W-LED-Highbay-Mercator-9998_ea6f528f-1f35-4182-91a1-3318d83e1f5b.jpg?v=1778653099"
  },
  {
    "sku": "MI67200D",
    "title": "Tarzen 200W LED Highbay",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tarzen-200W-LED-Highbay-Mercator-1669_708e3ae4-54e7-41f7-9565-2d420d7df23b.jpg?v=1778653104"
  },
  {
    "sku": "MI67200QL",
    "title": "Tarzen LED Highbay",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tarzen-LED-Highbay-Mercator-134_9cbe87b7-e67c-44f3-94c6-cf87286b2eb7.jpg?v=1778653107"
  },
  {
    "sku": "AUL022BLK",
    "title": "Templestowe Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL022BLK_89c49bf5-257a-4543-8e1a-f35aaf7112fb.jpg?v=1778653111"
  },
  {
    "sku": "MF4625W-4",
    "title": "Terre LED Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Terre-LED-Batten-Light-Mercator-5852_f8ba6706-cdb5-46c9-add4-26191a5cf6b7.jpg?v=1778653114"
  },
  {
    "sku": "MPLS502BLK",
    "title": "Terrence 1Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Terrence-1Lt-Light-Pendant-Mercator-540_0d06fdb9-3bb6-44d8-a75a-29e004c45c21.jpg?v=1778653119"
  },
  {
    "sku": "MPLS502BRS",
    "title": "Terrence 1Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Terrence-1Lt-Light-Pendant-Mercator-540_0d06fdb9-3bb6-44d8-a75a-29e004c45c21.jpg?v=1778653119"
  },
  {
    "sku": "MPLS502WHT",
    "title": "Terrence 1Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Terrence-1Lt-Light-Pendant-Mercator-540_0d06fdb9-3bb6-44d8-a75a-29e004c45c21.jpg?v=1778653119"
  },
  {
    "sku": "MPLS502BLK",
    "title": "Terrence 1Lt Light Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Terrence-1Lt-Light-Pendant-Mercator-540_346061c8-9ded-46a4-b98a-e6ee06efa81b.jpg?v=1778653122"
  },
  {
    "sku": "A45111",
    "title": "Thalia Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Thalia-Table-Lamp-Mercator-9100_464e0e45-6fcb-44a0-9b6a-a209cca7fdad.jpg?v=1778653125"
  },
  {
    "sku": "MDIY003CLR",
    "title": "Thompson DIY Glass Batten Fix Shade",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Thompson-DIY-Glass-Batten-Fix-Shade-Mercator-12_db2682ed-69d6-4916-91dd-063d52cc209c.jpg?v=1778653131"
  },
  {
    "sku": "MDIY003SMK",
    "title": "Thompson DIY Glass Batten Fix Shade",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Thompson-DIY-Glass-Batten-Fix-Shade-Mercator-12_db2682ed-69d6-4916-91dd-063d52cc209c.jpg?v=1778653131"
  },
  {
    "sku": "MDIY003SMK",
    "title": "Thompson DIY Glass Batten Fix Shade",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Thompson-DIY-Glass-Batten-Fix-Shade-Mercator-3342_a09017f3-9add-4d4c-8c5b-ae2426cd9a87.jpg?v=1778653132"
  },
  {
    "sku": "MPLS504BLK-L",
    "title": "Tia  1Lt Large Pendant Light-Trim",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tia-1Lt-Large-Pendant-Light-Trim-Mercator-1697_fce8f004-4e22-4d43-896f-721fde4a5516.jpg?v=1778653136"
  },
  {
    "sku": "MX4071BLK",
    "title": "Tilbury DIY Shade Coach Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tilbury-DIY-Shade-Coach-Light-Mercator-2716_a35539f6-c61a-4691-8acf-d0abb421431b.jpg?v=1778653139"
  },
  {
    "sku": "MX4011BLK",
    "title": "Tilbury Outdoor Coach Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tilbury-Outdoor-Coach-Light-Mercator-5836_296e4bdc-7ee9-4dd5-92a0-cd16500f4bf3.jpg?v=1778653145"
  },
  {
    "sku": "MX4011BGE",
    "title": "Tilbury Outdoor Coach Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tilbury-Outdoor-Coach-Light-Mercator-5836_296e4bdc-7ee9-4dd5-92a0-cd16500f4bf3.jpg?v=1778653145"
  },
  {
    "sku": "MX4011WHT",
    "title": "Tilbury Outdoor Coach Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tilbury-Outdoor-Coach-Light-Mercator-5836_296e4bdc-7ee9-4dd5-92a0-cd16500f4bf3.jpg?v=1778653145"
  },
  {
    "sku": "MX4011-WHT-SEN",
    "title": "Tilbury Outdoor Coach Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MX4011-WHT-SEN.png?v=1792576910"
  },
  {
    "sku": "MX4011-BLK-SEN",
    "title": "Tilbury Outdoor Coach Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MX4011-WHT-SEN.png?v=1792576910"
  },
  {
    "sku": "MX4011-BGE-SEN",
    "title": "Tilbury Outdoor Coach Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MX4011-WHT-SEN.png?v=1792576910"
  },
  {
    "sku": "A21611WHT",
    "title": "Timothy LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Timothy-LED-Table-Lamp-Mercator-4784_70e08fec-04b6-4def-9e9f-7f7021a0b54a.jpg?v=1778653155"
  },
  {
    "sku": "MI57100D",
    "title": "Titan III 100W LED Highbay",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Titan-III-100W-LED-Highbay-Mercator-3397_cef02d7c-cdcd-419b-978c-a790d7c5790b.jpg?v=1778653158"
  },
  {
    "sku": "MI57150D",
    "title": "Titan III 150W LED Highbay",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Titan-III-150W-LED-Highbay-Mercator-344_59b66dc2-a5d2-4bbd-9206-8f8d43ef1eda.jpg?v=1778653163"
  },
  {
    "sku": "MI57200D",
    "title": "Titan III 200W LED Highbay",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Titan-III-200W-LED-Highbay-Mercator-8497_1e91eb1f-b17d-4d94-8491-7af1ef8a0548.jpg?v=1778653168"
  },
  {
    "sku": "MX10150BLK-SEN",
    "title": "Tivoli 50W LED Flood Light with PIR sensor and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tivoli-50W-LED-Flood-Light-with-PIR-sensor-and-Remote-Mercator-7737_b874f259-2bf1-40f0-9df3-c46c601bef63.jpg?v=1778653172"
  },
  {
    "sku": "MX10150BLK",
    "title": "Tivoli LED Flood Light Range",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tivoli-LED-Flood-Light-Range-Mercator-4029_adac5ad5-bd58-4ed8-816b-057ba05bd621.jpg?v=1778653175"
  },
  {
    "sku": "MX10120BLK-SEN",
    "title": "Tivoli LED Flood Light with PIR Sensor and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tivoli-LED-Flood-Light-with-PIR-Sensor-and-Remote-Mercator-7144_c7ee45ba-3502-4e56-bc4e-215e120295b8.jpg?v=1778653179"
  },
  {
    "sku": "MX10130BLK",
    "title": "Tivoli LED Flood Light with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tivoli-LED-Flood-Light-with-Sensor-Mercator-5818_8a7f6624-290d-4fa8-9f34-96964dfdf493.jpg?v=1778653182"
  },
  {
    "sku": "MP1631-25",
    "title": "Toledo 25cm 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Toledo-25cm-1Lt-Pendant-Light-Mercator-2200_a0285246-283c-438b-9574-1b733e4f9fd9.jpg?v=1778653186"
  },
  {
    "sku": "MP1631-30",
    "title": "Toledo 30cm 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Toledo-30cm-1Lt-Pendant-Light-Mercator-8579_5490cf7b-d32c-467b-adf6-b5baf1fb6103.jpg?v=1778653189"
  },
  {
    "sku": "MG9031L",
    "title": "Tonic 1Lt Large Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tonic-1Lt-Large-Pendant-Light-Mercator-3412_981419ca-0ac2-462d-b611-22e3a41124e4.jpg?v=1778653193"
  },
  {
    "sku": "MC1021",
    "title": "Tracy 14W LED Ceiling Light With Chrome Trim",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tracy-14W-LED-Ceiling-Light-Mercator-7239_345a688b-bb5d-4e4d-9c87-dbc0e92ba1bb.jpg?v=1778653198"
  },
  {
    "sku": "MC1221",
    "title": "Tracy 24W LED Ceiling Light With Chrome Trim",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tracy-24W-LED-Ceiling-Light-Mercator-9104_1135aec9-6c2f-4d0b-af4a-85f4159b3ff7.jpg?v=1778653202"
  },
  {
    "sku": "A10333BLK",
    "title": "Travis 3 X 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-3Lt-Spotlight-Mercator-3812_a740323e-ff63-426d-989b-e4ff6b4dc895.jpg?v=1778653208"
  },
  {
    "sku": "A10333WHT",
    "title": "Travis 3 X 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-3Lt-Spotlight-Mercator-3812_a740323e-ff63-426d-989b-e4ff6b4dc895.jpg?v=1778653208"
  },
  {
    "sku": "A10333BLK",
    "title": "Travis 3 X 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-3Lt-Spotlight-Mercator-3812_ea000bb9-eabc-446e-8764-4cf91ae4fdfd.jpg?v=1778653212"
  },
  {
    "sku": "A10034BLK",
    "title": "Travis 4 X 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-4Lt-Spotlight-Mercator-9330_7c73f8e6-b66c-4b32-b2ff-60f7a657d43e.jpg?v=1778653216"
  },
  {
    "sku": "A10034WHT",
    "title": "Travis 4 X 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-4Lt-Spotlight-Mercator-9330_7c73f8e6-b66c-4b32-b2ff-60f7a657d43e.jpg?v=1778653216"
  },
  {
    "sku": "A10034BLK",
    "title": "Travis 4 X 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-4Lt-Spotlight-Mercator-9330_dcb3d4cd-d8ca-4f7b-bf5d-edeff6ae77af.jpg?v=1778653220"
  },
  {
    "sku": "A10031BLK",
    "title": "Travis 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-1Lt-Spotlight-Mercator-5433_67616427-2cb3-4393-823f-31d6574c8709.jpg?v=1778653225"
  },
  {
    "sku": "A10031WHT",
    "title": "Travis 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-1Lt-Spotlight-Mercator-5433_67616427-2cb3-4393-823f-31d6574c8709.jpg?v=1778653225"
  },
  {
    "sku": "A10031BLK",
    "title": "Travis 5W GU10 LED Spotlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Travis-1Lt-Spotlight-Mercator-5433_e6b661ad-8d9b-40aa-888b-8a7daee2ef67.jpg?v=1778653228"
  },
  {
    "sku": "A89391BLK-3",
    "title": "Trax 15W LED Track Light Single Head",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Trax-LED-Track-Light-Mercator-9340_d6e68112-bea4-4d08-98f6-34260cdd3da4.jpg?v=1778653233"
  },
  {
    "sku": "FC598133BB",
    "title": "Trinidad III 130cm DC Ceiling Fan with LED Light and Remote",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/FC598133BB_1f252c5a-377b-4ae0-889b-62307782374f.jpg?v=1778653236"
  },
  {
    "sku": "MPB96U",
    "title": "Trodos 4 Outlet RCD Power Block with USB Charger",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Trodos-4-Outlet-RCD-Power-Block-with-USB-Charger-Mercator-4247_e92f5159-9983-4d1b-b524-3b1541cc1082.jpg?v=1778653239"
  },
  {
    "sku": "9B22LED02-3",
    "title": "Tubular 2700K B22 Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Tubular-2700K-B22-Globe-Mercator-8078_4fb96c8a-742f-49bd-8b23-5c35730b9ea7.jpg?v=1778653244"
  },
  {
    "sku": "BE500ESPBK",
    "title": "Turboline 300 Round Exhaust Fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Turboline-300-Round-Exhaust-Fan-Mercator-2806_929fbc3e-0c94-4af7-ae48-f33c454bd861.jpg?v=1778653247"
  },
  {
    "sku": "BE510ESPWH",
    "title": "Turboline 300 Round Exhaust Fan with CCT LED",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Turboline-300-Round-Exhaust-Fan-with-CCT-LED-Mercator-7383_6b1dae61-5049-40ce-b2e7-8f0435cf14f5.jpg?v=1778653252"
  },
  {
    "sku": "BE510ESPBK",
    "title": "Turboline 300 Round Exhaust Fan with CCT LED",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Turboline-300-Round-Exhaust-Fan-with-CCT-LED-Mercator-7383_6b1dae61-5049-40ce-b2e7-8f0435cf14f5.jpg?v=1778653252"
  },
  {
    "sku": "BE501ESPWH",
    "title": "Turboline II 300 Exhaust fan",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE501ESPWH_f9558e97-cdeb-4f92-932d-8b5d2e972598.jpg?v=1778653256"
  },
  {
    "sku": "BE511ESPWH",
    "title": "Turboline II Exhaust Fan with CCT LED",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE511ESPWH_fbee811d-364e-4e5a-98be-79bd6a33212b.jpg?v=1778653261"
  },
  {
    "sku": "BE511ESPWH",
    "title": "Turboline II Exhaust Fan with CCT LED (Copy)",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BE511ESPWH_db7f0b12-ffd4-4d60-8766-296741b790c0.jpg?v=1778653265"
  },
  {
    "sku": "MXD6822BLK",
    "title": "Twin Head Cob Led Floodlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lumio-Twin-Head-Cob-Led-Floodlight-Mercator-8484_e3b17380-51e3-4dba-98a0-248bc2bab84f.jpg?v=1778653268"
  },
  {
    "sku": "MXD6822BLK-SEN",
    "title": "Twin Head Cob Led Floodlight with Sensor",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Lumio-Twin-Head-Cob-Led-Floodlight-with-Sensor-Mercator-7731_1f7907c3-736e-4936-b385-1fff2f5d1681.jpg?v=1778653272"
  },
  {
    "sku": "MTBL034NAT",
    "title": "Umina Rattan Cage Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Umina-Rattan-Cage-Table-Lamp-Mercator-4699_dd79ae1e-d0d3-4810-a769-5828b1cfa224.jpg?v=1778653277"
  },
  {
    "sku": "BH266ESWWH",
    "title": "Vader DC 4-in-1 Bathroom Heater with LED Indicator Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Mercator_Vader_BH266ESWWH_A4_Flyer.pdf?v=1779946529",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BH266ESWWH_1_2.webp?v=1781583657"
  },
  {
    "sku": "BH276ESPWH",
    "title": "Vader Ultra 7-In-1 Bathroom Heater with LED Indicator Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BH276ESPWH_Datasheet_9.pdf?v=1792733527",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/BH276ESPWH.png?v=1792733866"
  },
  {
    "sku": "MPLS017",
    "title": "Vaucluse 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vaucluse-1Lt-Pendant-Light-Mercator-277_763b7b07-545a-481b-957b-59ed9d50e0ba.jpg?v=1778653281"
  },
  {
    "sku": "MWL017",
    "title": "Vaucluse Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vaucluse-Wall-Light-Mercator-4268_be83e413-c10f-458e-85dd-264798afa90a.jpg?v=1778653285"
  },
  {
    "sku": "AUL1023BLK",
    "title": "Vector LED Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1023BLK_cab8bd21-d389-4941-b81a-98bb380fde44.jpg?v=1778653289"
  },
  {
    "sku": "A43431",
    "title": "Verona 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/A43431_3ae929d2-0df8-4fd3-974f-477eff8b8551.jpg?v=1778653292"
  },
  {
    "sku": "A43433",
    "title": "Verona 3Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Verona-3Lt-Pendant-Light-Mercator-467_5965767f-d82d-4926-bcec-14258954d249.jpg?v=1778653296"
  },
  {
    "sku": "9B22LED26",
    "title": "Vintage B22 Decorative Cylinder Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vintage-B22-Decorative-Cylinder-Globe-Mercator-4369_20cd2d00-1c26-45dc-b276-bf031a8b5b4d.jpg?v=1778653300"
  },
  {
    "sku": "9B22LED25",
    "title": "Vintage B22 Decorative Sphere Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vintage-B22-Decorative-Sphere-Globe-Mercator-5634_579a3c26-655e-4d9d-8a70-d1146b6fa695.jpg?v=1778653304"
  },
  {
    "sku": "9E27LED26",
    "title": "Vintage E27 Decorative Cylinder Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vintage-E27-Decorative-Cylinder-Globe-Mercator-3803_615ec3c5-7ba5-4be2-b185-918cd43eb10c.jpg?v=1778653308"
  },
  {
    "sku": "9E27LED25",
    "title": "Vintage E27 Decorative Sphere Globe",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vintage-E27-Decorative-Sphere-Globe-Mercator-2087_6b37eb0a-42d0-4206-9346-220901661563.jpg?v=1778653312"
  },
  {
    "sku": "MPLS002NAT-L",
    "title": "Vior 1Lt 30W Large LED Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vior-1Lt-30W-Large-LED-Pendant-Light-Mercator-1092_ef660256-a233-4084-8150-9048aa9ed22e.jpg?v=1778653316"
  },
  {
    "sku": "MPLS002NAT-S",
    "title": "Vior 1Lt 30W Small LED Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Vior-1Lt-30W-Small-LED-Pendant-Light-Mercator-8168_eeaa164d-4da3-4f94-bb3f-5a52a39a31e9.jpg?v=1778653320"
  },
  {
    "sku": "FRMDC99",
    "title": "Wall Controller for DC Mercator Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MicrosoftTeams-image_29_9d3d690b-38d3-4cd6-acbf-73027b3de801.png?v=1778653333"
  },
  {
    "sku": "SMD4109W",
    "title": "Walter 10W 90mm Iku Smart Wi-Fi CCT LED Downlight",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000010W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005446_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_e8610660-a112-40f3-a8d9-5c7330a136c6.jpg?v=1778653337"
  },
  {
    "sku": "SMD4109W-RGB",
    "title": "Walter 10W 90mm Iku Smart Wi-Fi RGB And CCT LED Downlight",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000010W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005446_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_d09204d2-8b45-4c41-a4a4-d8b355d0d540.jpg?v=1778653341"
  },
  {
    "sku": "SMD4106W",
    "title": "Walter 7W 70mm Iku Smart Wi-Fi CCT LED Downlight",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000010W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005446_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_7be0b3d4-1040-4b33-ab99-2e3457473623.jpg?v=1778653346"
  },
  {
    "sku": "SMD4106W-RGB",
    "title": "Walter 7W 70mm Iku Smart Wi-Fi RGB And CCT LED Downlight",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000010W_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005446_2_Pairing_Guide.pdf?v=1776661655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_26c0cdea-3e27-4155-82f8-403c1cc6a353.jpg?v=1778653351"
  },
  {
    "sku": "SMD4106W-ZB",
    "title": "Walter 7W 70mm Iku Smart Zigbee CCT LED Downlight",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000010Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005500_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_f7c391ce-88b2-42b9-8d36-aecb458f0e4d.jpg?v=1778653354"
  },
  {
    "sku": "SMD4106W-RGB-ZB",
    "title": "Walter 7W 70mm Iku Smart Zigbee RGB  And CCT LED Downlight",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000010Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005500_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_6e97f4a6-c14f-4c2e-8a79-024e7bdda00f.jpg?v=1778653359"
  },
  {
    "sku": "SMD4109W-ZB",
    "title": "Walter 9W 90mm Iku Smart Zigbee CCT LED Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_9597d2bb-cda4-41c0-b7c9-d2e6ef5c72ce.jpg?v=1778653363"
  },
  {
    "sku": "SMD4109W-RGB-ZB",
    "title": "Walter 9W 90mm Iku Smart Zigbee RGB And CCT LED Downlight",
    "product_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MIDS000010Z_Data_Sheet.pdf?v=1776661624",
    "pairing_spec": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MRIN005500_2_Pairing_Guide.pdf?v=1776661656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/SMD4106W_e9a443e0-f064-45e0-b5ee-9fc6e7d94c28.jpg?v=1778653366"
  },
  {
    "sku": "MI8215CCT",
    "title": "Wave II Tri-Proof Batten Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wave-II-Tri-Proof-Batten-Light-Mercator-529_a2d190c4-cdeb-4577-b4e8-330570bdbad3.jpg?v=1778653369"
  },
  {
    "sku": "MI8240TRI",
    "title": "Wave Pro 120cm 20W/40W dual power Tri-proof LED Batten light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wave-Pro-20W-40W-Dual-LED-Batten-Light-Mercator-3231_294d67bf-87de-461e-ae22-def891c05f3d.jpg?v=1778653373"
  },
  {
    "sku": "MI8242BAT-S",
    "title": "Wave Pro 120cm Tri-proof Sustained Emergency Lighting LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wave-Pro-120cm-Tri-proof-Sustained-Emergency-Lighting-LED-Batten-Mercator-6037_8d3c0ffd-077b-42a5-ac1c-9d932b562c9b.jpg?v=1778653376"
  },
  {
    "sku": "MI8260TRI",
    "title": "Wave Pro 150cm 30W/60W dual power Tri-proof LED Batten light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wave-Pro-30W-60W-Dual-LED-Batten-Light-Mercator-6644_63af2e15-9ace-4012-beb4-ec68a692ed3e.jpg?v=1778653379"
  },
  {
    "sku": "MI8240BAT",
    "title": "Wave Pro 40W Battery Backup Triproof LED Batten",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wave-Pro-with-Emergency-Batten-Light-Mercator-270_adbde8b0-334c-45dd-9370-36b8467a56b9.jpg?v=1778653384"
  },
  {
    "sku": "MI8220TRI",
    "title": "Wave Pro 60cm 10W/20W dual power Tri-proof LED Batten light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wave-Pro-10W-20W-Dual-LED-Batten-Light-Mercator-356_94ff0d2c-d131-414d-83f3-7d604a7a00be.jpg?v=1778653388"
  },
  {
    "sku": "MWL003BLK",
    "title": "Waverley Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Waverley-Wall-Light-Mercator-202_e5af389a-2adb-4418-90ab-aeed5e179ec6.jpg?v=1778653392"
  },
  {
    "sku": "MDIY001BLK",
    "title": "Webster DIY 20cm Batten Fix",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Webster-DIY-20cm-Metal-Shade-Mercator-6706_9dd34afe-f876-47b1-b9fd-4510bc091eb6.jpg?v=1778653397"
  },
  {
    "sku": "MDIY001WHT",
    "title": "Webster DIY 20cm Batten Fix",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Webster-DIY-20cm-Metal-Shade-Mercator-6706_9dd34afe-f876-47b1-b9fd-4510bc091eb6.jpg?v=1778653397"
  },
  {
    "sku": "MX9512BLK-CCT",
    "title": "Wells 12W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wells-12W-LED-Up-Down-Wall-Light-Mercator-1442_15906a02-06cb-4c4c-9614-b4c26d96744f.jpg?v=1778653402"
  },
  {
    "sku": "MX9512WHT-CCT",
    "title": "Wells 12W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wells-12W-LED-Up-Down-Wall-Light-Mercator-1442_15906a02-06cb-4c4c-9614-b4c26d96744f.jpg?v=1778653402"
  },
  {
    "sku": "MX9506WHT-CCT",
    "title": "Wells 8W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wells-6W-LED-Up-Down-Wall-Light-Mercator-7774_981f30a9-080a-41d7-b8bb-912d7a195fcf.jpg?v=1778653406"
  },
  {
    "sku": "MX9506BLK-CCT",
    "title": "Wells 8W LED Up/Down Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wells-6W-LED-Up-Down-Wall-Light-Mercator-7774_981f30a9-080a-41d7-b8bb-912d7a195fcf.jpg?v=1778653406"
  },
  {
    "sku": "MPLS022",
    "title": "Westlakes 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Westlakes-1Lt-Pendant-Light-Mercator-7871_f135e3f2-4ce4-401d-9b9d-4103be6dfc8e.jpg?v=1778653411"
  },
  {
    "sku": "MG2621WHT",
    "title": "Willow 1Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Willow-1Lt-Pendant-Light-Mercator-9858_22caae68-20a1-4d10-ab6f-c9c2f1427e37.jpg?v=1778653414"
  },
  {
    "sku": "MG2624WHT",
    "title": "Willow 4Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Willow-4Lt-Pendant-Light-Mercator-1165_5e7bf0e6-2c10-4802-9c9c-8485d19f3783.jpg?v=1778653418"
  },
  {
    "sku": "MWL009BRS",
    "title": "Wilshire Wall Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wilshire-Wall-Lamp-Mercator-5914_8a08e22e-36b6-46bb-ae01-631b605f7ce6.jpg?v=1778653423"
  },
  {
    "sku": "MWL009BLK",
    "title": "Wilshire Wall Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wilshire-Wall-Lamp-Mercator-5914_8a08e22e-36b6-46bb-ae01-631b605f7ce6.jpg?v=1778653423"
  },
  {
    "sku": "MTBL001-L",
    "title": "Winnie Large Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Winnie-Large-Table-Lamp-Mercator-9646_c7fcce6b-a8ec-4c7d-9543-c2776749dc78.jpg?v=1778653427"
  },
  {
    "sku": "MTBL001-S",
    "title": "Winnie Small Table Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Winnie-Small-Table-Lamp-Mercator-8671_6d9c94ff-1bb9-4df5-9242-726c71fbc215.jpg?v=1778653437"
  },
  {
    "sku": "MDIY002BLK",
    "title": "Winslow DIY 25cm Batten Fix",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Winslow-DIY-25cm-Metal-Shade-Mercator-9909_c2157694-f037-4c53-92d5-f04b1e601fa0.jpg?v=1778653441"
  },
  {
    "sku": "MDC146",
    "title": "Wireless Door Chime Battery Operated",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wireless-Door-Chime-Battery-Operated-Mercator-8511_f0e56a67-7f76-4612-8133-7aa207537acb.jpg?v=1778653445"
  },
  {
    "sku": "MDC650",
    "title": "Wireless with Power Socket Door Chime Kit",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MDC650_6d94ddc7-8316-4ea8-82a5-3145c8fe2c36.jpg?v=1778653448"
  },
  {
    "sku": "XFC8283",
    "title": "Wiring Loom 600mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/XFC8283_7ab27024-1c60-4743-a25c-a360e970c358.jpg?v=1778653451"
  },
  {
    "sku": "XFC8284",
    "title": "Wiring Loom 900mm for Ceiling Fans",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/XFC8284_1a038d5a-2ad4-4e98-ad0c-bac28fe04e6c.jpg?v=1778653455"
  },
  {
    "sku": "XFC6403",
    "title": "WIRING LOOM ONLY 600MM CAPRICE",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XFC3603",
    "title": "WIRING LOOM ONLY 600MM EAGLE",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XFC7003",
    "title": "WIRING LOOM ONLY 600mm NEMOI",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XFC8583",
    "title": "WIRING LOOM ONLY 600MM SAMOS",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XFC6404",
    "title": "WIRING LOOM ONLY 900MM CAPRICE",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XFC3604",
    "title": "WIRING LOOM ONLY 900MM EAGLE",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "XFC7004",
    "title": "WIRING LOOM ONLY 900mm NEMOI",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "MTFL005",
    "title": "Wyatt  Floor Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Wyatt-Floor-Lamp-Mercator-213_37e384a2-def0-4fee-a7d2-34b6686b7562.jpg?v=1778653459"
  },
  {
    "sku": "HT00101CH",
    "title": "Yarra 1 Bar Heated Towel Rail",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Yarra-1-Bar-Heated-Towel-Rail-Mercator-40920854_c606db71-7e9b-4b43-af3f-7ac84c248438.jpg?v=1778653462"
  },
  {
    "sku": "MX7391P-BLK",
    "title": "Yarra Outdoor Lamp Post Coach Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Yarra-Outdoor-Lamp-Post-Coach-Light-Mercator-4151_a833fadc-d278-4d2a-bbe4-cb14cf0c3480.jpg?v=1778653466"
  },
  {
    "sku": "MX7391BLK",
    "title": "Yarra Outdoor Post Top Coach Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Yarra-Outdoor-Post-Top-Coach-Light-Mercator-9009_f585cd97-812b-479e-960e-576d23089a3c.jpg?v=1778653471"
  },
  {
    "sku": "MG7033BLK",
    "title": "York 3Lt Lantern-Style Pendant",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/York-3Lt-Lantern-Style-Pendant-Mercator-725_f7843e59-5269-457b-a6ad-8b90d857d793.jpg?v=1778653475"
  },
  {
    "sku": "AUL1118",
    "title": "Zane Wireless Charging Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1118WHT_30bcf02b-1036-42b9-ba2c-1ee6102b3e55.jpg?v=1778653480"
  },
  {
    "sku": "AUL1118BLK",
    "title": "Zane Wireless Charging Task Lamp",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/AUL1118WHT_30bcf02b-1036-42b9-ba2c-1ee6102b3e55.jpg?v=1778653480"
  },
  {
    "sku": "MG7136",
    "title": "Zappa 6Lt Pendant Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Zappa-6Lt-Pendant-Light-Mercator-9915_117de1d2-fbde-466c-bb7e-8eae42b5815f.jpg?v=1778653483"
  },
  {
    "sku": "MD350W-TRI",
    "title": "Zeke 7W Tri-Colour LED Flush Lens Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Zeke-7W-Tri-Colour-LED-Flush-Lens-Downlight-Mercator-9906_deb4135d-07aa-460f-a770-0c488fee4af1.jpg?v=1778653487"
  },
  {
    "sku": "MD355W-TRI",
    "title": "Zeke 9W Tri-Colour LED Flush Lens Downlight",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Zeke-9W-Tri-Colour-LED-Flush-Lens-Downlight-Mercator-4736_30d2b94b-5177-4a9c-a46c-984c69c4ac89.jpg?v=1778653491"
  },
  {
    "sku": "MD933012",
    "title": "Zilla 36W Backlit Tri-colour High Efficacy LED Panel Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Zilla-36W-Backlit-Tri-colour-High-Efficacy-LED-Panel-Light-Mercator-8075_38e106fd-5188-49e0-9833-d81107dabdf9.jpg?v=1778653495"
  },
  {
    "sku": "MD9536TRI",
    "title": "Zilla 36W Backlit Tri-colour LED Panel Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Zilla-36W-Backlit-Tri-colour-LED-Panel-Light-Mercator-8976_cb70b0e2-3f9c-478d-84eb-c82ccea04c60.jpg?v=1778653499"
  },
  {
    "sku": "MD953012S",
    "title": "Zilla 36W Sidelit Tri-colour LED Panel Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Zilla-36W-Sidelit-Tri-colour-LED-Panel-Light-Mercator-5903_93a85880-5b05-4115-a5e1-12e55d949a18.jpg?v=1778653503"
  },
  {
    "sku": "MXB1010CCT",
    "title": "Zion II-12W LED Bulkhead CCT Outdoor Wall Light",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/MXB1010_6e7efe24-977e-40cc-b356-b4cb2095d3ff.jpg?v=1778653506"
  },
  {
    "sku": "MD913012-5",
    "title": "Zip 40W Rectangular LED Panel",
    "product_spec": "",
    "pairing_spec": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0749/5653/8130/files/Zip-40W-Rectangular-LED-Panel-Mercator-3508_ab226038-3e91-4b95-92f5-a7a00e649a30.jpg?v=1778653511"
  }
];